import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import * as JSFUNC from "../../Library/JSFUNC.js";
import * as LibraryReact from "../../Library/LibraryReact.js";
import * as CEGeneralReact from "../../CaptureExecGeneral/CEGeneralReact.js";
import * as CEComplexReact from "../../CaptureExecGeneral/CEComplexReact.js";
import * as CEIconsReact from '../../CaptureExecGeneral/CEIconsReact.js';
import * as TeammateRatingsReact from '../OpenCapture/TeammateRatingsReact.js';

//-----------------------------------------------------------------------------------------------
//External facing components to run and edit the Contacts System
//-----------------------------------------------------------------------------------------------
export const ContactsTabWithNoSelection = inject("ContactsMobx")(observer(
class ContactsTabWithNoSelection extends Component { //props:
  render() {
    return(
      <ContactsSystem
        p_selectMode="no_select"
      />
    );
  }
}));




export const SelectOrSelectMultiContactsFloatingBox = inject("ContactsMobx")(observer(
class SelectOrSelectMultiContactsFloatingBox extends Component { //props: p_selectMode, p_selectedContactIDOrContactIDsComma, p_contactIDsAlreadyAddedArray, p_title, p_openContactIsPersonTF, p_openContactID, p_initialZoomedCompanyID, p_initialZoomedPersonID, f_onSaveChanged, f_onCancel
  //p_selectMode                            "select_contact_person", "selectmulti_contact_persons", "select_contact_company", "selectmulti_contact_companies", "no_select"
  //p_selectedContactIDOrContactIDsComma    (essentially "valueRaw") the contact or contacts that are selected
  //p_contactIDsAlreadyAddedArray           contacts that had already been added to whatever subsystem this is serving, these contacts will show up gray and cannot be added to the selection
  //p_title                                 the title to display on the floating box
  //p_openContactIsPersonTF                 can supply these 2 inputs together to initialize the contacts system with a contact already opened on the right side
  //p_openContactID
  //p_initialZoomedCompanyID                (optional) provide to zoom in the left side tree on one org with all divisions expanded
  //p_initialZoomedPersonID                 (optional) provide to zoom in the left side tree on one org containing this contact person

  constructor(props) {
    super(props);
    
    const p_selectMode = this.props.p_selectMode;
    const p_selectedContactIDOrContactIDsComma = this.props.p_selectedContactIDOrContactIDsComma;
    const p_openContactIsPersonTF = this.props.p_openContactIsPersonTF;
    const p_initialZoomedCompanyID = this.props.p_initialZoomedCompanyID;
    const p_initialZoomedPersonID = this.props.p_initialZoomedPersonID;

    this.props.ContactsMobx.a_initialize_contacts_system();
    this.props.ContactsMobx.a_initialize_initial_and_current_selected_contact_ids_arrays(p_selectMode, p_selectedContactIDOrContactIDsComma);

    const [isSelectingPersonsTFU] = this.props.ContactsMobx.is_person_and_is_multiselect_tfu_from_select_mode(p_selectMode);
    const isPersonTF = ((p_openContactIsPersonTF !== undefined) ? (p_openContactIsPersonTF) : (isSelectingPersonsTFU));
    if(isPersonTF !== undefined) {
      this.props.ContactsMobx.a_set_contacts_browser_selected_tab_db_name((isPersonTF) ? ("persons") : ("companies"));
    }

    //if the input p_initialZoomedCompanyID is provided, set the filter to only show that company fully expanded
    if(p_initialZoomedCompanyID !== undefined) {
      this.props.ContactsMobx.a_set_left_side_zoomed_org_id_from_company_id(p_initialZoomedCompanyID);
    }
    else if(p_initialZoomedPersonID !== undefined) {
      this.props.ContactsMobx.a_set_left_side_zoomed_org_id_from_person_id(p_initialZoomedPersonID);
    }
  }

  onclick_floating_box_save_selected_contacts = () => {
    const p_selectMode = this.props.p_selectMode;
    const f_onSaveChanged = this.props.f_onSaveChanged;
    const f_onCancel = this.props.f_onCancel;

    const outputSelectedContactIDOrContactIDsComma = this.props.ContactsMobx.get_changed_output_selected_value_or_unchanged_undefined(p_selectMode);
    if(outputSelectedContactIDOrContactIDsComma !== undefined) { //the current output has been changed from the initial input value, call the external save function
      if(JSFUNC.is_function(f_onSaveChanged)) {
        f_onSaveChanged(outputSelectedContactIDOrContactIDsComma);
      }
    }
    else { //if the current output is the same as the original input, call a cancel operation
      if(JSFUNC.is_function(f_onCancel)) {
        f_onCancel();
      }
    }
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_selectedContactIDOrContactIDsComma = this.props.p_selectedContactIDOrContactIDsComma;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;
    const p_title = this.props.p_title;
    const p_openContactIsPersonTF = this.props.p_openContactIsPersonTF;
    const p_openContactID = this.props.p_openContactID;
    const p_initialZoomedCompanyID = this.props.p_initialZoomedCompanyID;
    const p_initialZoomedPersonID = this.props.p_initialZoomedPersonID;
    const f_onSaveChanged = this.props.f_onSaveChanged;
    const f_onCancel = this.props.f_onCancel;

    const o_currentSelectedContactIDsArray = this.props.ContactsMobx.o_currentSelectedContactIDsArray;

    const [isSelectingPersonsTFU, isMultiSelectTFU] = this.props.ContactsMobx.is_person_and_is_multiselect_tfu_from_select_mode(p_selectMode);
    const personCompanyLabel = this.props.ContactsMobx.person_or_company_string_from_is_person_and_is_multi_tf(isSelectingPersonsTFU, isMultiSelectTFU); //Person/Persons/Company/Companies

    var title = p_title;
    if(title === undefined) {
      title = "Select Contact " + personCompanyLabel;
    }

    var selectedContactsArrayOfObjs = [];
    for(let contactID of o_currentSelectedContactIDsArray) {
      var contactObj = this.props.ContactsMobx.contact_company_or_person_obj_from_id(isSelectingPersonsTFU, contactID);
      selectedContactsArrayOfObjs.push(contactObj);
    }

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="contactsSystemSelect"
        p_title={title}
        p_bgColorClass="contactsSelectionFloatingSurface"
        p_shadowColor="62777a"
        f_onClickSave={((f_onSaveChanged && f_onCancel) ? (this.onclick_floating_box_save_selected_contacts) : (undefined))}
        f_onClickCancel={f_onCancel}>
        <div className="flex11a displayFlexColumn">
          {(isMultiSelectTFU !== undefined) &&
            <div className="flex00a" style={{padding:"0.55em 0.75em", background:"linear-gradient(135deg, #eaf2f2, #e2eded)", borderBottom:"1px solid #cbdadb", boxShadow:"0 0.1em 0.35em rgba(45, 70, 74, 0.08)"}}>
              <div className="displayFlexRowVc flexWrap smallFullPad" style={{gap:"0.15em 0.3em", padding:0}}>
                <div className="flex00a displayFlexRowVc" style={{minHeight:"2.3em", marginRight:"0.5em", padding:"0 0.7em 0 0.2em", borderRight:"1px solid #cbdadb"}}>
                  <font className="font13 fontBold" style={{color:"#38565b", fontSize:"0.9em", fontWeight:700, whiteSpace:"nowrap"}}>
                    {"Contact " + personCompanyLabel + " Selected" + ((isMultiSelectTFU) ? (" (" + o_currentSelectedContactIDsArray.length + ")") : ("")) + ":"}
                  </font>
                </div>
                {selectedContactsArrayOfObjs.map((m_contactObj) =>
                  <ContactsFloatingBoxSelectedContactsBubbleList
                    key={m_contactObj.id}
                    p_contactObj={m_contactObj}
                  />
                )}
              </div>
            </div>
          }
          <ContactsSystem
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
            p_openContactIsPersonTF={p_openContactIsPersonTF}
            p_openContactID={p_openContactID}
          />
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));

const ContactsFloatingBoxSelectedContactsBubbleList = inject("ContactsMobx")(observer(
class ContactsFloatingBoxSelectedContactsBubbleList extends Component { //props: p_contactObj
  onclick_selected_contact_bubble_open_contact_on_right_side = () => {
    const p_contactObj = this.props.p_contactObj;
    this.props.ContactsMobx.a_open_contact(p_contactObj.isPersonTF, p_contactObj.id); //onclick bubble open contact for view/edit on right side of contact system
  }

  onclick_remove_contact_from_selection = () => {
    const p_contactObj = this.props.p_contactObj;
    this.props.ContactsMobx.a_remove_contact_from_selection(p_contactObj.id);
  }

  render() {
    const p_contactObj = this.props.p_contactObj;

    const contactName = this.props.ContactsMobx.contact_name_plaintext_from_contact_obj(p_contactObj);

    return(
      <div className="flex00a lrMargin microTopMargin microBottomMargin" style={{flexBasis:"20em", minWidth:0}}>
        <LibraryReact.InteractiveDiv
          p_class="positionRelative displayFlexRowVc lrPad microTopPad microBottomPad contactsSelectedContactBubble cursorPointer"
          f_onClick={this.onclick_selected_contact_bubble_open_contact_on_right_side}>
          <div className="flex00a smallRightMargin">
            <CompanyOrPersonIcon p_isPersonTF={p_contactObj.isPersonTF} p_sizeEm={1.25} />
          </div>
          <div className="flex11a">
            <LibraryReact.NowrapEllipsis>
              {contactName}
              {(p_contactObj.isPersonTF) &&
                <font className="fontItalic fontTextLighter">{" | " + p_contactObj.title}</font>
              }
            </LibraryReact.NowrapEllipsis>
          </div>
          <CEGeneralReact.RemoveItemXWithRedHover
            p_title={"Remove '" + contactName + "' as a selected Contact"}
            f_onClick={this.onclick_remove_contact_from_selection}
          />
        </LibraryReact.InteractiveDiv>
      </div>
    );
  }
}));



export const ContactBubble = inject("ContactsMobx", "DatabaseMobx")(observer(
class ContactBubble extends Component { //props: p_isPersonTF, p_contactID, p_iconSizeEm, p_fontClass, p_personMarkInvalidEmailTF, f_onClickRemove
  //used as the display for the name of a teammate or competitor so that it is interactive and quickly opens the contact system (and cannot be changed, the entire teammate would have to be deleted to change which contact this one is pointing to)
  //clicking on a contact bubble by default opens the contact system for that particular contact in a floating box
  constructor(props) {
    super(props);
    this.state = {
      s_hoverOpenTF: false,
      s_floatingContactBoxOpenTF: false
    };

    this.iconContainerElementRef = React.createRef();
  }

  onhover_bubble = (i_hoverTF) => {
    this.setState({s_hoverOpenTF:i_hoverTF});
  }

  onclick_bubble = () => {
    this.setState({s_floatingContactBoxOpenTF:true});
  }

  onclose_contacts_floating_box = () => {
    this.setState({s_floatingContactBoxOpenTF:false});
  }

  onclick_remove_x = () => {
    if(JSFUNC.is_function(this.props.f_onClickRemove)) {
      this.props.f_onClickRemove(this.props.p_contactID);
    }
  }

  render() {
    const s_hoverOpenTF = this.state.s_hoverOpenTF;
    const s_floatingContactBoxOpenTF = this.state.s_floatingContactBoxOpenTF;

    const p_isPersonTF = this.props.p_isPersonTF;
    const p_contactID = this.props.p_contactID;
    const p_iconSizeEm = JSFUNC.prop_value(this.props.p_iconSizeEm, 1.25);
    const p_fontClass = JSFUNC.prop_value(this.props.p_fontClass, "");
    const p_personMarkInvalidEmailTF = JSFUNC.prop_value(this.props.p_personMarkInvalidEmailTF, false);

    const contactObj = this.props.ContactsMobx.contact_company_or_person_obj_from_id(p_isPersonTF, p_contactID);
    const contactName = this.props.ContactsMobx.contact_name_plaintext_from_contact_obj(contactObj);
    const contactPersonEmail = this.props.ContactsMobx.contact_person_email_from_contact_person_obj(contactObj);

    //hover box calculations
    var contactInfoHoverBoxComponent = null;
    if(s_hoverOpenTF) {
      var fieldsArrayOfObjs = [];
      if(contactObj.isPersonTF) { //person info fields
        fieldsArrayOfObjs = [
          {id:-1, display_name:"Name", valueMask:contactObj.fullName},
          {id:-2, display_name:"Company", valueMask:contactObj.parentCompanyAbbrOrLegalName},
          {id:-3, display_name:"Title", valueMask:contactObj.title},
          {id:-4, display_name:"Email", valueMask:contactObj.email},
          {id:-5, display_name:"Phone", valueMask:contactObj.phone}
        ];
        for(let extraFieldObj of this.props.DatabaseMobx.c_contactsPersonsExtraFieldsArrayOfObjs) {
          fieldsArrayOfObjs.push({id:extraFieldObj.id, display_name:extraFieldObj.display_name, valueMask:contactObj[extraFieldObj.db_name]});
        }
      }
      else { //company info fields
        fieldsArrayOfObjs = [{id:-1, display_name:"Name", valueMask:contactObj.abbrOrLegalName}];
        if(JSFUNC.text_or_number_is_filled_out_tf(contactObj.organizationAbbrOrLegalName) && (contactObj.abbrOrLegalName !== contactObj.organizationAbbrOrLegalName)) {
          fieldsArrayOfObjs.push({id:-2, display_name:"Organization", valueMask:contactObj.organizationAbbrOrLegalName});
        }
        fieldsArrayOfObjs.push({id:-3, display_name:"Business Type", valueMask:this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(contactObj.business_type_id, this.props.DatabaseMobx.c_selectBusinessTypeFieldTypeObj)});
        fieldsArrayOfObjs.push({id:-4, display_name:"Small Business Certification(s)", valueMask:this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(contactObj.sb_certifications_bm_set_aside_ids_comma, this.props.DatabaseMobx.c_selectMultiBitMasterSetAsidesFieldTypeObj)});
        fieldsArrayOfObjs.push({id:-5, display_name:"Capabilities", valueMask:this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(contactObj.capability_ids_comma, this.props.DatabaseMobx.c_selectMultiCapabilitiesFieldTypeObj)});
        fieldsArrayOfObjs.push({id:-6, display_name:"NAICS Code(s)", valueMask:this.props.DatabaseMobx.value_mask_plaintext_from_value_raw_and_field_type_obj(contactObj.naics_code_ids_comma, this.props.DatabaseMobx.c_selectMultiBitMasterNaicsCodesCombinedNamesFieldTypeObj)});
      }

      //compute correct positioning of hover box relative to proximity to client window edges
      var hoverBoxTop = ((p_iconSizeEm / 1.18) + 0.7) + "em";
      var hoverBoxBottom = undefined;
      const iconContainerElementRefCurrentOrNull = this.iconContainerElementRef.current;
      if(iconContainerElementRefCurrentOrNull !== null) {
        const iconContainerClientRectObj = iconContainerElementRefCurrentOrNull.getBoundingClientRect();
        const windowHeightPx = window.innerHeight;
        const iconHeightFromTopPx = iconContainerClientRectObj.y;
        if(iconHeightFromTopPx > (windowHeightPx * 0.66)) { //more than 2/3 way down the screen
          hoverBoxTop = undefined;
          hoverBoxBottom = ((p_iconSizeEm / 1.18) + 0.9) + "em";
        }
      }

      contactInfoHoverBoxComponent = (
        <div
          className="positionAbsolute displayFlexColumn microTopMargin lrMedPad smallTopPad smallBottomPad"
          style={{zIndex:"8888", top:hoverBoxTop, bottom:hoverBoxBottom, width:"30em", color:"#34494e", background:"#fff", border:"1px solid #cbd9da", borderRadius:"0.65em", boxShadow:"0 0.4em 1.1em rgba(32, 56, 60, 0.22)"}}>
          {fieldsArrayOfObjs.map((m_fieldObj, m_index) =>
            <div key={m_fieldObj.id} className="displayFlexRow tbMicroPad" style={{borderBottom:((m_index === fieldsArrayOfObjs.length - 1) ? ("0") : ("1px solid #edf1f1"))}}>
              <div className="flex00a" style={{flexBasis:"10em"}}>
                <font style={{color:"#476a70", fontStyle:"normal", fontWeight:600}}>
                  {m_fieldObj.display_name + ":"}
                </font>
              </div>
              <div className="flex11a">
                <font className="">
                  {m_fieldObj.valueMask}
                </font>
              </div>
            </div>
          )}
        </div>
      );
    }

    const contactBubbleComponent = (
      <>
        <LibraryReact.InteractiveDiv
          p_class="positionRelative displayFlexRowVc lrPad microTopPad microBottomPad contactsEntityBubble cursorPointer"
          p_styleObj={{minWidth:0, color:"#34494e", background:"#fbfdfd", border:"1px solid #cbd9da", borderRadius:"0.55em", boxShadow:"0 0.08em 0.3em rgba(39, 65, 69, 0.1)", transition:"background 120ms ease, border-color 120ms ease, box-shadow 120ms ease, transform 120ms ease"}}
          f_onClick={this.onclick_bubble}
          f_onHover={this.onhover_bubble}>
          <div ref={this.iconContainerElementRef} className="flex00a smallRightMargin">
            <CompanyOrPersonIcon p_isPersonTF={p_isPersonTF} p_sizeEm={p_iconSizeEm} />
          </div>
          <div className="flex11a" style={{flexBasis:"150em"}}>
            <LibraryReact.NowrapEllipsis p_fontClass={p_fontClass}>
              {contactName}
              {(p_isPersonTF && JSFUNC.text_or_number_is_filled_out_tf(contactObj.title)) &&
                <font className="fontItalic fontTextLighter">{" | " + contactObj.title}</font>
              }
            </LibraryReact.NowrapEllipsis>
          </div>
          {(p_personMarkInvalidEmailTF) &&
            <div className="flex11a" style={{flexBasis:"100em"}}>
              <LibraryReact.NowrapEllipsis p_fontClass={p_fontClass + " fontTextLighter"}>
                {contactPersonEmail}
              </LibraryReact.NowrapEllipsis>
            </div>
          }
          {(JSFUNC.is_function(this.props.f_onClickRemove)) &&
            <CEGeneralReact.RemoveItemXWithRedHover
              p_tabIndex={-1}
              p_title={undefined}
              f_onClick={this.onclick_remove_x}
            />
          }
          {contactInfoHoverBoxComponent}
        </LibraryReact.InteractiveDiv>
        {(s_floatingContactBoxOpenTF) &&
          <SelectOrSelectMultiContactsFloatingBox
            p_selectMode="noSelect"
            p_title={"Contact Details for '" + contactName + "'"}
            p_openContactIsPersonTF={p_isPersonTF}
            p_openContactID={p_contactID}
            p_initialZoomedCompanyID={((p_isPersonTF) ? (undefined) : (p_contactID))}
            p_initialZoomedPersonID={((p_isPersonTF) ? (p_contactID) : (undefined))}
            f_onCancel={this.onclose_contacts_floating_box}
          />
        }
      </>
    );

    if(p_personMarkInvalidEmailTF) {
      const contactPersonEmailErrorMessage = JSFUNC.valid_email_address_undefined_or_invalid_email_error_message_string(contactPersonEmail);
      if(contactPersonEmailErrorMessage !== undefined) {
        return(
          <div className="border borderColorRed" style={{borderWidth:"2px"}}>
            {contactBubbleComponent}
            <div className="tbMicroPad lrPad">
              <CEGeneralReact.ErrorText p_text={contactPersonEmailErrorMessage} />
            </div>
          </div>
        );
      }
    }

    return(contactBubbleComponent);
  }
}));



export const MultiAddContactBubblesVerticalList = inject("DatabaseMobx")(observer(
class MultiAddContactBubblesVerticalList extends Component { //props: p_canEditTF, p_isPersonTF, p_addedContactIDsComma, p_addButtonType, p_addButtonText, p_addInstructions, p_tabIndex, p_errorIfEmptyTF, p_personMarkInvalidEmailTF, p_initialZoomedCompanyID, f_onAddContacts, f_onRemoveContact, f_onChange
  //have a choice of using f_onAddContacts/f_onRemoveContact together independently, or using f_onChange which combines both add and remove and returns the new updated comma list of contactIDs
  onadd_selected_contacts = (i_newContactIDsToAddComma) => {
    if(JSFUNC.is_function(this.props.f_onAddContacts)) {
      this.props.f_onAddContacts(i_newContactIDsToAddComma);
    }

    if(JSFUNC.is_function(this.props.f_onChange)) {
      const updatedContactPersonIDsComma = JSFUNC.add_value_to_comma_list(i_newContactIDsToAddComma, this.props.p_addedContactIDsComma);
      this.props.f_onChange(updatedContactPersonIDsComma);
    }
  }

  onremove_single_contact = (i_contactIDToRemove) => {
    if(JSFUNC.is_function(this.props.f_onRemoveContact)) {
      this.props.f_onRemoveContact(i_contactIDToRemove);
    }

    if(JSFUNC.is_function(this.props.f_onChange)) {
      const updatedContactPersonIDsComma = JSFUNC.remove_all_int_values_from_int_comma_list(i_contactIDToRemove, this.props.p_addedContactIDsComma);
      this.props.f_onChange(updatedContactPersonIDsComma);
    }
  }

  render() {
    const p_canEditTF = JSFUNC.prop_value(this.props.p_canEditTF, true);
    const p_isPersonTF = this.props.p_isPersonTF;
    const p_addedContactIDsComma = this.props.p_addedContactIDsComma;
    const p_addButtonType = this.props.p_addButtonType;
    const p_addButtonText = this.props.p_addButtonText;
    const p_addInstructions = this.props.p_addInstructions;
    const p_tabIndex = this.props.p_tabIndex;
    const p_errorIfEmptyTF = this.props.p_errorIfEmptyTF;
    const p_personMarkInvalidEmailTF = this.props.p_personMarkInvalidEmailTF;
    const p_initialZoomedCompanyID = this.props.p_initialZoomedCompanyID;

    const addedContactIDsArray = JSFUNC.convert_comma_list_to_int_array(p_addedContactIDsComma);
    const numAddedContacts = addedContactIDsArray.length;
    const fieldTypeObj = ((p_isPersonTF) ? (this.props.DatabaseMobx.c_selectMultiContactPersonsFieldTypeObj) : (this.props.DatabaseMobx.c_selectMultiContactCompaniesFieldTypeObj));

    return(
      <>
        {(p_canEditTF) &&
          <>
            <CEGeneralReact.CaptureExecFieldAddNewItemsButton
              p_buttonType={p_addButtonType}
              p_buttonText={p_addButtonText}
              p_addInstructions={p_addInstructions}
              p_fieldTypeObj={fieldTypeObj}
              p_valuesToNotIncludeArray={addedContactIDsArray}
              p_contactsZoomedCompanyID={p_initialZoomedCompanyID}
              p_tabIndex={p_tabIndex}
              f_onAddSelectedItems={this.onadd_selected_contacts}
            />
            <div className="smallBottomMargin" />
          </>
        }
        {(numAddedContacts > 0) ? (
          addedContactIDsArray.map((m_contactID) =>
            <MultiAddContactBubbleVertical
              key={m_contactID}
              p_canEditTF={p_canEditTF}
              p_isPersonTF={p_isPersonTF}
              p_contactID={m_contactID}
              p_personMarkInvalidEmailTF={p_personMarkInvalidEmailTF}
              f_onRemoveContact={this.onremove_single_contact}
            />
          )
        ) : (
          <div className={"textCenter " + ((p_errorIfEmptyTF) ? ("border2 borderColorRed") : (""))}>
            <font className="fontItalic fontTextLighter">
              {"--No Contact " + ((p_isPersonTF) ? ("Persons") : ("Companies")) + " added yet--"}
            </font>
          </div>
        )}
      </>
    );
  }
}));

class MultiAddContactBubbleVertical extends Component { //props: p_canEditTF, p_isPersonTF, p_contactID, p_personMarkInvalidEmailTF, f_onRemoveContact
  onremove_contact = () => {
    if(JSFUNC.is_function(this.props.f_onRemoveContact)) {
      this.props.f_onRemoveContact(this.props.p_contactID);
    }
  }

  render() {
    const p_canEditTF = this.props.p_canEditTF;

    return(
      <div className="tbMicroMargin">
        <ContactBubble
          p_isPersonTF={this.props.p_isPersonTF}
          p_contactID={this.props.p_contactID}
          p_personMarkInvalidEmailTF={this.props.p_personMarkInvalidEmailTF}
          f_onClickRemove={((p_canEditTF) ? (this.onremove_contact) : (undefined))}
        />
      </div>
    );
  }
}





export const CompanyOrPersonIcon = inject("UserMobx")(observer(
class CompanyOrPersonIcon extends Component { //props: p_isPersonTF, p_sizeEm
  render() {
    const contactIconColor = "52606d";
    const sizePx = Math.round(this.props.UserMobx.c_userFontSizePx * this.props.p_sizeEm);
    if(this.props.p_isPersonTF) {
      return(<CEIconsReact.SvgPerson p_sizePx={sizePx} p_color={contactIconColor} />);
    }
    return(<CEIconsReact.SvgCompany p_sizePx={sizePx} p_color={contactIconColor} />);
  }
}));







//-----------------------------------------------------------------------------------------------
//Contacts System
//-----------------------------------------------------------------------------------------------
const ContactsSystem = inject("CaptureExecMobx", "ContactsMobx")(observer(
class ContactsSystem extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray, p_openContactIsPersonTF, p_openContactID

  // This is the main Contacts System where all contacts can be searched, created, edited, and deleted. It is used:
  //    1. when the "Contacts" tab is opened from the left nav (p_selectMode is "no_select", adding/editing/deleting is possible, no selection function)
  //    2. when selecting 1 or more persons or companies for some other subsystem using SelectOrSelectMultiContactsFloatingBox which presents this inside the floating box with selection
  // p_selectMode: "select_contact_person", "selectmulti_contact_persons", "select_contact_company", "selectmulti_contact_companies", "no_select"
  // p_contactIDsAlreadyAddedArray: contactIDs that are not available for selection
  // p_openContactIsPersonTF/p_openContactID: can supply these 2 inputs together to initialize the contacts system with a contact already opened on the right side

  componentDidMount() {
    if((this.props.p_openContactIsPersonTF !== undefined) && (this.props.p_openContactID !== undefined)) {
      this.props.ContactsMobx.a_open_contact(this.props.p_openContactIsPersonTF, this.props.p_openContactID);
    }
  }

  render() {
    const p_selectMode = JSFUNC.prop_value(this.props.p_selectMode, "no_select");
    const p_contactIDsAlreadyAddedArray = JSFUNC.prop_value(this.props.p_contactIDsAlreadyAddedArray, []);

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const o_leftSideMode = this.props.ContactsMobx.o_leftSideState;
    const o_rightSideState = this.props.ContactsMobx.o_rightSideState;
    const narrowDesktopTF = (o_mediaQueryFlag === 3);
    const leftSideFlexStyleObj = ((narrowDesktopTF) ? ({flex:"0 0 35em"}) : ({flex:"2 1 0"}));
    const rightSideFlexStyleObj = ((narrowDesktopTF) ? ({flex:"1 1 0"}) : ({flex:"3 1 0"}));

    const leftSideTreeComponent = (
      <ContactsSystemLeftTree
        p_selectMode={p_selectMode}
        p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
      />
    );

    const rightSideSingleContactComponent = (
      <ContactsSystemRightSingleContact
        p_selectMode={p_selectMode}
        p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
      />
    );

    //for mobile, determine which single screen to show based on the left/right states
    if(c_isMobileOrTabletTF) {
      if((o_rightSideState === "empty") || (o_leftSideMode === "selectParentDivision")) {
        return(leftSideTreeComponent);
      }
      return(rightSideSingleContactComponent);
    }

    //for larger screens, always show both left and right sides regardless of their states
    return(
      <div className="flex11a displayFlexRow" style={{padding:"0.65em", gap:"0.65em", background:"#e9e6df"}}>
        <div className="flex11a displayFlexColumn overflowHidden" style={{...leftSideFlexStyleObj, minWidth:0, background:"#fbfaf7", border:"1px solid #d8d3c8", borderRadius:"0.8em", boxShadow:"0 0.2em 0.8em rgba(35, 45, 55, 0.08)"}}>
          {leftSideTreeComponent}
        </div>
        <div className="flex11a displayFlexColumn overflowHidden" style={{...rightSideFlexStyleObj, minWidth:0, background:"#fbfaf7", border:"1px solid #d8d3c8", borderRadius:"0.8em", boxShadow:"0 0.2em 0.8em rgba(35, 45, 55, 0.08)"}}>
          {rightSideSingleContactComponent}
        </div>
      </div>
    );
  }
}));



const ContactsSystemLeftTree = inject("CaptureExecMobx", "ContactsMobx", "DatabaseMobx", "UserMobx")(observer(
class ContactsSystemLeftTree extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray
  onclick_create_new_contact_company = () => {
    this.props.ContactsMobx.a_initialize_new_contact(false); //initialize a new contact company (p_isPersonTF is false)
    this.props.ContactsMobx.a_set_right_side_state("createNewContact");
  }

  onclick_create_new_contact_person = () => {
    this.props.ContactsMobx.a_initialize_new_contact(true); //initialize a new contact person (p_isPersonTF is true)
    this.props.ContactsMobx.a_set_right_side_state("createNewContact");
  }

  onchange_search_contacts = (i_changedValue) => {
    this.props.ContactsMobx.a_set_search_text(i_changedValue);
  }

  onselect_search_field = (i_searchFieldKey) => {
    this.props.ContactsMobx.a_set_search_field_key(i_searchFieldKey);
  }

  onselect_search_values = (i_selectedValuesComma) => {
    this.props.ContactsMobx.a_set_search_selected_values_comma(i_selectedValuesComma);
  }

  onselect_contacts_browser_tab = (i_selectedTabDbName) => {
    this.props.ContactsMobx.a_set_contacts_browser_selected_tab_db_name(i_selectedTabDbName);
  }

  onchange_sam_gov_entity_search_text = (i_newText) => {
    this.props.ContactsMobx.a_set_sam_gov_entity_search_input_text(i_newText);
  }

  onclick_search_sam_gov_entities = () => {
    const c_samGovEntityFieldsArrayOfObjs = this.props.ContactsMobx.c_samGovEntityFieldsArrayOfObjs;
    const samEntityColumnDbNamesComma = JSFUNC.get_column_vector_from_arrayOfObjs(c_samGovEntityFieldsArrayOfObjs, "dbName").join(",");
    this.props.ContactsMobx.a_search_sam_gov_entities(samEntityColumnDbNamesComma);
  }

  onclick_open_advanced_search = () => {
    this.props.ContactsMobx.a_open_contacts_advanced_search_left_side();
  }

  onclick_open_export = () => {
    this.props.ContactsMobx.a_set_left_side_state("exportContactsToCsv");
  }

  onclick_close_export = () => {
    this.props.ContactsMobx.a_set_left_side_state("treeWithSearch");
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;

    const o_loadingThroughPhase2CompleteTF = this.props.CaptureExecMobx.o_loadingThroughPhase2CompleteTF;
    const o_leftSideMode = this.props.ContactsMobx.o_leftSideState;
    const o_searchFieldKey = this.props.ContactsMobx.o_searchFieldKey;
    const o_searchText = this.props.ContactsMobx.o_searchText;
    const o_searchSelectedValuesComma = this.props.ContactsMobx.o_searchSelectedValuesComma;
    const o_contactsBrowserSelectedTabDbName = this.props.ContactsMobx.o_contactsBrowserSelectedTabDbName;
    const o_samGovEntitySearchInputText = this.props.ContactsMobx.o_samGovEntitySearchInputText;
    const o_samGovEntitiesSearchState = this.props.ContactsMobx.o_samGovEntitiesSearchState;
    const o_rightSideState = this.props.ContactsMobx.o_rightSideState;
    const c_allOrgsArrayOfObjs = this.props.ContactsMobx.c_allOrgsArrayOfObjs;
    const c_allPersonsArrayOfObjs = this.props.ContactsMobx.c_allPersonsArrayOfObjs;
    const c_searchFieldsFieldTypeObj = this.props.ContactsMobx.c_searchFieldsFieldTypeObj;
    const c_selectedSearchFieldObj = this.props.ContactsMobx.c_selectedSearchFieldObj;
    const c_selectedSearchValuesFieldTypeObjOrUndefined = this.props.ContactsMobx.c_selectedSearchValuesFieldTypeObjOrUndefined;
    const c_bitGlobalInfoObj = this.props.DatabaseMobx.c_bitGlobalInfoObj;
    const c_userCanCreateContactsTF = this.props.UserMobx.c_userCanCreateContactsTF;

    if(!o_loadingThroughPhase2CompleteTF) {
      return(
        <div className="flex11a displayFlexColumnHcVc textCenter">
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font11 fontItalic fontTextLight">
            {"CaptureExec is loading your system Contacts"}
          </LibraryReact.DivFont>
          <CEGeneralReact.LoadingAnimation />
        </div>
      );
    }

    var leftSideIsTreeWithSearchTF = false;
    var leftSideIsAdvancedCompanySearchTF = false;
    var leftSideIsExportContactsToCsvTF = false;
    var leftSideIsSelectParentDivisionTF = false;
    if(o_leftSideMode === "treeWithSearch") { leftSideIsTreeWithSearchTF = true; }
    else if(o_leftSideMode === "advancedCompanySearch") { leftSideIsAdvancedCompanySearchTF = true; }
    else if(o_leftSideMode === "exportContactsToCsv") { leftSideIsExportContactsToCsvTF = true; }
    else if(o_leftSideMode === "selectParentDivision") { leftSideIsSelectParentDivisionTF = true; }

    var rightSideIsEmptyTF = false;
    var rightSideIsCreateNewContactTF = false;
    if(o_rightSideState === "empty") { rightSideIsEmptyTF = true; }
    else if(o_rightSideState === "createNewContact") { rightSideIsCreateNewContactTF = true; }

    if(leftSideIsAdvancedCompanySearchTF) {
      return(
        <ContactsAdvancedSearch
          p_selectMode={p_selectMode}
          p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
        />
      );
    }

    const selectedSearchFieldUsesSelectTF = (c_selectedSearchValuesFieldTypeObjOrUndefined !== undefined);
    const searchIsEmptyTF = ((selectedSearchFieldUsesSelectTF) ? (o_searchSelectedValuesComma.length === 0) : (o_searchText.length === 0));
    const selectedSearchFieldDisplayName = ((c_selectedSearchFieldObj === undefined) ? ("Field") : (c_selectedSearchFieldObj.displayName));
    const isSamGovEntitiesTabTF = (o_contactsBrowserSelectedTabDbName === "samEntities");
    const contactsActionsVerticalDotsMenuItemsArrayOfObjs = [
      {
        displayName: "Advanced Search",
        functionOnClickMenuItem: this.onclick_open_advanced_search
      },
      {
        displayName: "Export Contacts",
        functionOnClickMenuItem: this.onclick_open_export
      }
    ];

    return(
      <>
        <div className="flex00a displayFlexRow" style={{padding:"0.7em 0.8em 0", gap:"0.45em", background:"#fbfaf7"}}>
          <LibraryReact.InteractiveDiv
            p_class={"flex11a contactsModernBrowserTab " + ((o_contactsBrowserSelectedTabDbName === "companies") ? ("contactsModernBrowserTabSelected") : (""))}
            p_styleObj={{display:"flex", alignItems:"center", justifyContent:"center", minHeight:"2.8em", gap:"0.45em", color:((o_contactsBrowserSelectedTabDbName === "companies") ? ("#fff") : ("#5f6158")), background:((o_contactsBrowserSelectedTabDbName === "companies") ? ("#77765a") : ("#f5f3ed")), border:"1px solid " + ((o_contactsBrowserSelectedTabDbName === "companies") ? ("#77765a") : ("#ddd8cd")), borderRadius:"0.55em 0.55em 0 0", cursor:"pointer", transition:"background 120ms ease, color 120ms ease, border-color 120ms ease", boxShadow:((o_contactsBrowserSelectedTabDbName === "companies") ? ("inset 0 -0.2em rgba(0, 0, 0, 0.12)") : (undefined))}}
            f_onClick={() => this.onselect_contacts_browser_tab("companies")}>
            <span className="fontBold">{"Companies"}</span>
            <span className="contactsModernBrowserTabCount">{JSFUNC.number_commas_decimal_format(c_allOrgsArrayOfObjs.length)}</span>
          </LibraryReact.InteractiveDiv>
          <LibraryReact.InteractiveDiv
            p_class={"flex11a contactsModernBrowserTab " + ((o_contactsBrowserSelectedTabDbName === "persons") ? ("contactsModernBrowserTabSelected") : (""))}
            p_styleObj={{display:"flex", alignItems:"center", justifyContent:"center", minHeight:"2.8em", gap:"0.45em", color:((o_contactsBrowserSelectedTabDbName === "persons") ? ("#fff") : ("#5f6158")), background:((o_contactsBrowserSelectedTabDbName === "persons") ? ("#77765a") : ("#f5f3ed")), border:"1px solid " + ((o_contactsBrowserSelectedTabDbName === "persons") ? ("#77765a") : ("#ddd8cd")), borderRadius:"0.55em 0.55em 0 0", cursor:"pointer", transition:"background 120ms ease, color 120ms ease, border-color 120ms ease", boxShadow:((o_contactsBrowserSelectedTabDbName === "persons") ? ("inset 0 -0.2em rgba(0, 0, 0, 0.12)") : (undefined))}}
            f_onClick={() => this.onselect_contacts_browser_tab("persons")}>
            <span className="fontBold">{"Persons"}</span>
            <span className="contactsModernBrowserTabCount">{JSFUNC.number_commas_decimal_format(c_allPersonsArrayOfObjs.length)}</span>
          </LibraryReact.InteractiveDiv>
          <LibraryReact.InteractiveDiv
            p_class={"flex11a contactsModernBrowserTab " + ((isSamGovEntitiesTabTF) ? ("contactsModernBrowserTabSelected") : (""))}
            p_styleObj={{display:"flex", alignItems:"center", justifyContent:"center", minHeight:"2.8em", gap:"0.45em", color:(isSamGovEntitiesTabTF ? "#fff" : "#5f6158"), background:(isSamGovEntitiesTabTF ? "#77765a" : "#f5f3ed"), border:"1px solid " + (isSamGovEntitiesTabTF ? "#77765a" : "#ddd8cd"), borderRadius:"0.55em 0.55em 0 0", cursor:"pointer", transition:"background 120ms ease, color 120ms ease, border-color 120ms ease", boxShadow:(isSamGovEntitiesTabTF ? "inset 0 -0.2em rgba(0, 0, 0, 0.12)" : undefined)}}
            f_onClick={() => this.onselect_contacts_browser_tab("samEntities")}>
            <span className="fontBold">{"SAM.gov Entities"}</span>
            <span className="contactsModernBrowserTabCount">{c_bitGlobalInfoObj.samEntitiesLastFlashNumCompaniesDisplayNumber}</span>
          </LibraryReact.InteractiveDiv>
        </div>
        {isSamGovEntitiesTabTF &&
          <div className="flex00a textCenter fontItalic" style={{padding:"0.45em 0.8em 0", color:"#9a7a32"}}>
            {"This SAM entities database is the posted version from " + c_bitGlobalInfoObj.samEntitiesLastFlashDateText + " containing " + c_bitGlobalInfoObj.samEntitiesLastFlashNumCompaniesDisplayNumber + " entities."}
          </div>
        }
        <div className="flex00a displayFlexRowVc" style={{minHeight:"4.8em", padding:"0.7em 0.8em", gap:"0.25em", background:"#fbfaf7", borderBottom:"1px solid #ddd8cd", boxShadow:"0 0.15em 0.4em rgba(35, 45, 55, 0.04)"}}>
          {isSamGovEntitiesTabTF ? (
            <>
              <div className="flex11a">
                <ContactControlLabel p_text="Search SAM.gov Entity Name or UEI" />
                <CEGeneralReact.SearchInputTextWithClearX
                  p_inputText={o_samGovEntitySearchInputText}
                  p_placeholderText="Enter all or part of an entity name or UEI..."
                  p_includeSearchIconTF={true}
                  p_heightEm={2.2}
                  p_tabIndex={1}
                  f_onChange={this.onchange_sam_gov_entity_search_text}
                  f_onKeyDownEnter={this.onclick_search_sam_gov_entities}
                />
              </div>
              <div className="flex00a smallLeftMargin">
                <CEGeneralReact.CEButton
                  p_type={(o_samGovEntitiesSearchState === "loading") ? ("blueDisabled") : ("blue")}
                  p_text="Search"
                  f_onClick={((o_samGovEntitiesSearchState === "loading") ? (undefined) : (this.onclick_search_sam_gov_entities))}
                />
              </div>
            </>
          ) : (
            <>
              {(c_userCanCreateContactsTF && !leftSideIsSelectParentDivisionTF && !rightSideIsCreateNewContactTF) &&
                <>
                  <CreateNewPersonOrCompanyContactButton p_isPersonTF={false} f_onClick={this.onclick_create_new_contact_company} />
                  <CreateNewPersonOrCompanyContactButton p_isPersonTF={true} f_onClick={this.onclick_create_new_contact_person} />
                </>
              }
              <div className="flex11a displayFlexRowVc" style={{minWidth:"18em", padding:"0 0.55em"}}>
                <div className="flex11a smallRightMargin" style={{flexBasis:"90em", minWidth:0}}>
                  <ContactControlLabel p_text="Field" />
                  <CEGeneralReact.GenericInputOrSelectFromInputType
                    p_fieldTypeObj={c_searchFieldsFieldTypeObj}
                    p_valueRaw={o_searchFieldKey}
                    p_tabIndex={1}
                    f_onChangeOrOnSelect={this.onselect_search_field}
                  />
                </div>
                <div className="flex11a smallLeftMargin" style={{flexBasis:"110em", minWidth:0}}>
                  <ContactControlLabel p_text={(selectedSearchFieldUsesSelectTF) ? ("Filter values") : ("Search")} />
                  {(selectedSearchFieldUsesSelectTF) ? (
                    <CEGeneralReact.GenericInputOrSelectFromInputType
                      p_fieldTypeObj={c_selectedSearchValuesFieldTypeObjOrUndefined}
                      p_valueRaw={o_searchSelectedValuesComma}
                      p_tabIndex={2}
                      f_onChangeOrOnSelect={this.onselect_search_values}
                    />
                  ) : (
                    <CEGeneralReact.SearchInputTextWithClearX
                      p_inputText={o_searchText}
                      p_placeholderText={"Find by " + selectedSearchFieldDisplayName + "..."}
                      p_includeSearchIconTF={true}
                      p_heightEm={2.2}
                      p_tabIndex={2}
                      f_onChange={this.onchange_search_contacts}
                    />
                  )}
                </div>
              </div>
              <div className="flex00a contactsModernOverflowMenu" title="More Contacts actions" style={{margin:"1.05em 0.5em 0 0.25em", padding:"0.35em 0.25em", borderRadius:"0.4em"}}>
                <CEGeneralReact.VerticalDotsMenu p_menuItemsArrayOfObjs={contactsActionsVerticalDotsMenuItemsArrayOfObjs} />
              </div>
            </>
          )}
        </div>
        {(leftSideIsSelectParentDivisionTF) &&
          <LeftTreeBottomChooseParentDivisionUnassignedButtons />
        }
        <ContactsBrowserPaginatedList
          p_selectMode={p_selectMode}
          p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
          p_searchIsEmptyTF={searchIsEmptyTF}
        />
        {(leftSideIsExportContactsToCsvTF) &&
          <ExportContactsToCsvFloatingBox
            f_onClickCancel={this.onclick_close_export}
          />
        }
      </>
    );
  }
}));

const CreateNewPersonOrCompanyContactButton = inject("UserMobx")(observer(
class CreateNewPersonOrCompanyContactButton extends Component { //props: p_isPersonTF, f_onClick
  render() {
    const p_isPersonTF = this.props.p_isPersonTF;
    
    const c_svgPerson24CreateNew = this.props.UserMobx.c_svgPerson24CreateNew;
    const c_svgCompany24CreateNew = this.props.UserMobx.c_svgCompany24CreateNew;

    const addNewPersonOrCompanySvgIconComponent = ((p_isPersonTF) ? (c_svgPerson24CreateNew) : (c_svgCompany24CreateNew));
    return(
      <div className="flex00a" style={{padding:"0 0.3em"}}>
        <div
          className="displayFlexColumnHcVc contactsModernAddButton cursorPointer"
          style={{width:"3.2em", height:"3.2em", background:"#77765a", border:"1px solid #66654c", borderRadius:"0.65em", boxShadow:"0 0.15em 0.4em rgba(70, 67, 46, 0.24)", transition:"background 120ms ease, border-color 120ms ease, transform 120ms ease"}}
          title={"Create a new " + ((p_isPersonTF) ? ("person") : ("company")) + " in the contacts system"}
          onClick={this.props.f_onClick}>
          {addNewPersonOrCompanySvgIconComponent}
        </div>
      </div>
    );
  }
}));

const ExportContactsToCsvFloatingBox = inject("ContactsMobx")(observer(
class ExportContactsToCsvFloatingBox extends Component { //props: f_onClickCancel
  constructor(props) {
    super(props);
    this.state = {
      s_exportTopLevelContactCompaniesTF: true,
      s_exportSubdivisionContactCompaniesTF: true,
      s_exportContactPersonsTF: true,
      s_exportIsRunningTF: false
    };
  }

  onswitch_export_top_level_contact_companies = () => {
    this.setState({s_exportTopLevelContactCompaniesTF:!this.state.s_exportTopLevelContactCompaniesTF});
  }

  onswitch_export_subdivision_contact_companies = () => {
    this.setState({s_exportSubdivisionContactCompaniesTF:!this.state.s_exportSubdivisionContactCompaniesTF});
  }

  onswitch_export_contact_persons = () => {
    this.setState({s_exportContactPersonsTF:!this.state.s_exportContactPersonsTF});
  }



  onclick_export_contacts_to_csv_file = () => {
    const s_exportTopLevelContactCompaniesTF = this.state.s_exportTopLevelContactCompaniesTF;
    const s_exportSubdivisionContactCompaniesTF = this.state.s_exportSubdivisionContactCompaniesTF;
    const s_exportContactPersonsTF = this.state.s_exportContactPersonsTF;

    this.setState({s_exportIsRunningTF:true});

    const functionOnFinish = () => {
      this.setState({s_exportIsRunningTF:false});
    }
    this.props.ContactsMobx.a_export_contacts_to_csv_for_download(s_exportTopLevelContactCompaniesTF, s_exportSubdivisionContactCompaniesTF, s_exportContactPersonsTF, functionOnFinish);
  }

  render() {
    const s_exportTopLevelContactCompaniesTF = this.state.s_exportTopLevelContactCompaniesTF;
    const s_exportSubdivisionContactCompaniesTF = this.state.s_exportSubdivisionContactCompaniesTF;
    const s_exportContactPersonsTF = this.state.s_exportContactPersonsTF;
    const s_exportIsRunningTF = this.state.s_exportIsRunningTF;

    return(
      <CEGeneralReact.FloatingBoxWithSaveCancel
        p_trblFlag="smallVertical"
        p_title="Export All Contacts to .csv File"
        f_onClickCancel={this.props.f_onClickCancel}>
        <div className="flex11a yScroll medFullPad">
          <div className="bigBottomMargin">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={s_exportTopLevelContactCompaniesTF}
              p_onText="Include Top Level Contact Companies"
              p_offText="Don't Include Top Level Contact Companies"
              f_onSwitch={this.onswitch_export_top_level_contact_companies}
            />
          </div>
          <div className="bigBottomMargin">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={s_exportSubdivisionContactCompaniesTF}
              p_onText="Include Subdivision Contact Companies"
              p_offText="Don't Include Subdivision Contact Companies"
              f_onSwitch={this.onswitch_export_subdivision_contact_companies}
            />
          </div>
          <div className="bigBottomMargin">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={s_exportContactPersonsTF}
              p_onText="Include Contact Persons"
              p_offText="Don't Include Contact Persons"
              f_onSwitch={this.onswitch_export_contact_persons}
            />
          </div>
        </div>
        <div className="flex00a displayFlexRowHcVc flexWrap borderT1bbb" style={{flexBasis:"3.5em"}}>
          {(s_exportIsRunningTF) ? (
            <div className="flex00a displayFlexColumnHcVc">
              <div className="flex00a textCenter">
                <font className="fontItalic fontTextLighter">
                  {"Exporting Contacts to .csv File"}
                </font>
              </div>
              <CEGeneralReact.LoadingAnimation />
            </div>
          ) : (
            <>
              <div className="flex00a lrMedPad">
                <CEGeneralReact.CEButton
                  p_type={((!s_exportTopLevelContactCompaniesTF && !s_exportSubdivisionContactCompaniesTF && !s_exportContactPersonsTF) ? ("blueDisabled") : ("blue"))}
                  p_text="Export Contacts to .csv"
                  f_onClick={this.onclick_export_contacts_to_csv_file}
                />
              </div>
              <div className="flex00a lrMedPad">
                <CEGeneralReact.CEButton
                  p_type="gray"
                  p_text="Cancel"
                  f_onClick={this.props.f_onClickCancel}
                />
              </div>
            </>
          )}
        </div>
      </CEGeneralReact.FloatingBoxWithSaveCancel>
    );
  }
}));



const ContactsSystemRightSingleContact = inject("ContactsMobx")(observer(
class ContactsSystemRightSingleContact extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray
  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;

    const o_contactsBrowserSelectedTabDbName = this.props.ContactsMobx.o_contactsBrowserSelectedTabDbName;
    const o_rightSideState = this.props.ContactsMobx.o_rightSideState;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const o_newContactObj = this.props.ContactsMobx.o_newContactObj;
    const c_selectedSamGovEntityObjOrUndefined = this.props.ContactsMobx.c_selectedSamGovEntityObjOrUndefined;
    const isPersonsTabTF = (o_contactsBrowserSelectedTabDbName === "persons");

    if(o_contactsBrowserSelectedTabDbName === "samEntities") {
      return(
        <SamGovEntityDetails
          key={(c_selectedSamGovEntityObjOrUndefined === undefined) ? ("no-selected-entity") : (this.props.ContactsMobx.sam_gov_entity_field_value_from_key(c_selectedSamGovEntityObjOrUndefined, "uei"))}
          p_entityObjOrUndefined={c_selectedSamGovEntityObjOrUndefined}
        />
      );
    }

    if((o_rightSideState === "savingNewContact") && (o_newContactObj !== undefined)) {
      const personOrCompanyString = this.props.ContactsMobx.person_or_company_string_from_is_person_and_is_multi_tf(o_newContactObj.isPersonTF, false);
      const newContactName = ((o_newContactObj.isPersonTF) ? (o_newContactObj.first_name + " " + o_newContactObj.last_name) : (o_newContactObj.legal_name));
      return(
        <ContactEmptyState>
          <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
            {"Creating new Contact " + personOrCompanyString + " '" + newContactName + "'"}
          </LibraryReact.DivFont>
          <div className="microTopMargin">
            <CEGeneralReact.LoadingAnimation />
          </div>
        </ContactEmptyState>
      );
    }

    //open a single contact to view/edit each field
    if(((o_rightSideState === "viewEditSingleContact") || (o_rightSideState === "advancedSearchCapturesAnalysis")) && (c_openContactObj !== undefined)) {
      return(
        <SingleContactViewEdit p_selectMode={p_selectMode} p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray} />
      );
    }

    //this component can be the create new contact form where all fields are available for edit all at once
    if((o_rightSideState === "createNewContact") && (o_newContactObj !== undefined)) {
      return(
        <NewContactForm />
      );
    }

    //o_rightSideState is "empty" or any other invalid value, no contact is currently being viewed or added, so the right side is blank with a message
    return(
      <ContactEmptyState p_iconComponent={<CompanyOrPersonIcon p_isPersonTF={isPersonsTabTF} p_sizeEm={2.4} />}>
        <LibraryReact.DivFont p_fontClass="fontTextLighter">
          {"Select a contact to view their details"}
        </LibraryReact.DivFont>
        <LibraryReact.DivFont p_class="smallTopMargin" p_fontClass="fontTextLighter">
          {"Choose any person or company from the hierarchy, or use the add buttons to create a new contact."}
        </LibraryReact.DivFont>
      </ContactEmptyState>
    );
  }
}));





//-----------------------------------------------------------------------------------------------
//Left Side Sub Components
//-----------------------------------------------------------------------------------------------
const SamGovEntityDetails = inject("CaptureExecMobx", "ContactsMobx", "DatabaseMobx", "UserMobx")(observer(
class SamGovEntityDetails extends Component { //props: p_entityObjOrUndefined
  constructor(props) {
    super(props);
    this.state = {
      s_duplicateCheckOpenTF: false,
      s_saveInProgressTF: false,
      s_saveCompleteTF: false,
      s_companyCreatedWithPersonErrorTF: false,
      s_saveErrorMessageOrUndefined: undefined
    };
  }

  onclick_open_duplicate_checker = () => {
    this.setState({s_duplicateCheckOpenTF:true, s_saveErrorMessageOrUndefined:undefined});
  }

  onclick_cancel_duplicate_checker = () => {
    this.setState({s_duplicateCheckOpenTF:false, s_saveErrorMessageOrUndefined:undefined});
  }

  onclick_save_entity_to_contacts = () => {
    if(this.state.s_saveInProgressTF) {
      return;
    }
    this.setState({s_saveInProgressTF:true, s_saveErrorMessageOrUndefined:undefined});

    const p_entityObjOrUndefined = this.props.p_entityObjOrUndefined;
    const contactPersonsArrayOfObjs = this.props.ContactsMobx.sam_gov_entity_contact_persons_arrayOfObjs_from_entity_obj(p_entityObjOrUndefined);
    const functionOnSuccess = () => {
      this.setState({s_saveInProgressTF:false, s_saveCompleteTF:true, s_duplicateCheckOpenTF:false});
    }
    const functionOnError = (i_errorMessageOrUndefined, i_companyCreatedWithPersonErrorTF=false) => {
      this.setState({
        s_saveInProgressTF:false,
        s_companyCreatedWithPersonErrorTF:i_companyCreatedWithPersonErrorTF,
        s_saveErrorMessageOrUndefined:(i_errorMessageOrUndefined || ("Could not save the SAM.gov entity into Contacts."))
      });
    }
    this.props.ContactsMobx.a_insert_sam_gov_entity_into_contacts(p_entityObjOrUndefined, contactPersonsArrayOfObjs, functionOnSuccess, functionOnError);
  }

  render() {
    const s_duplicateCheckOpenTF = this.state.s_duplicateCheckOpenTF;
    const s_saveInProgressTF = this.state.s_saveInProgressTF;
    const s_saveCompleteTF = this.state.s_saveCompleteTF;
    const s_companyCreatedWithPersonErrorTF = this.state.s_companyCreatedWithPersonErrorTF;
    const s_saveErrorMessageOrUndefined = this.state.s_saveErrorMessageOrUndefined;
    const p_entityObjOrUndefined = this.props.p_entityObjOrUndefined;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_samGovEntityFieldsArrayOfObjs = this.props.ContactsMobx.c_samGovEntityFieldsArrayOfObjs;
    const c_samGovEntityContactCompanyDuplicateCandidatesArrayOfObjs = ((s_duplicateCheckOpenTF) ? (this.props.ContactsMobx.c_samGovEntityContactCompanyDuplicateCandidatesArrayOfObjs) : ([]));
    const c_userCanCreateContactsTF = this.props.UserMobx.c_userCanCreateContactsTF;

    if(p_entityObjOrUndefined === undefined) {
      return(
        <ContactEmptyState>
          <font className="fontItalic fontTextLighter">
            {"Select a SAM.gov entity to view its details."}
          </font>
        </ContactEmptyState>
      );
    }

    const entityName = this.props.ContactsMobx.sam_gov_entity_field_value_from_key(p_entityObjOrUndefined, "entityName");
    const companyFieldsArrayOfObjs = c_samGovEntityFieldsArrayOfObjs.filter((i_fieldObj) => i_fieldObj.displayRightTF && (i_fieldObj.contactNumber === undefined));
    const contactGroupsArrayOfObjs = this.props.ContactsMobx.c_samGovEntityContactGroupsArrayOfObjs;

    return(
      <div className="flex11a yScroll yScrollBottomPad medFullPad">
        <ContactModernSectionHeader p_text={entityName} />
        {(s_saveCompleteTF) ? (
          <div className="smallFullPad bgLightGreen border1ddd borderRadius05">
            {"Saved '" + entityName + "' and its listed contacts into " + c_productStylingObj.productName + " Contacts."}
          </div>
        ) : (
          <>
            {(!s_duplicateCheckOpenTF) ? (
              <div className="displayFlexRowHcVc smallBottomMargin">
                <CEGeneralReact.CEButton
                  p_type={(c_userCanCreateContactsTF) ? ("add") : ("blueDisabled")}
                  p_text={"Save Into " + c_productStylingObj.productName + " Contacts"}
                  f_onClick={(c_userCanCreateContactsTF) ? (this.onclick_open_duplicate_checker) : (undefined)}
                />
              </div>
            ) : (
              <div className="smallBottomMargin medFullPad bgLightestGray border1ddd borderRadius05">
                <LibraryReact.DivFont p_class="textCenter smallBottomMargin" p_fontClass="font12 fontBold">
                  {"Duplicate Check"}
                </LibraryReact.DivFont>
                {(c_samGovEntityContactCompanyDuplicateCandidatesArrayOfObjs.length === 0) ? (
                  <LibraryReact.DivFont p_class="textCenter smallBottomMargin" p_fontClass="fontTextLight">
                    {"No duplicates detected."}
                  </LibraryReact.DivFont>
                ) : (
                  <>
                    <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLight">
                      {"Possible existing Contacts, sorted from most similar to least similar:"}
                    </LibraryReact.DivFont>
                    {c_samGovEntityContactCompanyDuplicateCandidatesArrayOfObjs.map((m_duplicateCandidateObj) =>
                      <div key={m_duplicateCandidateObj.id} className="displayFlexRowVc tbMicroPad borderB1ddd">
                        <div className="flex11a">
                          {m_duplicateCandidateObj.contactName}
                        </div>
                        <div className="flex00a smallLeftMargin fontItalic fontTextLight">
                          {Math.round(m_duplicateCandidateObj.similarity0to1 * 100) + "% match"}
                        </div>
                      </div>
                    )}
                  </>
                )}
                {(s_saveErrorMessageOrUndefined !== undefined) &&
                  <div className="smallTopMargin fontRed">
                    {s_saveErrorMessageOrUndefined}
                  </div>
                }
                <div className="displayFlexRowHcVc flexWrap smallTopMargin">
                  {(!s_companyCreatedWithPersonErrorTF) &&
                    <div className="flex00a lrMedPad">
                      <CEGeneralReact.CEButton
                        p_type={((s_saveInProgressTF || !c_userCanCreateContactsTF) ? ("blueDisabled") : ("blue"))}
                        p_text={(s_saveInProgressTF) ? ("Saving...") : ("Save Into Contacts")}
                        f_onClick={((s_saveInProgressTF || !c_userCanCreateContactsTF) ? (undefined) : (this.onclick_save_entity_to_contacts))}
                      />
                    </div>
                  }
                  <div className="flex00a lrMedPad">
                    <CEGeneralReact.CEButton
                      p_type="gray"
                      p_text="Cancel"
                      f_onClick={((s_saveInProgressTF) ? (undefined) : (this.onclick_cancel_duplicate_checker))}
                    />
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        <div className="smallTopMargin">
          {companyFieldsArrayOfObjs.map((m_fieldObj) =>
            <SamGovEntityDetailField
              key={m_fieldObj.dbName}
              p_fieldObj={m_fieldObj}
              p_value={m_fieldObj.samGovEntityDisplayValue}
              p_setAsideValueMaskOrUndefined={m_fieldObj.setAsideValueMaskOrUndefined}
              p_unmappedBusinessTypeCodesArray={m_fieldObj.unmappedBusinessTypeCodesArray}
              p_naicsValueMaskOrUndefined={m_fieldObj.naicsValueMaskOrUndefined}
              p_unmappedNaicsCodesArray={m_fieldObj.unmappedNaicsCodesArray}
            />
          )}
        </div>
        {contactGroupsArrayOfObjs.map((m_contactGroupObj) => (
            <div key={m_contactGroupObj.contactNumber} className="bigTopMargin" style={{marginLeft:"0.7em", padding:"0.65em 0.85em", background:"#f7f9fa", border:"1px solid #e1e6e9", borderLeft:"3px solid #b5c7d0", borderRadius:"0.5em"}}>
              <div className="smallBottomMargin" style={{paddingBottom:"0.35em", borderBottom:"1px solid #e1e6e9"}}>
                <span className="font12 fontBold fontTextLight">
                  {m_contactGroupObj.contactName}
                </span>
                {(m_contactGroupObj.contactPersonTypeNameOrUndefined !== undefined) &&
                  <span className="smallLeftMargin fontTextLight" style={{fontSize:"0.85em", fontWeight:400}}>
                    {"(" + m_contactGroupObj.contactPersonTypeNameOrUndefined + ")"}
                  </span>
                }
              </div>
              {m_contactGroupObj.fieldsArrayOfObjs.map((m_fieldObj) =>
                <SamGovEntityDetailField
                  key={m_fieldObj.dbName}
                  p_fieldObj={m_fieldObj}
                  p_value={p_entityObjOrUndefined[m_fieldObj.dbName]}
                />
              )}
            </div>
        ))}
      </div>
    );
  }
}));

function SamGovEntityDetailField(props) { //props: p_fieldObj, p_value
  const p_fieldObj = props.p_fieldObj;
  const p_value = props.p_value;
  const p_setAsideValueMaskOrUndefined = props.p_setAsideValueMaskOrUndefined;
  const p_unmappedBusinessTypeCodesArray = JSFUNC.is_array(props.p_unmappedBusinessTypeCodesArray) ? (props.p_unmappedBusinessTypeCodesArray) : ([]);
  const p_naicsValueMaskOrUndefined = props.p_naicsValueMaskOrUndefined;
  const p_unmappedNaicsCodesArray = JSFUNC.is_array(props.p_unmappedNaicsCodesArray) ? (props.p_unmappedNaicsCodesArray) : ([]);
  const displayValue = JSFUNC.text_or_number_is_filled_out_tf(p_value) ? (p_value) : ("—");

  return(
    <div className="displayFlexRowVc tbMicroPad borderB1ddd">
      <div className="flex00a smallRightMargin" style={{flexBasis:"14em"}}>
        <font className="fontBold fontTextLight">
          {p_fieldObj.displayName}
        </font>
      </div>
      <div className="flex11a" style={{overflowWrap:"anywhere", whiteSpace:"pre-wrap"}}>
        {displayValue}
        {((p_setAsideValueMaskOrUndefined !== undefined) || (p_unmappedBusinessTypeCodesArray.length > 0)) &&
          <>
            {" ("}
            {p_setAsideValueMaskOrUndefined}
            {(p_setAsideValueMaskOrUndefined !== undefined && p_unmappedBusinessTypeCodesArray.length > 0) ? ("; ") : ("")}
            {(p_unmappedBusinessTypeCodesArray.length > 0) &&
              <font className="fontRed">
                {"Unmapped codes: " + p_unmappedBusinessTypeCodesArray.join(", ")}
              </font>
            }
            {")"}
          </>
        }
        {((p_naicsValueMaskOrUndefined !== undefined) || (p_unmappedNaicsCodesArray.length > 0)) &&
          <>
            {" ("}
            {p_naicsValueMaskOrUndefined}
            {(p_naicsValueMaskOrUndefined !== undefined && p_unmappedNaicsCodesArray.length > 0) ? ("; ") : ("")}
            {(p_unmappedNaicsCodesArray.length > 0) &&
              <font className="fontRed">
                {"Unmapped NAICS codes: " + p_unmappedNaicsCodesArray.join(", ")}
              </font>
            }
            {")"}
          </>
        }
      </div>
    </div>
  );
}



const ContactsBrowserPaginatedList = inject("ContactsMobx")(observer(
class ContactsBrowserPaginatedList extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray, p_searchIsEmptyTF
  onclick_first_page = () => {
    this.onselect_page_number(1);
  }

  onclick_previous_page = () => {
    this.props.ContactsMobx.a_decrement_contacts_browser_current_page_number();
  }

  onclick_next_page = () => {
    this.props.ContactsMobx.a_increment_contacts_browser_current_page_number();
  }

  onclick_last_page = () => {
    this.onselect_page_number(this.props.ContactsMobx.c_contactsBrowserTotalNumPages);
  }

  onselect_page_number = (i_pageNumber) => {
    this.props.ContactsMobx.a_set_contacts_browser_current_page_number(i_pageNumber);
  }

  onselect_items_per_page = (i_itemsPerPage) => {
    this.props.ContactsMobx.a_set_contacts_browser_items_per_page(i_itemsPerPage);
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;
    const p_searchIsEmptyTF = this.props.p_searchIsEmptyTF;

    const o_searchText = this.props.ContactsMobx.o_searchText;
    const o_contactsBrowserSelectedTabDbName = this.props.ContactsMobx.o_contactsBrowserSelectedTabDbName;
    const c_contactsBrowserItemsPerPage = this.props.ContactsMobx.c_contactsBrowserItemsPerPage;
    const c_contactsBrowserPaginatedSelectedArrayOfObjs = this.props.ContactsMobx.c_contactsBrowserPaginatedSelectedArrayOfObjs;
    const c_contactsBrowserCurrentPageNumber = this.props.ContactsMobx.c_contactsBrowserCurrentPageNumber;
    const c_contactsBrowserTotalNumItems = this.props.ContactsMobx.c_contactsBrowserTotalNumItems;
    const c_contactsBrowserTotalNumPages = this.props.ContactsMobx.c_contactsBrowserTotalNumPages;
    const c_contactsBrowserCurrentPageFirstItemNumber = this.props.ContactsMobx.c_contactsBrowserCurrentPageFirstItemNumber;
    const c_contactsBrowserCurrentPageLastItemNumber = this.props.ContactsMobx.c_contactsBrowserCurrentPageLastItemNumber;
    const c_contactsBrowserCanIncrementPageTF = this.props.ContactsMobx.c_contactsBrowserCanIncrementPageTF;
    const c_contactsBrowserCanDecrementPageTF = this.props.ContactsMobx.c_contactsBrowserCanDecrementPageTF;
    const c_contactsBrowserItemsPerPageFieldTypeObj = this.props.ContactsMobx.c_contactsBrowserItemsPerPageFieldTypeObj;
    const c_selectedSearchValuesFieldTypeObjOrUndefined = this.props.ContactsMobx.c_selectedSearchValuesFieldTypeObjOrUndefined;
    const c_searchResultsCompaniesArrayOfObjs = this.props.ContactsMobx.c_searchResultsCompaniesArrayOfObjs;
    const o_samGovEntitiesSearchState = this.props.ContactsMobx.o_samGovEntitiesSearchState;
    const o_samGovEntitiesSearchErrorMessageOrUndefined = this.props.ContactsMobx.o_samGovEntitiesSearchErrorMessageOrUndefined;
    const isSamGovEntitiesTabTF = (o_contactsBrowserSelectedTabDbName === "samEntities");

    if(isSamGovEntitiesTabTF && (o_samGovEntitiesSearchState === "loading")) {
      return(
        <CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
          {"Searching SAM.gov Entities"}
        </CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
      );
    }
    if(isSamGovEntitiesTabTF && (o_samGovEntitiesSearchState === "error")) {
      return(
        <CEGeneralReact.EmptyScreenWhite>
          {o_samGovEntitiesSearchErrorMessageOrUndefined}
        </CEGeneralReact.EmptyScreenWhite>
      );
    }
    if(isSamGovEntitiesTabTF && (o_samGovEntitiesSearchState === "idle")) {
      return(
        <div className="flex11a displayFlexColumnHcVc textCenter medFullPad">
          <font className="fontItalic fontTextLighter">
            {"Search SAM.gov entities by entering an entity name above."}
          </font>
        </div>
      );
    }

    if(!isSamGovEntitiesTabTF && !p_searchIsEmptyTF && (c_selectedSearchValuesFieldTypeObjOrUndefined === undefined) && (o_searchText.length < 2)) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          <div>{"Search: '" + o_searchText + "'"}</div>
          <div className="smallTopMargin">{"Search must be at least 2 characters long."}</div>
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    const searchIsActiveTF = !p_searchIsEmptyTF;
    const isPersonsTabTF = (o_contactsBrowserSelectedTabDbName === "persons");
    const itemName = ((isSamGovEntitiesTabTF) ? ("SAM.gov entity") : ((searchIsActiveTF) ? ("contact") : ((isPersonsTabTF) ? ("person") : ("company"))));
    const itemNamePlural = ((isSamGovEntitiesTabTF) ? ("SAM.gov entities") : ((searchIsActiveTF) ? ("contacts") : ((isPersonsTabTF) ? ("persons") : ("companies"))));
    const firstPageNumber = Math.max(1, Math.min(c_contactsBrowserCurrentPageNumber - 2, c_contactsBrowserTotalNumPages - 4));
    const lastPageNumber = Math.min(c_contactsBrowserTotalNumPages, firstPageNumber + 4);
    const pageNumbersArray = [];
    for(let pageNumber = firstPageNumber; pageNumber <= lastPageNumber; pageNumber++) {
      pageNumbersArray.push(pageNumber);
    }

    return(
      <div className="flex11a displayFlexColumn" style={{minHeight:0}}>
        <div className="flex11a yScroll yScrollBottomPad" style={{padding:"0.75em", background:"#f3f1ec"}}>
          {(c_contactsBrowserPaginatedSelectedArrayOfObjs.length === 0) ? (
            <ContactNoResults p_text={"No " + itemNamePlural + " match the current search."} />
          ) : (
            c_contactsBrowserPaginatedSelectedArrayOfObjs.map((m_contactObj, m_index) => {
              if(isSamGovEntitiesTabTF) {
                return(
                  <SamGovEntitySearchResult
                    key={this.props.ContactsMobx.sam_gov_entity_field_value_from_key(m_contactObj, "uei")}
                    p_entityObj={m_contactObj}
                  />
                );
              }

              if(searchIsActiveTF) {
                const previousContactObj = ((m_index > 0) ? (c_contactsBrowserPaginatedSelectedArrayOfObjs[m_index - 1]) : (undefined));
                const shouldShowPersonsGroupGapTF = m_contactObj.isPersonTF && (c_searchResultsCompaniesArrayOfObjs.length > 0) && ((previousContactObj === undefined) || !previousContactObj.isPersonTF);
                return(
                  <div key={((m_contactObj.isPersonTF) ? ("p") : ("c")) + m_contactObj.id}>
                    {(shouldShowPersonsGroupGapTF) &&
                      <div style={{height:"1.2em"}} />
                    }
                    <ContactResultCard>
                      <ContactItem
                        p_selectMode={p_selectMode}
                        p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
                        p_contactObj={m_contactObj}
                        p_isSearchResultTF={true}
                        p_numDivisions={((m_contactObj.isPersonTF) ? (undefined) : (this.props.ContactsMobx.num_divisions_under_contact_company_obj(m_contactObj)))}
                      />
                    </ContactResultCard>
                  </div>
                );
              }

              return(isPersonsTabTF) ? (
                <ContactResultCard key={"p" + m_contactObj.id}>
                  <ContactItem
                    p_selectMode={p_selectMode}
                    p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
                    p_contactObj={m_contactObj}
                    p_isSearchResultTF={true}
                  />
                </ContactResultCard>
              ) : (
                <ExpandableOrganization
                  key={m_contactObj.id}
                  p_selectMode={p_selectMode}
                  p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
                  p_contactCompanyObj={m_contactObj}
                />
              );
            })
          )}
        </div>
        <div className="flex00a displayFlexRowVc" style={{minHeight:"3.7em", padding:"0.55em 0.8em", gap:"0.3em", background:"#fbfaf7", borderTop:"1px solid #ddd8cd"}}>
          <div className="flex11a" style={{color:"#6f7067", fontSize:"0.88em"}}>
            {"Showing " + c_contactsBrowserCurrentPageFirstItemNumber + "-" + c_contactsBrowserCurrentPageLastItemNumber + " of " + c_contactsBrowserTotalNumItems + " " + JSFUNC.plural(c_contactsBrowserTotalNumItems, itemName, itemNamePlural)}
          </div>
          <LibraryReact.InteractiveDiv
            p_class={"contactsModernPageButton " + ((!c_contactsBrowserCanDecrementPageTF) ? ("contactsModernPageButtonDisabled") : (""))}
            p_title="First page"
            f_onClick={this.onclick_first_page}>
            <ContactPageButtonGlyph p_text="«" />
          </LibraryReact.InteractiveDiv>
          <LibraryReact.InteractiveDiv
            p_class={"contactsModernPageButton " + ((!c_contactsBrowserCanDecrementPageTF) ? ("contactsModernPageButtonDisabled") : (""))}
            p_title="Previous page"
            f_onClick={this.onclick_previous_page}>
            <ContactPageButtonGlyph p_text="‹" />
          </LibraryReact.InteractiveDiv>
          {pageNumbersArray.map((m_pageNumber) =>
            <LibraryReact.InteractiveDiv
              key={m_pageNumber}
              p_class={"contactsModernPageButton " + ((m_pageNumber === c_contactsBrowserCurrentPageNumber) ? ("contactsModernPageButtonSelected") : (""))}
              f_onClick={() => this.onselect_page_number(m_pageNumber)}>
              {m_pageNumber}
            </LibraryReact.InteractiveDiv>
          )}
          <LibraryReact.InteractiveDiv
            p_class={"contactsModernPageButton " + ((!c_contactsBrowserCanIncrementPageTF) ? ("contactsModernPageButtonDisabled") : (""))}
            p_title="Next page"
            f_onClick={this.onclick_next_page}>
            <ContactPageButtonGlyph p_text="›" />
          </LibraryReact.InteractiveDiv>
          <LibraryReact.InteractiveDiv
            p_class={"contactsModernPageButton " + ((!c_contactsBrowserCanIncrementPageTF) ? ("contactsModernPageButtonDisabled") : (""))}
            p_title="Last page"
            f_onClick={this.onclick_last_page}>
            <ContactPageButtonGlyph p_text="»" />
          </LibraryReact.InteractiveDiv>
          <div style={{width:"9em", marginLeft:"0.45em"}}>
            <CEGeneralReact.GenericInputOrSelectFromInputType
              p_fieldTypeObj={c_contactsBrowserItemsPerPageFieldTypeObj}
              p_valueRaw={c_contactsBrowserItemsPerPage}
              f_onChangeOrOnSelect={this.onselect_items_per_page}
            />
          </div>
        </div>
      </div>
    );
  }
}));

const LeftTreeBottomChooseParentDivisionUnassignedButtons = inject("ContactsMobx")(observer(
class LeftTreeBottomChooseParentDivisionUnassignedButtons extends Component { //props:
  onclick_cancel_select_parent_division = () => {
    this.props.ContactsMobx.a_set_left_side_state("treeWithSearch");
  }

  onclick_select_top_level_as_parent_division = () => {
    const o_rightSideState = this.props.ContactsMobx.o_rightSideState;
    const o_newContactObj = this.props.ContactsMobx.o_newContactObj;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;

    const newParentCompanyID = -1; //set the new parent companyID as -1 for selecting it as top level

    if(o_rightSideState === "createNewContact") {
      const parentCompanyFieldDbName = this.props.ContactsMobx.parent_company_field_db_name(o_newContactObj.isPersonTF);
      this.props.ContactsMobx.a_update_new_contact_field_local(parentCompanyFieldDbName, newParentCompanyID);
    }
    else {
      const fieldDbName = this.props.ContactsMobx.parent_company_field_db_name(c_openContactObj.isPersonTF);
      this.props.ContactsMobx.a_update_contact_field(c_openContactObj.isPersonTF, c_openContactObj.id, fieldDbName, newParentCompanyID, "i");
    }

    this.props.ContactsMobx.a_set_left_side_state("treeWithSearch");
  }

  render() {
    const openContactIsPersonTF = this.props.ContactsMobx.o_openContactIsPersonTF;

    return(
      <div className="displayFlexColumnHcVc borderB1bbb lrPad" style={{height:"3.5em", background:"#aaa"}}>
        <div className="flex00a displayFlexRowVc flexWrap">
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text={((openContactIsPersonTF) ? ("Set Person as Unassigned") : ("Set as Top Level Company"))}
              p_tabIndex={-1}
              f_onClick={this.onclick_select_top_level_as_parent_division}
            />
          </div>
          <div className="flex00a">
            <font className="">
              {"Selecting a Parent Company/Division"}
            </font>
          </div>
          <div className="flex00a lrMedMargin">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="Cancel Selection"
              p_tabIndex={-1}
              f_onClick={this.onclick_cancel_select_parent_division}
            />
          </div>
        </div>
      </div>
    );
  }
}));


const ExpandableOrganization = inject("ContactsMobx")(observer(
class ExpandableOrganization extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray, p_contactCompanyObj
  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;
    const p_contactCompanyObj = this.props.p_contactCompanyObj;

    const c_numUnassignedPersons = this.props.ContactsMobx.c_numUnassignedPersons;

    var numDivisionsInOrg = undefined;
    var numPersonsInOrg = undefined;
    if(p_contactCompanyObj.id <= 0) { //persons not assigned to company has a person count at the 'org' level
      numPersonsInOrg = c_numUnassignedPersons;
    }
    else { //all other actual orgs get their precomputed division/person counts from the fields inside the company obj
      numDivisionsInOrg = p_contactCompanyObj.numOrgDivisions;
      numPersonsInOrg = p_contactCompanyObj.numPersons;
    }

    const orgIsExpandedTF = this.props.ContactsMobx.company_item_is_expanded_tf(p_contactCompanyObj.id);

    return(
      <div style={{marginBottom:"0.55em", overflow:"hidden", background:"#fffefa", border:((orgIsExpandedTF) ? ("1px solid #c8d2dc") : ("1px solid #ddd8ce")), borderRadius:"0.7em", boxShadow:((orgIsExpandedTF) ? ("0 0.2em 0.65em rgba(35, 45, 55, 0.09)") : ("0 0.1em 0.35em rgba(35, 45, 55, 0.05)"))}}>
        <ContactItem
          p_selectMode={p_selectMode}
          p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
          p_contactObj={p_contactCompanyObj}
          p_numDivisions={numDivisionsInOrg}
          p_numPersons={numPersonsInOrg}
        />
        {(orgIsExpandedTF) &&
          <OrgDivisionsAndPersonsTree
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
            p_orgCompanyObj={p_contactCompanyObj}
          />
        }
      </div>
    );
  }
}));


const OrgDivisionsAndPersonsTree = inject("ContactsMobx")(observer(
class OrgDivisionsAndPersonsTree extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray, p_orgCompanyObj
  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;
    const p_orgCompanyObj = this.props.p_orgCompanyObj;

    const orgCompanyID = p_orgCompanyObj.id;
    const orgAbbrOrLegalName = this.props.ContactsMobx.contact_name_plaintext_from_contact_obj(p_orgCompanyObj);
    const allDivisionsInOrgArrayOfObjs = this.props.ContactsMobx.all_companies_within_org_id_arrayOfObjs(orgCompanyID);
    const allExpandedDivisionTreeIDsArray = this.props.ContactsMobx.all_expanded_companies_within_org_tree_id_array(orgCompanyID);

    var divisionAndPersonComponentsArray = []; //all divisions in tree_id asc order with persons in each division placed below the subdivisions

    //persons directly assigned to top org at the top
    const orgPersonsArrayOfObjs = this.props.ContactsMobx.all_persons_within_company_id_arrayOfObjs(orgCompanyID);
    for(let personObj of orgPersonsArrayOfObjs) {
      divisionAndPersonComponentsArray.push(
        <ContactItem
          key={"p" + personObj.id}
          p_selectMode={p_selectMode}
          p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
          p_contactObj={personObj}
          p_leftIndent={1}
        />
      );
    }

    for(let orgDivisionContactCompanyObj of allDivisionsInOrgArrayOfObjs) {
      var divisionIsExpandedTF = this.props.ContactsMobx.company_item_is_expanded_tf(orgDivisionContactCompanyObj.id);

      //division treeID e.g. "01020101"
      var orgDivisionTreeID = orgDivisionContactCompanyObj.tree_id;
      var orgDivisionTreeIDLength = orgDivisionTreeID.length;
      var leftIndent = Math.ceil(orgDivisionTreeIDLength / 2);

      //only draw a division if its direct parent is open
      var divisionParentIsExpandedTF = true;
      if(orgDivisionTreeIDLength >= 4) {
        var divisionParentTreeID = orgDivisionTreeID.substring(0, orgDivisionTreeIDLength - 2);
        divisionParentIsExpandedTF = JSFUNC.in_array(divisionParentTreeID, allExpandedDivisionTreeIDsArray);
      }

      var divisionPersonsArrayOfObjs = []; //do not calculate this if it is not used in an expanded division
      if(divisionParentIsExpandedTF || divisionIsExpandedTF) {
        divisionPersonsArrayOfObjs = this.props.ContactsMobx.all_persons_within_company_id_arrayOfObjs(orgDivisionContactCompanyObj.id);
      }

      //draw this division (if the parent division that contains it is currently expanded)
      if(divisionParentIsExpandedTF) {
        var numDivisions = 0; //compute how many divisions are wihtin this division's tree of subdivisions
        var numPersons = divisionPersonsArrayOfObjs.length; //compute how many persons are wihtin this division's tree of subdivisions (including and starting with num persons assigned to this current division)
        for(let subDivisionObj of allDivisionsInOrgArrayOfObjs) {
          if(JSFUNC.tree_id_is_child_of_parent_tree_id_tf(orgDivisionContactCompanyObj.tree_id, subDivisionObj.tree_id, false)) {
            numDivisions++;

            var subDivisionPersonsArrayOfObjs = this.props.ContactsMobx.all_persons_within_company_id_arrayOfObjs(subDivisionObj.id);
            numPersons += subDivisionPersonsArrayOfObjs.length;
          }
        }

        //draw this particular division if its parent division is expanded
        divisionAndPersonComponentsArray.push(
          <ContactItem
            key={"d" + orgDivisionContactCompanyObj.id}
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
            p_contactObj={orgDivisionContactCompanyObj}
            p_numDivisions={numDivisions}
            p_numPersons={numPersons}
            p_leftIndent={leftIndent}
          />
        );
      }

      //only add the persons for this division if the folder is open
      if(divisionIsExpandedTF) {
        for(let personObj of divisionPersonsArrayOfObjs) {
          divisionAndPersonComponentsArray.push(
            <ContactItem
              key={"p" + personObj.id}
              p_selectMode={p_selectMode}
              p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
              p_contactObj={personObj}
              p_leftIndent={leftIndent + 1}
            />
          );
        }
      }
    }

    //if there are no divisions or contacts under this organization, display a message saying this org is empty
    if(divisionAndPersonComponentsArray.length === 0) {
      var message = "";
      if(orgCompanyID > 0) {
        message = "No Contacts or Divisions have been added to Organization '" + orgAbbrOrLegalName + "'";
      }
      else if(orgCompanyID === -2) {
        message = "No Contact Persons have been imported from the GCSS system";
      }
      else {
        message = "No Contact Persons have an unassigned Company";
      }

      divisionAndPersonComponentsArray = (
        <div className="displayFlexColumnHcVc medFullMargin">
          <font className="fontItalic fontWhite">
            {message}
          </font>
        </div>
      );
    }

    return(
      <div className="bigBottomMargin">
        {divisionAndPersonComponentsArray}
      </div>
    );
  }
}));


const ContactItem = inject("CaptureExecMobx", "ContactsMobx", "UserMobx")(observer(
class ContactItem extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray, p_contactObj, p_isSearchResultTF, p_numDivisions, p_numPersons, p_leftIndent
  onclick_contact_item = () => {
    this.props.ContactsMobx.a_open_contact(this.props.p_contactObj.isPersonTF, this.props.p_contactObj.id);
  }

  onclick_expand_collapse_org = () => {
    this.props.ContactsMobx.a_expand_collapse_company(this.props.p_contactObj.id);
  }

  ondelete_contact = () => {
    this.props.ContactsMobx.a_delete_contact(this.props.p_contactObj.isPersonTF, this.props.p_contactObj.id);
  }

  onclick_select_company_as_parent_division = () => {
    const newSelectedParentCompanyID = this.props.p_contactObj.id;
    const o_rightSideState = this.props.ContactsMobx.o_rightSideState;
    if(o_rightSideState === "createNewContact") { //update only local memory o_newContactObj when creating a new contact
      this.props.ContactsMobx.a_update_new_contact_parent_company_field_local(newSelectedParentCompanyID);
    }
    else { //update the database when editing an existing contact
      this.props.ContactsMobx.a_update_contact_parent_company_field(newSelectedParentCompanyID);
    }
    this.props.ContactsMobx.a_set_left_side_state("treeWithSearch");
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;
    const p_contactObj = this.props.p_contactObj;
    const isSearchResultTF = JSFUNC.prop_value(this.props.p_isSearchResultTF, false);
    const leftIndent = JSFUNC.prop_value(this.props.p_leftIndent, 0);
    const numDivisions = this.props.p_numDivisions; //if provided for a company, draw the tiny company icon with this count number, otherwise not drawn at all for undefined
    const numPersons = this.props.p_numPersons; //if provided for a company, draw the tiny person icon with this count number, otherwise not drawn at all for undefined

    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;
    const o_leftSideMode = this.props.ContactsMobx.o_leftSideState;
    const o_rightSideState = this.props.ContactsMobx.o_rightSideState;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const c_openContactAllChildrenIDsArray = this.props.ContactsMobx.c_openContactAllChildrenIDsArray;
    const c_userCanDeleteContactsTF = this.props.UserMobx.c_userCanDeleteContactsTF;

    const isSelectingParentDivisionTF = (o_leftSideMode === "selectParentDivision");

    const contactID = p_contactObj.id;
    const isValidContactTF = (contactID > 0);
    const isPersonTF = p_contactObj.isPersonTF;
    const isTopCompanyTF = this.props.ContactsMobx.contact_is_top_org_tf(p_contactObj);
    const personCompanyString = this.props.ContactsMobx.person_or_company_string_from_is_person_and_is_multi_tf(isPersonTF, false);

    //person contact item row has title on the far right as a fixed width nowrap box
    var personTitleContainerWidth = ((isSearchResultTF) ? ("14em") : ("17em")); //mediaQueryFlag 5/6
    if(this.props.CaptureExecMobx.o_mediaQueryFlag === 1 || this.props.CaptureExecMobx.o_mediaQueryFlag === 2) { personTitleContainerWidth = ((isSearchResultTF) ? ("11em") : ("12em")); }
    else if(this.props.CaptureExecMobx.o_mediaQueryFlag === 3) { personTitleContainerWidth = ((isSearchResultTF) ? ("12em") : ("13em")); }
    else if(this.props.CaptureExecMobx.o_mediaQueryFlag === 4) { personTitleContainerWidth = ((isSearchResultTF) ? ("13em") : ("15em")); }

    //contact full name from person or company
    const contactName = this.props.ContactsMobx.contact_name_plaintext_from_contact_obj(p_contactObj);

    var isExpandedTF = false; //persons cannot be expanded
    if(!isPersonTF) { //company
      isExpandedTF = this.props.ContactsMobx.company_item_is_expanded_tf(contactID); //determine if this contact company has been expanded
    }

    //company/person icon
    var CompanyOrPersonSvgComponent = null;
    if(isPersonTF) {
      CompanyOrPersonSvgComponent = this.props.UserMobx.c_svgPerson15;
    }
    else {
      CompanyOrPersonSvgComponent = ((isTopCompanyTF) ? (this.props.UserMobx.c_svgCompany20) : (this.props.UserMobx.c_svgCompany15)); //icon sizing (larger for top company)
    }


    var contactNameFontClass = "";
    if(isTopCompanyTF) { //style changes if the contact is a top org
      contactNameFontClass = "font12 " + ((!isValidContactTF) ? ("fontItalic") : ("fontBold"));
      if(!isExpandedTF) {
      }
    }

    //determine background color for persons/subdivisions/orgs
    var showDeleteDotsTF = true;
    var bgColor = "transparent";
    if(isSelectingParentDivisionTF) {
      showDeleteDotsTF = false;
      if(isPersonTF) { bgColor = "#aaa"; }
      else if(isTopCompanyTF) { bgColor = "#ccd"; }
      else { bgColor = "#ccd"; }
    }
    else {
      if(isPersonTF) { bgColor = "transparent"; }
      else if(isTopCompanyTF) { bgColor = "transparent"; }
      else { bgColor = "transparent"; }
    }

    //determine if a company/division/org can be deleted (must have 0 subdivisions under it to be possible)
    var deleteContactMenuItemsArrayOfObjs = [];
    if(isPersonTF) {
      deleteContactMenuItemsArrayOfObjs.push({
        displayName: "Delete Contact Person",
        confirmType: "confirmDelete",
        confirmTitle: "Delete Contact Person",
        confirmMessage: "Are you sure you want to delete Contact Person '" + contactName + "' from the CaptureExec Contacts system?",
        functionOnClickConfirmButton: this.ondelete_contact
      });
    }
    else {
      if(numDivisions > 0) { //cannot delete a company if it has subdivisions still under it, they must all be removed first
        deleteContactMenuItemsArrayOfObjs.push({
          displayName: "Delete Contact Company",
          confirmType: "cancel",
          confirmTitle: "Delete Contact Company",
          confirmMessage: "Contact company '" + contactName + "' cannot be deleted until all divisions (" + numDivisions + ") beneath it are deleted first.",
          functionOnClickConfirmButton: this.ondelete_contact
        });
      }
      else {
        deleteContactMenuItemsArrayOfObjs.push({
          displayName: "Delete Contact Company",
          confirmType: "confirmDelete",
          confirmTitle: "Delete Contact Company",
          confirmMessage: "Are you sure you want to delete contact company '" + contactName + "' from the CaptureExec Contacts system?",
          functionOnClickConfirmButton: this.ondelete_contact
        });
      }
    }

    //can't view/edit a different existing contact when trying to create a new one
    const canOpenContactViewEditWithRowClickTF = (isValidContactTF && (o_rightSideState !== "createNewContact") && !isSelectingParentDivisionTF);

    //selecting a parent
    var showSelectAsParentButtonTF = false;
    if(isSelectingParentDivisionTF && !isPersonTF && isValidContactTF) { //when selecting a parent, the button is only next to valid company contacts
      if(o_rightSideState === "viewEditSingleContact") { //changing the parent company for an existing contact
        if(c_openContactObj) {
          if(c_openContactObj.isPersonTF) { //can select any company to be the parent of a person
            showSelectAsParentButtonTF = true;
          }
          else { //selecting parent for an existing contact that is currently being viewed/edited, don't allow selection of itself or its children
            showSelectAsParentButtonTF = ((contactID !== c_openContactObj.id) && !JSFUNC.in_array(contactID, c_openContactAllChildrenIDsArray));
          }
        }
      }
      else { //currently selecting a parent for a new contact being created, any company can be selected as a parent
        showSelectAsParentButtonTF = true;
      }
    }

    const contactItemComponent = (
      <div
        className={"displayFlexRowVc contactsModernContactRow " + ((c_openContactObj !== undefined && c_openContactObj.id === contactID && c_openContactObj.isPersonTF === isPersonTF) ? ("contactsModernContactRowSelected ") : ("")) + ((canOpenContactViewEditWithRowClickTF) ? ("cursorPointer") : (""))}
        style={{backgroundColor:bgColor, minHeight:((isTopCompanyTF) ? ("3.7em") : ("3.35em")), padding:"0.35em 0.7em", borderBottom:"1px solid #edf0f2", transition:"background 120ms ease, box-shadow 120ms ease"}}
        title={"Click to view/edit info about Contact " + personCompanyString + " '" + contactName + "'"}
        onClick={((canOpenContactViewEditWithRowClickTF) ? (this.onclick_contact_item) : (undefined))}>
        {(!isSelectingParentDivisionTF) &&
          <SelectContactCheckBox
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
            p_contactObj={p_contactObj}
            p_sizeEm={1.2}
            p_styleObj={{marginRight:"0.8em"}}
          />
        }
        {(showSelectAsParentButtonTF) &&
          <div style={{marginRight:"0.8em"}}>
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="Parent"
              f_onClick={this.onclick_select_company_as_parent_division}
            />
          </div>
        }
        <div className={"flex00a smallRightMargin contactsModernRowIcon " + ((isPersonTF) ? ("contactsModernPersonCircleIcon") : (""))} style={{width:"2.25em", height:"2.25em", justifyContent:"center", borderRadius:"50%", background:"#ece9df"}}>
          {CompanyOrPersonSvgComponent}
        </div>
        {(!isPersonTF && isValidContactTF) &&
          <div className="flex00a smallRightMargin">
            <CEGeneralReact.RatingScoreBox1to5 p_rating={p_contactObj.tr_total} p_sizeEm={2.2} />
          </div>
        }
        <div className="flex11a" style={{flexBasis:"150em", color:"#25313b"}}>
          <LibraryReact.NowrapEllipsis p_fontClass={contactNameFontClass}>
            {contactName}
          </LibraryReact.NowrapEllipsis>
        </div>
        {(isPersonTF) &&
          <div className="flex00a" style={{flexBasis:personTitleContainerWidth}}>
            <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
              {p_contactObj.title}
            </LibraryReact.NowrapEllipsis>
          </div>
        }
        {(isSearchResultTF) &&
          <div className="flex11a" style={{flexBasis:((isPersonTF) ? ("125em") : ("100em"))}}>
            <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
              {((isPersonTF) ? (p_contactObj.organizationAbbrOrLegalName) : (p_contactObj.organizationAbbrOrLegalName))}
            </LibraryReact.NowrapEllipsis>
          </div>
        }
        {(!isPersonTF && numDivisions !== undefined) &&
          <div className="flex00a displayFlexRowVc" style={{marginRight:"0.6em"}}>
            <div className="flex11a" />
            <div className="flex00a smallRightMargin">
              {numDivisions}
            </div>
            <div key="icon" className="flex00a">
              {this.props.UserMobx.c_svgCompany10}
            </div>
          </div>
        }
        {(!isPersonTF && numPersons !== undefined) &&
          <div className="flex00a displayFlexRowVc" style={{marginRight:"0.6em"}}>
            <div className="flex11a" />
            <div className="flex00a smallRightMargin">
              {numPersons}
            </div>
            <div key="icon" className="flex00a">
              {this.props.UserMobx.c_svgPerson10}
            </div>
          </div>
        }
        {(!isPersonTF && !isSearchResultTF) &&
          <div className="flex00a" style={{flexBasis:"2em", marginRight:"0.8em"}}>
            <CEGeneralReact.ButtonExpandCollapse
              p_isExpandedTF={isExpandedTF}
              p_sizeEm={2.2}
              f_onClick={this.onclick_expand_collapse_org}
            />
          </div>
        }
        {(c_userCanDeleteContactsTF) &&
          <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.5em"}}>
            {(showDeleteDotsTF && isValidContactTF) &&
              <CEGeneralReact.VerticalDotsMenu
                p_menuItemsArrayOfObjs={deleteContactMenuItemsArrayOfObjs}
              />
            }
          </div>
        }
      </div>
    );

    if(leftIndent === 0) {
      return(contactItemComponent);
    }

    //create left indent spacing vertical lines
    const leftIndentMargin = ((c_isMobileTF) ? ("0.7em") : ("1.5em"));
    var leftIndexComponentsArray = [];
    for(let t = 0; t < leftIndent; t++) {
      leftIndexComponentsArray.push(
        <div className="flex00a" style={{flexBasis:"0.2em", marginLeft:leftIndentMargin, borderLeft:"1px solid #d5dbe0"}} />
      );
    }

    return(
      <div className="displayFlexRow">
        {leftIndexComponentsArray}
        <div className="flex11a">
          {contactItemComponent}
        </div>
      </div>
    );
  }
}));



const ContactsAdvancedSearch = inject("CaptureExecMobx", "ContactsMobx")(observer(
class ContactsAdvancedSearch extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray
  onclick_close_advanced_search = () => {
    this.props.ContactsMobx.a_initialize_contacts_system();
  }

  onselect_advanced_search_companies_or_persons_subtab = (i_newLeftSideState) => {
    this.props.ContactsMobx.a_set_left_side_state(i_newLeftSideState);
  }

  onclick_adv_search_results_download_csv_of_results_data = () => {
    this.props.ContactsMobx.a_contacts_advanced_search_download_csv_of_matching_companies_data();
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;

    const c_isMobileOrTabletTF = this.props.CaptureExecMobx.c_isMobileOrTabletTF;
    const o_advSearchGeneratingCsvOfMatchingCompaniesDataTF = this.props.ContactsMobx.o_advSearchGeneratingCsvOfMatchingCompaniesDataTF;
    const c_advSearchFilteredContactCompaniesArrayOfObjs = this.props.ContactsMobx.c_advSearchFilteredContactCompaniesArrayOfObjs;

    const numFilteredCompanies = c_advSearchFilteredContactCompaniesArrayOfObjs.length;

    var advSearchResultsBarMenuItemsArrayOfObjs = [];
    advSearchResultsBarMenuItemsArrayOfObjs.push({
      displayName: "Download .csv of Results Data",
      functionOnClickMenuItem: this.onclick_adv_search_results_download_csv_of_results_data
    });

    return(
      <div className="flex11a displayFlexColumn contactsAdvancedSearch">
        <div className="flex00a displayFlexRowVc tbPad borderB1bbb contactsAdvancedSearchHeader">
          <div className="flex11a lrMedPad">
            <LibraryReact.NowrapEllipsis p_fontClass="font14 fontItalic fontTextLight">
              {"Advanced Contact Search"}
            </LibraryReact.NowrapEllipsis>
          </div>
          <div className="flex00a lrPad">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text={((c_isMobileOrTabletTF) ? ("Exit") : ("Exit Advanced Search"))}
              f_onClick={this.onclick_close_advanced_search}
            />
          </div>
        </div>
        <div className="flex00a smallFullPad contactsAdvancedSearchFilters">
          <ContactsAdvancedSearchCompanyFilters />
        </div>
        <div className="flex00a displayFlexRow borderT1bbb borderB1bbb contactsAdvancedSearchResultsBar" style={{flexBasis:"3.2em"}}>
          <div className="flex00a displayFlexRowVc lrMedPad">
            <font className="font11 fontWhite contactsAdvancedSearchResultsCount">
              {numFilteredCompanies + " matching " + JSFUNC.plural(numFilteredCompanies, "Company", "Companies")}
            </font>
          </div>
          <div className="flex11a" />
          {(o_advSearchGeneratingCsvOfMatchingCompaniesDataTF) ? (
            <>
              <div className="flex00a displayFlexRowVc" style={{flexBasis:"8em"}}>
                <font className="fontItalic fontAlmostWhite">
                  {"Generating .csv"}
                </font>
              </div>
              <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"4em"}}>
                <CEGeneralReact.LoadingAnimation />
              </div>
            </>
          ) : (
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2em"}}>
              <CEGeneralReact.VerticalDotsMenu
                p_menuItemsArrayOfObjs={advSearchResultsBarMenuItemsArrayOfObjs}
                p_dotsFontColor="ffffff"
              />
            </div>
          )}
        </div>
        <div className="flex11a displayFlexColumn yScroll contactsAdvancedSearchResults" style={{flexBasis:"125em"}}>
          <ContactsAdvancedSearchFilteredContactResultsList
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
          />
        </div>
      </div>
    );
  }
}));


const ContactsAdvancedSearchCompanyFilters = inject("CaptureExecMobx", "ContactsMobx", "DatabaseMobx")(observer(
class ContactsAdvancedSearchCompanyFilters extends Component { //props:
  onselect_company_business_types = (i_newValue) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_company_filter_selected_business_type_ids_comma(i_newValue);
  }

  onselect_company_sb_certifications = (i_newValue) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_company_filter_selected_sb_certifications_bm_set_aside_ids_comma(i_newValue);
  }

  onselect_company_capabilities = (i_newValue) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_company_filter_selected_capability_ids_comma(i_newValue);
  }

  onselect_company_naics_codes = (i_newValue) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_company_filter_selected_naics_code_ids_comma(i_newValue);
  }

  onselect_company_contact_company_extra_field = (i_selectedContactCompanyExtraFieldID) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_company_filter_selected_contact_company_extra_field_id(i_selectedContactCompanyExtraFieldID);
  }

  onchange_company_contact_company_extra_field_search_text = (i_updatedSearchText) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_company_filter_contact_company_extra_field_search_text(i_updatedSearchText);
  }

  onselect_capture_date_field = (i_newValue) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_capture_filter_selected_date_field_id(i_newValue);
  }

  onchange_capture_earliest_date = (i_newValue) => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_capture_filter_selected_earliest_date(i_newValue);
  }

  render() {
    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;

    const o_advSearchCompanyFilterSelectedBusinessTypeIDsComma = this.props.ContactsMobx.o_advSearchCompanyFilterSelectedBusinessTypeIDsComma;
    const o_advSearchCompanyFilterSelectedSBCertificationIDsComma = this.props.ContactsMobx.o_advSearchCompanyFilterSelectedSBCertificationIDsComma;
    const o_advSearchCompanyFilterSelectedCapabilityIDsComma = this.props.ContactsMobx.o_advSearchCompanyFilterSelectedCapabilityIDsComma;
    const o_advSearchCompanyFilterSelectedNaicsCodeIDsComma = this.props.ContactsMobx.o_advSearchCompanyFilterSelectedNaicsCodeIDsComma;
    const o_advSearchCompanyFilterSelectedContactCompanyExtraFieldID = this.props.ContactsMobx.o_advSearchCompanyFilterSelectedContactCompanyExtraFieldID;
    const o_advSearchCompanyFilterContactCompanyExtraFieldSearchText = this.props.ContactsMobx.o_advSearchCompanyFilterContactCompanyExtraFieldSearchText;
    const o_advSearchCaptureFilterSelectedDateFieldID = this.props.ContactsMobx.o_advSearchCaptureFilterSelectedDateFieldID;
    const o_advSearchCaptureFilterSelectedEarliestDate = this.props.ContactsMobx.o_advSearchCaptureFilterSelectedEarliestDate;

    const c_advSearchBusinessTypeFilterIsActiveTF = this.props.ContactsMobx.c_advSearchBusinessTypeFilterIsActiveTF;
    const c_advSearchSBCertificationsFilterIsActiveTF = this.props.ContactsMobx.c_advSearchSBCertificationsFilterIsActiveTF;
    const c_advSearchCapabilitiesFilterIsActiveTF = this.props.ContactsMobx.c_advSearchCapabilitiesFilterIsActiveTF;
    const c_advSearchNaicsCodesFilterIsActiveTF = this.props.ContactsMobx.c_advSearchNaicsCodesFilterIsActiveTF;
    const c_advSearchContactCompanyExtraFieldSearchTextFilterIsActiveTF = this.props.ContactsMobx.c_advSearchContactCompanyExtraFieldSearchTextFilterIsActiveTF;
    const c_advSearchCaptureDateFilterIsActiveTF = this.props.ContactsMobx.c_advSearchCaptureDateFilterIsActiveTF;

    const filterBusinessTypesComponent = (
      <ContactsAdvancedSearchFilterShell p_label="Business Types" p_filterIsActiveTF={c_advSearchBusinessTypeFilterIsActiveTF}>
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiBusinessTypesFieldTypeObj}
          p_valueRaw={o_advSearchCompanyFilterSelectedBusinessTypeIDsComma}
          f_onChangeOrOnSelect={this.onselect_company_business_types}
        />
      </ContactsAdvancedSearchFilterShell>
    );

    const filterSBCertificationsComponent = (
      <ContactsAdvancedSearchFilterShell p_label="Small Business Certifications" p_filterIsActiveTF={c_advSearchSBCertificationsFilterIsActiveTF}>
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiBitMasterSetAsidesFieldTypeObj}
          p_valueRaw={o_advSearchCompanyFilterSelectedSBCertificationIDsComma}
          f_onChangeOrOnSelect={this.onselect_company_sb_certifications}
        />
      </ContactsAdvancedSearchFilterShell>
    );

    const filterCapabilitiesComponent = (
      <ContactsAdvancedSearchFilterShell p_label="Capabilities" p_filterIsActiveTF={c_advSearchCapabilitiesFilterIsActiveTF}>
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiCapabilitiesFieldTypeObj}
          p_valueRaw={o_advSearchCompanyFilterSelectedCapabilityIDsComma}
          f_onChangeOrOnSelect={this.onselect_company_capabilities}
        />
      </ContactsAdvancedSearchFilterShell>
    );

    const filterNaicsCodesComponent = (
      <ContactsAdvancedSearchFilterShell p_label="NAICS Codes" p_filterIsActiveTF={c_advSearchNaicsCodesFilterIsActiveTF}>
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={this.props.DatabaseMobx.c_selectMultiBitMasterNaicsCodesCombinedNamesFieldTypeObj}
          p_valueRaw={o_advSearchCompanyFilterSelectedNaicsCodeIDsComma}
          f_onChangeOrOnSelect={this.onselect_company_naics_codes}
        />
      </ContactsAdvancedSearchFilterShell>
    );

    var companyFiltersComponent = null;
    if(o_mediaQueryFlag >= 4) {
      companyFiltersComponent = (
        <>
          <div className="displayFlexRow microBottomMargin">
            <div className="flex11a lrMargin" style={{flexBasis:"100em"}}>
              {filterBusinessTypesComponent}
            </div>
            <div className="flex11a lrMargin" style={{flexBasis:"100em"}}>
              {filterCapabilitiesComponent}
            </div>
          </div>
          <div className="displayFlexRow microBottomMargin">
            <div className="flex11a lrMargin" style={{flexBasis:"100em"}}>
              {filterSBCertificationsComponent}
            </div>
            <div className="flex11a lrMargin" style={{flexBasis:"100em"}}>
              {filterNaicsCodesComponent}
            </div>
          </div>
        </>
      );
    }
    else {
      companyFiltersComponent = (
        <div className="lrMargin">
          {filterBusinessTypesComponent}
          {filterSBCertificationsComponent}
          {filterCapabilitiesComponent}
          {filterNaicsCodesComponent}
        </div>
      );
    }

    return(
      <>
        <div className="microBottomMargin contactsAdvancedSearchSectionTitle">
          <font className="font12 fontTextLighter">
            {"Filters for Contact Companies"}
          </font>
        </div>
        {companyFiltersComponent}
        <div className="lrMargin">
          <ContactsAdvancedSearchFilterShell p_label="Custom Field Text Search" p_filterIsActiveTF={c_advSearchContactCompanyExtraFieldSearchTextFilterIsActiveTF}>
            <div className="flex11a displayFlexRowVc">
              <div className="flex11a" style={{flexBasis:"125em"}}>
                <CEGeneralReact.GenericInputOrSelectFromInputType
                  p_fieldTypeObj={this.props.DatabaseMobx.c_selectContactCompanyExtraFieldFieldTypeObj}
                  p_valueRaw={o_advSearchCompanyFilterSelectedContactCompanyExtraFieldID}
                  f_onChangeOrOnSelect={this.onselect_company_contact_company_extra_field}
                />
              </div>
              <div className="flex00a" style={{flexBasis:"3.5em", marginLeft:"1em"}}>
                <font className="fontItalic fontTextLighter">
                  {"Search:"}
                </font>
              </div>
              <div className="flex11a lrMargin" style={{flexBasis:"100em"}}>
                <LibraryReact.Text
                  p_value={o_advSearchCompanyFilterContactCompanyExtraFieldSearchText}
                  p_class="borderRadius10 lrMedPad"
                  p_styleObj={{width:"100%"}}
                  f_onChange={this.onchange_company_contact_company_extra_field_search_text}
                />
              </div>
            </div>
          </ContactsAdvancedSearchFilterShell>
        </div>
        <div className="bigTopMargin smallBottomMargin contactsAdvancedSearchSectionTitle">
          <font className="font12 fontTextLighter">
            {"Filter Captures by Date Field"}
          </font>
        </div>
        <ContactsAdvancedSearchFilterShell p_filterIsActiveTF={c_advSearchCaptureDateFilterIsActiveTF}>
          <div className="displayFlexRow">
            <div className="flex11a">
              <div className="microBottomMargin">
                <font className="fontItalic fontTextLighter">
                  {"Capture Date Field:"}
                </font>
              </div>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.c_selectCaptureDateFieldFieldTypeObj}
                p_valueRaw={o_advSearchCaptureFilterSelectedDateFieldID}
                f_onChangeOrOnSelect={this.onselect_capture_date_field}
              />
            </div>
            <div className="flex00a lrMedPad">
              <div className="microBottomMargin">
                <font className="fontItalic fontTextLighter">
                  {"Earliest Date to Include:"}
                </font>
              </div>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={this.props.DatabaseMobx.c_genericDateFieldTypeObj}
                p_valueRaw={o_advSearchCaptureFilterSelectedEarliestDate}
                f_onChangeOrOnSelect={this.onchange_capture_earliest_date}
              />
            </div>
          </div>
        </ContactsAdvancedSearchFilterShell>
      </>
    );
  }
}));

function ContactsAdvancedSearchFilterShell(props) { //props: p_label, p_filterIsActiveTF, children
  const label = props.p_label;
  const filterIsActiveTF = props.p_filterIsActiveTF;

  return(
    <div className="displayFlexRow bgLightestGray border1bbb contactsAdvancedSearchFilterShell">
      <div className={"flex00a borderR1bbb " + ((filterIsActiveTF) ? ("bgBlueGradient") : ("bgLightGrayGradient"))} style={{flexBasis:"1em"}} />
      {(label !== undefined) &&
        <div className="flex00a displayFlexColumnVc lrPad" style={{flexBasis:"8em"}}>
          <font className="fontItalic fontTextLighter">
            {label}
          </font>
        </div>
      }
      <div className="flex11a displayFlexColumnVc tbPad lrPad">
        {props.children}
      </div>
    </div>
  );
}


const ContactsAdvancedSearchFilteredContactResultsList = inject("ContactsMobx")(observer(
class ContactsAdvancedSearchFilteredContactResultsList extends Component { //props: p_selectMode
  onclick_show_all_adv_search_results = () => {
    this.props.ContactsMobx.a_contacts_advanced_search_set_num_results_drawn_to_unlimited();
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;

    const o_advSearchNumResultsDrawnLimit = this.props.ContactsMobx.o_advSearchNumResultsDrawnLimit;
    const c_advSearchAnyFilterIsActiveTF = this.props.ContactsMobx.c_advSearchAnyFilterIsActiveTF;
    const c_advSearchFilteredContactCompaniesArrayOfObjs = this.props.ContactsMobx.c_advSearchFilteredContactCompaniesArrayOfObjs;

    if(!c_advSearchAnyFilterIsActiveTF) {
      return(
        <CEGeneralReact.EmptyScreenGray>
          {"Use the Filters above to view matching Contact search results here"}
        </CEGeneralReact.EmptyScreenGray>
      );
    }

    const numResults = c_advSearchFilteredContactCompaniesArrayOfObjs.length;

    return(
      <>
        {c_advSearchFilteredContactCompaniesArrayOfObjs.map((m_advSearchFilteredContactObj, m_index) =>
          (m_index < o_advSearchNumResultsDrawnLimit) &&
          <ContactsAdvancedSearchResultContactItem
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
            p_contactObj={m_advSearchFilteredContactObj}
            p_isSearchResultTF={true}
          />
        )}
        {(numResults > o_advSearchNumResultsDrawnLimit) &&
          <div className="displayFlexRow tbMedPad contactsAdvancedSearchMoreResults">
            <div className="flex00a lrPad">
              <CEGeneralReact.CEButton
                p_type="blue"
                p_text={"Show all " + numResults + " Contact Companies"}
                f_onClick={this.onclick_show_all_adv_search_results}
              />
            </div>
            <div className="flex11a lrPad" />
          </div>
        }
      </>
    );
  }
}));

const ContactsAdvancedSearchResultContactItem = inject("ContactsMobx", "UserMobx")(observer(
class ContactsAdvancedSearchResultContactItem extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray, p_contactObj
  onclick_contact_item = () => {
    this.props.ContactsMobx.a_open_contact(this.props.p_contactObj.isPersonTF, this.props.p_contactObj.id);
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;
    const p_contactObj = this.props.p_contactObj;

    const c_advSearchCompanyFilterSelectedContactCompanyExtraFieldMapOrUndefined = this.props.ContactsMobx.c_advSearchCompanyFilterSelectedContactCompanyExtraFieldMapOrUndefined;

    const isValidContactTF = (p_contactObj.id > 0);
    const isPersonTF = p_contactObj.isPersonTF;
    const contactName = this.props.ContactsMobx.contact_name_plaintext_from_contact_obj(p_contactObj);
    const isTopCompanyTF = this.props.ContactsMobx.contact_is_top_org_tf(p_contactObj);
    const selectedContactCompanyExtraFieldIsValidTF = (c_advSearchCompanyFilterSelectedContactCompanyExtraFieldMapOrUndefined !== undefined);

    var selectedContactCompanyExtraFieldDbName = "";
    var selectedContactCompanyExtraFieldDisplayName = "";
    if(selectedContactCompanyExtraFieldIsValidTF) {
      selectedContactCompanyExtraFieldDbName = c_advSearchCompanyFilterSelectedContactCompanyExtraFieldMapOrUndefined.get("db_name");
      selectedContactCompanyExtraFieldDisplayName = c_advSearchCompanyFilterSelectedContactCompanyExtraFieldMapOrUndefined.get("display_name");
    }

    var contactNameFontClass = "";
    if(isTopCompanyTF) { //style changes if the contact is a top org
      contactNameFontClass = "font12 " + ((!isValidContactTF) ? ("fontItalic") : ("fontBold"));
    }

    return(
      <div
        className={"displayFlexColumnVc lrMedPad contactsAdvancedSearchResult " + ((isValidContactTF) ? ("cursorPointer") : (""))}
        style={{height:"6.2em"}}
        title={"View/Edit info for  '" + contactName + "'"}
        onClick={((isValidContactTF) ? (this.onclick_contact_item) : (undefined))}>
        <div className="displayFlexRowVc">
          <SelectContactCheckBox
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
            p_contactObj={p_contactObj}
            p_sizeEm={1.2}
            p_styleObj={{marginRight:"0.8em"}}
          />
          <div className="flex00a smallRightMargin">
            {((isTopCompanyTF) ? (this.props.UserMobx.c_svgCompany20) : (this.props.UserMobx.c_svgCompany15))}
          </div>
          <div className="flex11a" style={{flexBasis:"150em"}}>
            <LibraryReact.NowrapEllipsis p_fontClass={contactNameFontClass}>
              {contactName}
            </LibraryReact.NowrapEllipsis>
          </div>
          {(!p_contactObj.isTopLevelCompanyTF) &&
            <div className="flex11a" style={{flexBasis:((isPersonTF) ? ("125em") : ("100em"))}}>
              <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                {p_contactObj.organizationAbbrOrLegalName}
              </LibraryReact.NowrapEllipsis>
            </div>
          }
          {(!isPersonTF && selectedContactCompanyExtraFieldIsValidTF) &&
            <div className="flex00a displayFlexColumn lrPad" style={{flexBasis:"11em"}}>
              <div className="flex00a">
                <LibraryReact.NowrapEllipsis p_fontClass="fontItalic fontTextLighter">
                  {selectedContactCompanyExtraFieldDisplayName + ":"}
                </LibraryReact.NowrapEllipsis>
              </div>
              <div className="flex00a">
                <LibraryReact.NowrapEllipsis p_fontClass="fontTextLight">
                  {p_contactObj[selectedContactCompanyExtraFieldDbName]}
                </LibraryReact.NowrapEllipsis>
              </div>
            </div>
          }
        </div>
        <div className="displayFlexRowVc microTopMargin" style={{height:"1.6em"}}>
          <div className="flex00a lrMedPad" style={{flexBasis:"12em"}}>
            <font className="fontItalic fontTextLight">
              {"We are the Prime:"}
            </font>
          </div>
          <ContactsAdvancedSearchResultWinLossCount p_teamingCategory="theirAsOurWins" p_label="Wins" p_count={p_contactObj.numWonCapturesWePrimeTheySub} p_captureIDsArray={p_contactObj.wonCaptureIDsWePrimeTheySubArray} p_contactCompanyID={p_contactObj.id} />
          <ContactsAdvancedSearchResultWinLossCount p_teamingCategory="theirAsOurActive" p_label="Active" p_count={p_contactObj.numActiveCapturesWePrimeTheySub} p_captureIDsArray={p_contactObj.activeCaptureIDsWePrimeTheySubArray} p_contactCompanyID={p_contactObj.id} />
          <ContactsAdvancedSearchResultWinLossCount p_teamingCategory="theirAsOurLosses" p_label="Losses" p_count={p_contactObj.numLostCapturesWePrimeTheySub} p_captureIDsArray={p_contactObj.lostCaptureIDsWePrimeTheySubArray} p_contactCompanyID={p_contactObj.id} />
        </div>
        <div className="displayFlexRowVc microTopMargin" style={{height:"1.6em"}}>
          <div className="flex00a lrMedPad" style={{flexBasis:"12em"}}>
            <font className="fontItalic fontTextLight">
              {"We are a Sub:"}
            </font>
          </div>
          <ContactsAdvancedSearchResultWinLossCount p_teamingCategory="usAsTheirWins" p_label="Wins" p_count={p_contactObj.numWonCapturesTheyPrimeWeSub} p_captureIDsArray={p_contactObj.wonCaptureIDsTheyPrimeWeSubArray} p_contactCompanyID={p_contactObj.id} />
          <ContactsAdvancedSearchResultWinLossCount p_teamingCategory="usAsTheirActive" p_label="Active" p_count={p_contactObj.numActiveCapturesTheyPrimeWeSub} p_captureIDsArray={p_contactObj.activeCaptureIDsTheyPrimeWeSubArray} p_contactCompanyID={p_contactObj.id} />
          <ContactsAdvancedSearchResultWinLossCount p_teamingCategory="usAsTheirLosses" p_label="Losses" p_count={p_contactObj.numLostCapturesTheyPrimeWeSub} p_captureIDsArray={p_contactObj.lostCaptureIDsTheyPrimeWeSubArray} p_contactCompanyID={p_contactObj.id} />
        </div>
      </div>
    );
  }
}));

const ContactsAdvancedSearchResultWinLossCount = inject("ContactsMobx")(observer(
class ContactsAdvancedSearchResultWinLossCount extends Component { //props: p_teamingCategory, p_label, p_count, p_captureIDsArray, p_contactCompanyID
  onclick_view_captures_in_search_results_box = () => {
    const p_teamingCategory = this.props.p_teamingCategory;
    const p_captureIDsArray = this.props.p_captureIDsArray;
    const p_contactCompanyID = this.props.p_contactCompanyID;
    this.props.ContactsMobx.a_contacts_advanced_search_open_captures_analysis(p_contactCompanyID, p_teamingCategory, p_captureIDsArray);
  }

  render() {
    const p_label = this.props.p_label;
    const p_count = this.props.p_count;
    const p_captureIDsArray = this.props.p_captureIDsArray;
    const p_contactCompanyID = this.props.p_contactCompanyID;

    return(
      <div className="flex11a displayFlexRowVc borderL1ddd" style={{flexBasis:"100em"}}>
        <div className="flex00a lrPad">
          <font className="fontItalic fontTextLight">
            {p_label}
          </font>
        </div>
        <div className="flex00a lrPad">
          {(p_count > 0) ? (
            <LibraryReact.ButtonFlexibleWidthFitsSingleLineText
              p_text={p_count}
              p_class="tbMicroPad lrMedPad border bevelBorderColors borderRadius10 bgBlueGradient hoverLightBlueGradient contactsAdvancedSearchCountButton cursorPointer"
              p_fontClass="fontBold fontWhite"
              p_hoverText="Click to View Capture(s)"
              f_onClick={this.onclick_view_captures_in_search_results_box}
            />
          ) : (
            <font className="fontItalic fontTextLighter">
              {p_count}
            </font>
          )}
        </div>
        <div className="flex11a displayFlexRowVc" />
      </div>
    );
  }
}));











//-----------------------------------------------------------------------------------------------
//Right Side Sub Components
//-----------------------------------------------------------------------------------------------
const SingleContactViewEdit = inject("CaptureExecMobx", "ContactsMobx")(observer(
class SingleContactViewEdit extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray
  onclick_close_contact = () => {
    this.props.ContactsMobx.a_close_contact();
  }

  onselect_contact_info_subtab = (i_selectedTabDbName) => {
    this.props.ContactsMobx.a_set_open_contact_view_edit_single_contact_selected_tab_db_name(i_selectedTabDbName);
    if(i_selectedTabDbName === "teammateAnalysis") {
      this.props.ContactsMobx.a_load_open_contact_teammate_ratings();
    }
    else if(i_selectedTabDbName === "competitorAnalysis") {
      this.props.ContactsMobx.a_load_open_contact_competitor_analysis();
    }
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;

    const o_openContactID = this.props.ContactsMobx.o_openContactID;
    const o_rightSideState = this.props.ContactsMobx.o_rightSideState;
    const o_openContactSubtabLoadingFromDatabaseMessageOrUndefined = this.props.ContactsMobx.o_openContactSubtabLoadingFromDatabaseMessageOrUndefined;
    const o_openContactLoadingDocsTF = this.props.ContactsMobx.o_openContactLoadingDocsTF;
    const o_openContactViewEditSingleContactSelectedTabDbName = this.props.ContactsMobx.o_openContactViewEditSingleContactSelectedTabDbName;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const c_openContactName = this.props.ContactsMobx.c_openContactName;
    const c_openContactCompanyFileFolderSystemMapOfMaps = this.props.ContactsMobx.c_openContactCompanyFileFolderSystemMapOfMaps;
    const c_openContactCompanyFileFolderSystemNumFiles = this.props.ContactsMobx.c_openContactCompanyFileFolderSystemNumFiles;
    const c_openContactPersonFileFolderSystemMapOfMaps = this.props.ContactsMobx.c_openContactPersonFileFolderSystemMapOfMaps;
    const c_openContactPersonFileFolderSystemNumFiles = this.props.ContactsMobx.c_openContactPersonFileFolderSystemNumFiles;

    const isPersonTF = c_openContactObj.isPersonTF;
    const openContactIconSizeEm = ((!isPersonTF && c_openContactObj.isTopLevelCompanyTF) ? 3.2 : 2.4);

    const openContactFileFolderSystemMapOfMaps = ((isPersonTF) ? (c_openContactPersonFileFolderSystemMapOfMaps) : (c_openContactCompanyFileFolderSystemMapOfMaps));
    const openContactFileFolderSystemNumFiles = ((isPersonTF) ? (c_openContactPersonFileFolderSystemNumFiles) : (c_openContactCompanyFileFolderSystemNumFiles));

    const contactsFfsTblName = ((isPersonTF) ? ("tbl_g_contacts_persons_filefoldersystem") : ("tbl_g_contacts_companies_filefoldersystem"));
    const contactsFfsTblContactIDColumnName = ((isPersonTF) ? ("contact_person_id") : ("contact_company_id"));

    const contactNameAndCloseButtonTopBarComponent = (
      <div className="flex00a" style={{padding:"1.1em 1em", background:"linear-gradient(135deg, #fbfaf7, #efede6)", borderBottom:"1px solid #ddd8cd"}}>
        <div className="displayFlexRowVc">
          <SelectContactCheckBox
            p_selectMode={p_selectMode}
            p_contactIDsAlreadyAddedArray={p_contactIDsAlreadyAddedArray}
            p_contactObj={c_openContactObj}
            p_sizeEm={1.6}
            p_styleObj={{marginLeft:"0.3em", marginRight:"0.8em"}}
          />
          <div className={"flex00a smallRightMargin contactsModernDetailAvatar " + ((isPersonTF) ? ("contactsModernPersonCircleIcon") : (""))} style={{width:"3.6em", height:"3.6em", justifyContent:"center", borderRadius:"50%", background:"#e7e3d8", border:"1px solid #d5d0c3"}}>
            <CompanyOrPersonIcon p_isPersonTF={isPersonTF} p_sizeEm={openContactIconSizeEm} />
          </div>
          {(!isPersonTF) &&
            <div className="flex00a smallRightMargin">
              <CEGeneralReact.RatingScoreBox1to5 p_rating={c_openContactObj.tr_total} p_sizeEm={2.8} />
            </div>
          }
          <div className="flex11a smallRightMargin">
            <font className="font15 fontBold" style={{color:"#202b33"}}>
              {c_openContactName}
            </font>
            <div style={{marginTop:"0.25em", color:"#74808a", fontSize:"0.86em"}}>
              {(isPersonTF) ? ("Contact Person") : ("Contact Company")}
            </div>
          </div>
          <div className="flex00a lrMargin">
            <CEGeneralReact.CEButton
              p_type="gray"
              p_text="Close"
              f_onClick={this.onclick_close_contact}
            />
          </div>
        </div>
      </div>
    );

    var rightSideContentComponent = null;
    if(o_rightSideState === "advancedSearchCapturesAnalysis") {
      rightSideContentComponent = (
        <div className="flex11a yScroll yScrollBottomPad" style={{padding:"1.1em 1.2em", background:"#fbfaf7"}}>
          <AdvancedSearchCapturesAnalysis p_selectMode={p_selectMode} />
        </div>
      );
    }
    else {
      var rightSideContentUnderSubTabsComponent = null;
      if(o_openContactViewEditSingleContactSelectedTabDbName === "contactInfo") {
        rightSideContentUnderSubTabsComponent = (
          <div className="flex11a yScroll yScrollBottomPad" style={{padding:"1.1em 1.2em", background:"#fbfaf7"}}>
            <ContactFieldsListEditSaveCancel />
            <div className="hugeBottomMargin" />
            <EditParentCompanyDivision p_contactObj={c_openContactObj} />
            <div className="hugeBottomMargin" />
          </div>
        );
      }
      else if(o_openContactViewEditSingleContactSelectedTabDbName === "teammateAnalysis") {
        rightSideContentUnderSubTabsComponent = (
          <div className="flex11a yScroll yScrollBottomPad" style={{padding:"1.1em 1.2em", background:"#fbfaf7"}}>
            <ContactCompanyTeammateAnalysis />
            <div className="hugeBottomMargin" />
          </div>
        );
      }
      else if(o_openContactViewEditSingleContactSelectedTabDbName === "competitorAnalysis") {
        const o_openContactCompetitorAnalysisLoadState = this.props.ContactsMobx.o_openContactCompetitorAnalysisLoadState;
        const o_openContactCompetitorAnalysisErrorMessageOrUndefined = this.props.ContactsMobx.o_openContactCompetitorAnalysisErrorMessageOrUndefined;

        if(o_openContactCompetitorAnalysisLoadState === "loading") {
          rightSideContentUnderSubTabsComponent = (
            <CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
              {"Loading competitor analysis"}
            </CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
          );
        }
        else if(o_openContactCompetitorAnalysisLoadState === "error") {
          rightSideContentUnderSubTabsComponent = (
            <div className="flex11a displayFlexColumnHcVc medFullPad">
              <CEGeneralReact.EmptyScreenWhite>
                {o_openContactCompetitorAnalysisErrorMessageOrUndefined}
              </CEGeneralReact.EmptyScreenWhite>
              <div className="smallTopMargin">
                <CEGeneralReact.CEButton
                  p_type="blue"
                  p_text="Retry"
                  f_onClick={() => this.props.ContactsMobx.a_load_open_contact_competitor_analysis(true)}
                />
              </div>
            </div>
          );
        }
        else if(o_openContactCompetitorAnalysisLoadState === "loaded") {
          rightSideContentUnderSubTabsComponent = (
            <div className="flex11a yScroll yScrollBottomPad" style={{padding:"1.1em 1.2em", background:"#fbfaf7"}}>
              <ContactCompanyCompetitorAnalysis />
              <div className="hugeBottomMargin" />
            </div>
          );
        }
      }
      else if(o_openContactViewEditSingleContactSelectedTabDbName === "contactConversations") {
        if(o_openContactSubtabLoadingFromDatabaseMessageOrUndefined !== undefined) {
          rightSideContentUnderSubTabsComponent = (
            <div className="flex11a displayFlexColumnHc medFullPad">
              <div className="medBottomMargin">
                <font className="fontItalic fontTextLight">
                  {o_openContactSubtabLoadingFromDatabaseMessageOrUndefined}
                </font>
              </div>
              <CEGeneralReact.LoadingAnimation />
            </div>
          );
        }
        else {
          rightSideContentUnderSubTabsComponent = (
            <div className="flex11a yScroll yScrollBottomPad" style={{padding:"1.1em 1.2em", background:"#fbfaf7"}}>
              <ContactPersonConversations />
              <div className="hugeBottomMargin" />
            </div>
          );
        }
      }
      else if(o_openContactViewEditSingleContactSelectedTabDbName === "viewDocs") {
        rightSideContentUnderSubTabsComponent = (
          <CEComplexReact.FileFolderSystem
            p_tblName={contactsFfsTblName}
            p_tblMapOfMaps={openContactFileFolderSystemMapOfMaps}
            p_tblFilterValuesObj={{[contactsFfsTblContactIDColumnName]:o_openContactID}}
            p_title={undefined}
            p_defaultXmlType={undefined}
            p_allowedExtsArray={undefined}
            p_disableUploadFilesTF={false}
            p_disableCreateOnlineLinkDocsTF={false}
            p_disableCreateFoldersTF={false}
            p_viewWideTrueNarrowFalse={false}
            p_navigateToFolderID={this.props.CaptureExecMobx.o_navigateToFolderIDTblGContactsFileFolderSystem}
            f_onPerformFFSAction={undefined}
            f_onNavigateToFolder={this.props.CaptureExecMobx.a_set_navigate_to_folder_id_tbl_g_contacts_filefoldersystem}
          />
        );
      }

      var contactInfoSubtabDbNamesArray = ["contactInfo"];
      var contactInfoSubtabDisplayNamesArray = ["Contact Info"];
      if(!isPersonTF) { //company specific contact tabs
        const numTeammateCaptures = this.props.ContactsMobx.c_openContactCompanyTeammateCaptureIDsArray.length;
        const numCompetitorCaptures = this.props.ContactsMobx.c_openContactCompanyCompetitorCaptureIDsArray.length;
        contactInfoSubtabDbNamesArray.push("teammateAnalysis");
        contactInfoSubtabDisplayNamesArray.push("Analysis as Teammate (" + numTeammateCaptures + ")");
        contactInfoSubtabDbNamesArray.push("competitorAnalysis");
        contactInfoSubtabDisplayNamesArray.push("Analysis as Competitor (" + numCompetitorCaptures + ")");
      }
      else { //person specific contact tabs
        contactInfoSubtabDbNamesArray.push("contactConversations");
        contactInfoSubtabDisplayNamesArray.push("Conversations");
      }
      contactInfoSubtabDbNamesArray.push("viewDocs");
      contactInfoSubtabDisplayNamesArray.push((o_openContactLoadingDocsTF) ? ("Loading Docs...") : ("View Docs (" + openContactFileFolderSystemNumFiles + ")"));

      rightSideContentComponent = (
        <>
          <div className="flex00a contactsModernTabs" style={{padding:"0.75em 1em 0", background:"#fbfaf7", borderBottom:"1px solid #ddd8cd"}}>
            <CEGeneralReact.TabsList
              p_tabDbNamesArray={contactInfoSubtabDbNamesArray}
              p_tabDisplayNamesArray={contactInfoSubtabDisplayNamesArray}
              p_selectedTabDbName={o_openContactViewEditSingleContactSelectedTabDbName}
              p_tabHeight="2.4em"
              p_textMaxHeight="2.4em"
              p_tabWidth={undefined}
              p_tabSpacing="0em"
              p_underlineSelectionTF={true}
              p_selectedFontClass="fontBold"
              p_unselectedFontClass="fontTextLighter"
              p_canEditTF={true}
              p_rowFlexWrapTF={false}
              f_onSelect={this.onselect_contact_info_subtab}
            />
          </div>
          {rightSideContentUnderSubTabsComponent}
        </>
      );
    }

    return(
      <div className="flex11a displayFlexColumn" style={{background:"#fbfaf7"}}>
        {contactNameAndCloseButtonTopBarComponent}
        {rightSideContentComponent}
      </div>
    );
  }
}));

const ContactFieldsListEditSaveCancel = inject("ContactsMobx")(observer(
class ContactFieldsListEditSaveCancel extends Component { //props:
  render() {
    const c_openContactFieldsArrayOfObjs = this.props.ContactsMobx.c_openContactFieldsArrayOfObjs;

    return(
      <>
        <ContactModernSectionHeader p_text="Details" />
        {c_openContactFieldsArrayOfObjs.map((m_contactFieldObj) =>
          (!JSFUNC.in_array(m_contactFieldObj.db_name, ["contact_company_id", "org_topdiv_id", "tree_id"])) &&
          <ContactFieldEditSaveCancel
            key={m_contactFieldObj.id}
            p_contactFieldObj={m_contactFieldObj}
          />
        )}
      </>
    );
  }
}));

const ContactFieldEditSaveCancel = inject("CaptureExecMobx", "ContactsMobx", "DatabaseMobx", "UserMobx")(observer(
class ContactFieldEditSaveCancel extends Component { //props: p_contactFieldObj
  onsave_changed_field_value = (i_newValue) => {
    const p_contactFieldObj = this.props.p_contactFieldObj;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    this.props.ContactsMobx.a_update_contact_field(c_openContactObj.isPersonTF, c_openContactObj.id, p_contactFieldObj.db_name, i_newValue, p_contactFieldObj.fieldTypeObj.idsb);
  }

  render() {
    const p_contactFieldObj = this.props.p_contactFieldObj; //expanded field obj of hardcoded and custom contact fields mixed together

    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const c_userCanEditContactsTF = this.props.UserMobx.c_userCanEditContactsTF;

    const fieldDbName = p_contactFieldObj.db_name;
    const fieldDisplayName = p_contactFieldObj.display_name;
    const fieldTypeObj = p_contactFieldObj.fieldTypeObj;

    const isPersonTF = c_openContactObj.isPersonTF;
    const valueRaw = c_openContactObj[fieldDbName];

    const valueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(valueRaw, fieldTypeObj);

    var valueMask = valueMaskSortIfoObj.valueMask;
    var valueIsEditableTFU = true;
    if(!c_openContactObj.existsTF || !c_userCanEditContactsTF) { //cannot edit any fields if the contact does not exist or this user cannot edit the contacts
      valueIsEditableTFU = false;
    }
    else if(!isPersonTF && (fieldDbName === "sb_certifications_bm_set_aside_ids_comma") && !c_openContactObj.businessTypeIsSmallTF) { //if this is a large business, mask the sb certs to read N/A and be uneditable
      valueMask = this.props.DatabaseMobx.not_filled_out_font_html("N/A");
      valueIsEditableTFU = false;
    }

    if((fieldDbName === "sam_unique_entity_id") && valueMaskSortIfoObj.isFilledOutTF) {
      const cageCodeIsFilledOutTF = JSFUNC.text_or_number_is_filled_out_tf(c_openContactObj["cage_code"]);
      const webShortNamesArray = ["SBA", "G2X", "OGUS"];
      const webFullNamesArray = ["U.S. Small Business Administration (SBA) Profile", "G2Xchange (G2X)", "OpenGovUS"];
      var webAddressesArray = [];
      //webAddressesArray.push("https://www.fpds.gov/ezsearch/search.do?indexName=awardfull&templateName=1.5.3&s=FPDS.GOV&q=" + valueMaskSortIfoObj.valueRaw);
      webAddressesArray.push("https://search.certifications.sba.gov/profile/" + valueMaskSortIfoObj.valueRaw + "/" + c_openContactObj["cage_code"]);
      webAddressesArray.push("https://g2xchange.com/app/companies/" + valueMaskSortIfoObj.valueRaw);
      webAddressesArray.push("https://opengovus.com/sam-entity/" + valueMaskSortIfoObj.valueRaw);
      const disabledMessagesOrUndefinedArray = [((cageCodeIsFilledOutTF) ? (undefined) : ("Cage Code must also be filled out to access a company's SBA profile")), undefined, undefined];

      valueMask = (
        <div className="displayFlexRowVc flexWrap">
          <div className="flex00a" style={{flexBasis:"13em"}}>
            {valueMaskSortIfoObj.valueMask}
          </div>
          <div className="flex00a displayFlexRowVc" style={{flexBasis:"12em"}}>
            {webShortNamesArray.map((m_webShortName, m_index) =>
              <SamUeiWebLinkIcon
                key={m_webShortName}
                p_webShortName={m_webShortName}
                p_webFullName={webFullNamesArray[m_index]}
                p_webAddress={webAddressesArray[m_index]}
                p_contactCompanyName={c_openContactObj.abbrOrLegalName}
                p_disabledMessageOrUndefined={disabledMessagesOrUndefinedArray[m_index]}
              />
            )}
            <div className="flex11a" />
          </div>
        </div>
      );
    }

    return(
      <CEGeneralReact.CaptureExecFieldEditSaveCancel
        p_ceEditItemString={"contactField" + p_contactFieldObj.id}
        p_isContactFieldTF={true}
        p_fieldDisplayName={fieldDisplayName}
        p_fieldTypeObj={fieldTypeObj}
        p_valueRaw={valueRaw}
        p_valueMask={valueMask}
        p_valueIsEditableTFU={valueIsEditableTFU}
        p_containerClass="contactsModernFieldRow"
        p_fieldClass="fontBlue"
        p_fieldWidth={((c_isMobileTF) ? ("30%") : ("14em"))}
        p_fieldNowrapTF={false}
        p_fieldValueVerticallyAlignedTF={false}
        p_floatingBoxTitle={"Editing Contact " + fieldDisplayName}
        f_onSaveChanged={this.onsave_changed_field_value}
      />
    );
  }
}));

class SamUeiWebLinkIcon extends Component { //p_webShortName, p_webFullName, p_webAddress, p_contactCompanyName, p_disabledMessageOrUndefined
  onclick_online_link_open_in_new_tab = (event) => {
    const p_webAddress = this.props.p_webAddress;

    event.preventDefault();
    event.stopPropagation(); //prevent clicking elements beneath this icon

    window.open(p_webAddress, "_blank");
  }

  render() {
    const p_webShortName = this.props.p_webShortName;
    const p_webFullName = this.props.p_webFullName;
    const p_webAddress = this.props.p_webAddress;
    const p_contactCompanyName = this.props.p_contactCompanyName;
    const p_disabledMessageOrUndefined = this.props.p_disabledMessageOrUndefined;

    const disabledTF = (p_disabledMessageOrUndefined !== undefined);

    var hoverText = "[" + ((disabledTF) ? (p_disabledMessageOrUndefined) : ("Click to open " + p_webShortName + " link in new window")) + "]";
    hoverText += "\n" + p_webAddress;
    hoverText += "\nLink to " + p_webFullName + " for '" + p_contactCompanyName + "'";

    return(
      <div
        className={"flex00a displayFlexColumnHcVc lrMargin border bevelBorderColorBlue borderRadius05 " + ((disabledTF) ? ("bgLightGrayGradient") : ("bgLightGoldGradient hoverLighterGoldGradient cursorPointer")) + " textCenter"}
        style={{flexBasis:"3.8em", height:"1.3em"}}
        title={hoverText}
        onClick={((disabledTF) ? (undefined) : (this.onclick_online_link_open_in_new_tab))}>
        <font className="font09 fontBold fontBlue">
          {p_webShortName}
        </font>
      </div>
    );
  }
}

const EditParentCompanyDivision = inject("ContactsMobx", "UserMobx")(observer(
class EditParentCompanyDivision extends Component { //props: p_contactObj
  onclick_edit_parent_division = () => {
    this.props.ContactsMobx.a_set_left_side_state("selectParentDivision");
  }

  onclick_cancel_selection = () => {
    this.props.ContactsMobx.a_set_left_side_state("treeWithSearch");
  }

  render() {
    const contactObjCopy = JSFUNC.copy_obj(this.props.p_contactObj);
    const openContactName = this.props.ContactsMobx.contact_name_plaintext_from_contact_obj(contactObjCopy);

    const o_leftSideMode = this.props.ContactsMobx.o_leftSideState;
    const c_userCanEditContactsTF = this.props.UserMobx.c_userCanEditContactsTF;

    const isSelectingParentDivisionTF = (o_leftSideMode === "selectParentDivision");

    const isPersonTF = contactObjCopy.isPersonTF;
    const parentCompanyIDFieldDbName = this.props.ContactsMobx.parent_company_field_db_name(isPersonTF);
    var parentCompanyID = contactObjCopy[parentCompanyIDFieldDbName];

    var parentCompanyName = undefined;
    var parentCompanyNameFontClasses = undefined;
    if(isSelectingParentDivisionTF) {
      parentCompanyName = "--Select a 'Parent' button on the left to set a new Parent Company/Division for " + openContactName + "--";
      parentCompanyNameFontClasses = "fontItalic fontTextLighter";
    }
    else if(!JSFUNC.select_int_is_filled_out_tf(parentCompanyID)) {
      if(isPersonTF) {
        parentCompanyName = "--Person Not Assigned to a Company/Division--";
      }
      else {
        parentCompanyName = "--This is a Top Level Company--";
      }
      parentCompanyNameFontClasses = "fontItalic fontTextLighter";
    }
    else {
      if(!isPersonTF) {
        parentCompanyID = this.props.ContactsMobx.parent_company_id_from_company_obj(contactObjCopy);
      }
      const parentCompanyObj = this.props.ContactsMobx.contact_company_or_person_obj_from_id(false, parentCompanyID);
      parentCompanyName = this.props.ContactsMobx.contact_name_plaintext_from_contact_obj(parentCompanyObj);
    }

    var editCancelSelectionButtonsComponent = null;
    if(contactObjCopy.existsTF && c_userCanEditContactsTF) {
      if(isSelectingParentDivisionTF) {
        editCancelSelectionButtonsComponent = (
          <div className="flex00a">
            <CEGeneralReact.CEButton
              p_type="add"
              p_text="Cancel Selection"
              p_tabIndex={-1}
              f_onClick={this.onclick_cancel_selection}
            />
          </div>
        );
      }
      else {
        editCancelSelectionButtonsComponent = (
          <CEGeneralReact.EditSaveCancelIcon
            p_iconType="edit"
            f_onClick={this.onclick_edit_parent_division}
          />
        );
      }
    }

    return(
      <>
        <div className="displayFlexRowVc microBottomMargin">
          <div className="flex00a smallRightMargin">
            <font className="font12 fontBold fontTextLight">
              {"Parent Company/Division"}
            </font>
          </div>
          {editCancelSelectionButtonsComponent}
          <div className="flex11a" />
        </div>
        <div>
          <font className={parentCompanyNameFontClasses}>
            {parentCompanyName}
          </font>
        </div>
      </>
    );
  }
}));


const ContactCompanyTeammateAnalysis = inject("ContactsMobx", "DatabaseMobx")(observer(
class ContactCompanyTeammateAnalysis extends Component { //props:
  render() {
    const o_openContactSubtabLoadingFromDatabaseMessageOrUndefined = this.props.ContactsMobx.o_openContactSubtabLoadingFromDatabaseMessageOrUndefined;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const c_openContactCompanyTeammateCaptureIDsArray = this.props.ContactsMobx.c_openContactCompanyTeammateCaptureIDsArray;
    const c_openContactCompanyTeammateArchivedCaptureIDsArray = this.props.ContactsMobx.c_openContactCompanyTeammateArchivedCaptureIDsArray;
    const c_openContactCompanyTeammatesRatingsCapturesArrayOfObjs = this.props.ContactsMobx.c_openContactCompanyTeammatesRatingsCapturesArrayOfObjs;
    const c_openContactCompanyTeammatesRatingsCapturesReviewedArrayOfObjs = this.props.ContactsMobx.c_openContactCompanyTeammatesRatingsCapturesReviewedArrayOfObjs;
    const c_openContactCompanyTeammatesRatingsCapturesNotReviewedArrayOfObjs = this.props.ContactsMobx.c_openContactCompanyTeammatesRatingsCapturesNotReviewedArrayOfObjs;
    const c_openContactCompanyTeammateRatingsTimeGraphObj = this.props.ContactsMobx.c_openContactCompanyTeammateRatingsTimeGraphObj;
    const c_teammatesRatingsQuestionsArrayOfObjs = this.props.DatabaseMobx.c_teammatesRatingsQuestionsArrayOfObjs;

    if((c_openContactObj === undefined) || c_openContactObj.isPersonTF) {
      return(null);
    }

    const numTeammateCaptures = c_openContactCompanyTeammateCaptureIDsArray.length;
    const numReviews = (JSFUNC.is_number_not_nan(c_openContactObj.tr_num_reviews) ? c_openContactObj.tr_num_reviews : 0);
    const numTeammateCapturesText = numTeammateCaptures + " " + JSFUNC.plural(numTeammateCaptures, "Capture", "Captures");
    const numReviewsText = numReviews + " " + JSFUNC.plural(numReviews, "time", "times");
    const isLoadingTF = (o_openContactSubtabLoadingFromDatabaseMessageOrUndefined !== undefined);

    return(
      <div className="displayFlexColumn lrMedPad" style={{paddingBottom:"1em"}}>
        <ContactModernSectionHeader p_text="Analysis as Teammate" />
        <div className="smallBottomMargin medFullPad bgWhite border1ddd borderRadius05">
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="fontItalic fontTextLight">
            {"'" + c_openContactObj.abbrOrLegalName + "' is a Teammate on " + numTeammateCapturesText + " and has been reviewed " + numReviewsText}
          </LibraryReact.DivFont>
          <div style={{maxWidth:"32em"}}>
            <ContactCompanyTeammateRatingItem p_label="Overall Rating" p_rating={c_openContactObj.tr_total} p_isOverallTF={true} />
            {c_teammatesRatingsQuestionsArrayOfObjs.map((m_teammatesRatingsQuestionObj) =>
              <ContactCompanyTeammateRatingItem
                key={m_teammatesRatingsQuestionObj.id}
                p_label={m_teammatesRatingsQuestionObj.name}
                p_rating={c_openContactObj["tr_q" + m_teammatesRatingsQuestionObj.id]}
              />
            )}
          </div>
        </div>
        {(isLoadingTF) ? (
          <CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
            {o_openContactSubtabLoadingFromDatabaseMessageOrUndefined}
          </CEGeneralReact.EmptyScreenGrayWithLoadingAnimation>
        ) : (
          <>
            <div style={{marginTop:"1.2em"}}>
              <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font12 fontBold fontTextLight">
                {"Capture Value Over Time"}
              </LibraryReact.DivFont>
              <ContactAnalysisTimeGraph p_isTeammateAnalysisTF={true} p_timeGraphObj={c_openContactCompanyTeammateRatingsTimeGraphObj} />
            </div>
            <div style={{marginTop:"1.2em"}}>
              <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font12 fontBold fontTextLight">
                {"Teammate Captures (" + c_openContactCompanyTeammatesRatingsCapturesArrayOfObjs.length + ")"}
              </LibraryReact.DivFont>
              {(c_openContactCompanyTeammatesRatingsCapturesArrayOfObjs.length === 0) ? (
                <ContactNoResults p_text="This company has not been added as a Teammate to any currently loaded Captures." />
              ) : (
                c_openContactCompanyTeammatesRatingsCapturesArrayOfObjs.map((m_teammatesRatingsCaptureObj) =>
                  <ContactCompanyTeammateAnalysisCapture
                    key={m_teammatesRatingsCaptureObj.captureID}
                    p_teammatesRatingsCaptureObj={m_teammatesRatingsCaptureObj}
                  />
                )
              )}
              {(c_openContactCompanyTeammateArchivedCaptureIDsArray.length > 0) &&
                <LibraryReact.DivFont p_class="smallFullPad" p_fontClass="font12 fontItalic fontTextLight">
                  {"'" + c_openContactObj.abbrOrLegalName + "' has also been a Teammate on " + c_openContactCompanyTeammateArchivedCaptureIDsArray.length + " " + JSFUNC.plural(c_openContactCompanyTeammateArchivedCaptureIDsArray.length, "Capture", "Captures") + " that are archived and not currently loaded."}
                </LibraryReact.DivFont>
              }
              {(c_openContactCompanyTeammatesRatingsCapturesReviewedArrayOfObjs.length > 0) &&
                <LibraryReact.DivFont p_class="smallFullPad" p_fontClass="font12 fontItalic fontTextLight">
                  {"Ratings filled out for " + c_openContactCompanyTeammatesRatingsCapturesReviewedArrayOfObjs.length + " of " + c_openContactCompanyTeammatesRatingsCapturesArrayOfObjs.length + " current Teammate Captures."}
                </LibraryReact.DivFont>
              }
              {(c_openContactCompanyTeammatesRatingsCapturesNotReviewedArrayOfObjs.length > 0) &&
                <LibraryReact.DivFont p_class="smallFullPad" p_fontClass="font12 fontItalic fontTextLight">
                  {c_openContactCompanyTeammatesRatingsCapturesNotReviewedArrayOfObjs.length + " current Teammate Captures do not have ratings filled out."}
                </LibraryReact.DivFont>
              }
            </div>
          </>
        )}
      </div>
    );
  }
}));

const ContactCompanyCompetitorAnalysis = inject("ContactsMobx")(observer(
class ContactCompanyCompetitorAnalysis extends Component { //props:
  render() {
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const c_openContactCompanyCompetitorAnalysisCapturesArrayOfObjs = this.props.ContactsMobx.c_openContactCompanyCompetitorAnalysisCapturesArrayOfObjs;
    const c_openContactCompanyCompetitorAnalysisTimeGraphObj = this.props.ContactsMobx.c_openContactCompanyCompetitorAnalysisTimeGraphObj;

    if((c_openContactObj === undefined) || c_openContactObj.isPersonTF) {
      return(null);
    }

    return(
      <div className="displayFlexColumn lrMedPad" style={{paddingBottom:"1em"}}>
        <ContactModernSectionHeader p_text="Analysis as Competitor" />
        <div style={{marginTop:"1.2em"}}>
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font12 fontBold fontTextLight">
            {"Capture Value Over Time"}
          </LibraryReact.DivFont>
          <ContactAnalysisTimeGraph p_timeGraphObj={c_openContactCompanyCompetitorAnalysisTimeGraphObj} />
        </div>
        <div style={{marginTop:"1.2em"}}>
          <LibraryReact.DivFont p_class="smallBottomMargin" p_fontClass="font12 fontBold fontTextLight">
            {"Competitor Captures (" + c_openContactCompanyCompetitorAnalysisCapturesArrayOfObjs.length + ")"}
          </LibraryReact.DivFont>
          {(c_openContactCompanyCompetitorAnalysisCapturesArrayOfObjs.length === 0) ? (
            <ContactNoResults p_text="This company has not been added as a Competitor to any currently loaded Captures." />
          ) : (
            c_openContactCompanyCompetitorAnalysisCapturesArrayOfObjs.map((m_competitorAnalysisCaptureObj) =>
              <ContactCompanyCompetitorAnalysisCapture
                key={m_competitorAnalysisCaptureObj.captureID + "_" + m_competitorAnalysisCaptureObj.competitorObj.id}
                p_competitorAnalysisCaptureObj={m_competitorAnalysisCaptureObj}
              />
            )
          )}
        </div>
      </div>
    );
  }
}));

function ContactModernSectionHeader(props) { //props: p_text
  const p_text = props.p_text;

  return(
    <LibraryReact.DivFont p_styleObj={{marginBottom:"0.65em", paddingBottom:"0.45em", color:"#34434d", borderBottom:"1px solid #e8ebee"}} p_fontClass="font12 fontBold">
      {p_text}
    </LibraryReact.DivFont>
  );
}

function contact_analysis_field_hover_text(i_contactName, i_captureName, i_fieldDisplayName, i_valueMaskPlainText) {
  return(i_contactName + "\n" + i_captureName + "\n" + i_fieldDisplayName + ": " + i_valueMaskPlainText);
}

function ContactAnalysisCaptureGraphDate(props) { //props: p_contactName, p_captureName, p_fieldDisplayName, p_date
  const p_contactName = props.p_contactName;
  const p_captureName = props.p_captureName;
  const p_fieldDisplayName = props.p_fieldDisplayName;
  const p_date = props.p_date;
  const hasDateFieldTF = (p_fieldDisplayName !== "");
  const dateDisplayText = ((p_date === "") ? ("—") : (p_date));
  const fieldDisplayNameText = ((hasDateFieldTF) ? (p_fieldDisplayName) : ("—"));
  const dateHoverText = ((hasDateFieldTF) ? (contact_analysis_field_hover_text(p_contactName, p_captureName, p_fieldDisplayName, dateDisplayText)) : (""));

  return(
    <div className="flex00a displayFlexColumn smallFullPad" style={{flexBasis:"7em", minWidth:0, overflow:"hidden"}} title={dateHoverText}>
      <div className="font09 fontItalic fontTextLighter">
        {fieldDisplayNameText}
      </div>
      {(hasDateFieldTF) &&
        <font className="fontBold" style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
          {dateDisplayText}
        </font>
      }
    </div>
  );
}

function ContactControlLabel(props) { //props: p_text
  const p_text = props.p_text;

  return(
    <div style={{margin:"0 0 0.3em 0.15em", color:"#77776c", fontSize:"0.78em", fontWeight:600, letterSpacing:"0.03em", textTransform:"uppercase"}}>
      {p_text}
    </div>
  );
}

function ContactAnalysisGraphSelect(props) { //props: p_label, p_fieldTypeObj, p_valueRaw, f_onChangeOrOnSelect
  const p_label = props.p_label;
  const p_fieldTypeObj = props.p_fieldTypeObj;
  const p_valueRaw = props.p_valueRaw;
  const f_onChangeOrOnSelect = props.f_onChangeOrOnSelect;

  return(
    <div className="flex00a displayFlexRowVc" style={{gap:"0.5em"}}>
      <div className="flex00a" style={{margin:0, color:"#77776c", fontSize:"0.78em", fontWeight:600, letterSpacing:"0.03em", textTransform:"uppercase"}}>
        {p_label}
      </div>
      <div className="flex00a" style={{width:"8em"}}>
        <CEGeneralReact.GenericInputOrSelectFromInputType
          p_fieldTypeObj={p_fieldTypeObj}
          p_valueRaw={p_valueRaw}
          f_onChangeOrOnSelect={f_onChangeOrOnSelect}
        />
      </div>
    </div>
  );
}

function ContactEmptyState(props) { //props: p_iconComponent, children
  const p_iconComponent = props.p_iconComponent;

  return(
    <div className="flex11a displayFlexColumnHcVc textCenter" style={{margin:"1.2em", padding:"2em", color:"#6e7a83", background:"linear-gradient(145deg, #fafbf9, #f3f5f4)", border:"1px dashed #d6ddd9", borderRadius:"0.8em"}}>
      {(p_iconComponent !== undefined) &&
        <div className="displayFlexRowHcVc" style={{width:"4.2em", height:"4.2em", marginBottom:"1em", background:"#e8ece9", borderRadius:"50%"}}>
          {p_iconComponent}
        </div>
      }
      {props.children}
    </div>
  );
}

function ContactNoResults(props) { //props: p_text
  const p_text = props.p_text;

  return(
    <div className="textCenter" style={{margin:"1em", padding:"2em", color:"#74756d", background:"#fbfaf7", border:"1px dashed #d6d1c5", borderRadius:"0.7em"}}>
      {p_text}
    </div>
  );
}

function ContactResultCard(props) { //props: children
  return(
    <div className="smallBottomMargin overflowHidden" style={{background:"#fffefa", border:"1px solid #ddd8ce", borderRadius:"0.7em", boxShadow:"0 0.1em 0.35em rgba(70, 62, 45, 0.05)"}}>
      {props.children}
    </div>
  );
}

const SamGovEntitySearchResult = inject("ContactsMobx")(observer(
class SamGovEntitySearchResult extends Component { //props: p_entityObj
  onclick_select_sam_gov_entity = () => {
    this.props.ContactsMobx.a_set_selected_sam_gov_entity_uei(this.props.ContactsMobx.sam_gov_entity_field_value_from_key(this.props.p_entityObj, "uei"));
  }

  render() {
    const p_entityObj = this.props.p_entityObj;
    const o_selectedSamGovEntityUEIOrUndefined = this.props.ContactsMobx.o_selectedSamGovEntityUEIOrUndefined;
    const c_samGovEntityFieldsArrayOfObjs = this.props.ContactsMobx.c_samGovEntityFieldsArrayOfObjs;
    const addressFieldsArrayOfObjs = c_samGovEntityFieldsArrayOfObjs.filter((i_fieldObj) => i_fieldObj.displayLeftTF && (i_fieldObj.resultGroup === "address") && JSFUNC.text_or_number_is_filled_out_tf(p_entityObj[i_fieldObj.dbName]));
    const addressPiecesArray = addressFieldsArrayOfObjs.map((i_fieldObj) => p_entityObj[i_fieldObj.dbName]);
    const selectedTF = (o_selectedSamGovEntityUEIOrUndefined === this.props.ContactsMobx.sam_gov_entity_field_value_from_key(p_entityObj, "uei"));

    return(
      <LibraryReact.InteractiveDiv
        p_class="displayFlexColumn smallBottomMargin medFullPad cursorPointer border1ddd borderRadius05"
        p_styleObj={{background:(selectedTF ? "#eaf2f2" : "#fff"), borderColor:(selectedTF ? "#77979a" : "#d6dce0"), boxShadow:(selectedTF ? "inset 0.2em 0 #5d8588" : "0 0.1em 0.3em rgba(35, 45, 55, 0.06)")}}
        f_onClick={this.onclick_select_sam_gov_entity}>
        {c_samGovEntityFieldsArrayOfObjs.filter((i_fieldObj) => i_fieldObj.displayLeftTF && (i_fieldObj.resultGroup === "uei")).map((m_fieldObj) =>
          <div key={m_fieldObj.dbName} className="font09 fontItalic fontTextLighter">
            {m_fieldObj.displayName + ": " + JSFUNC.prop_value(p_entityObj[m_fieldObj.dbName], "")}
          </div>
        )}
        {c_samGovEntityFieldsArrayOfObjs.filter((i_fieldObj) => i_fieldObj.displayLeftTF && (i_fieldObj.resultGroup === "name")).map((m_fieldObj) =>
          <div key={m_fieldObj.dbName} className="font12 fontBold">
            {p_entityObj[m_fieldObj.dbName]}
          </div>
        )}
        {(addressPiecesArray.length > 0) &&
          <div className="smallTopMargin fontItalic fontTextLight">
            {addressPiecesArray.join(", ")}
          </div>
        }
      </LibraryReact.InteractiveDiv>
    );
  }
}));

function ContactPageButtonGlyph(props) { //props: p_text
  const p_text = props.p_text;

  return(
    <span style={{color:"#4f514a", fontFamily:"Arial, sans-serif", fontSize:"1.3em", fontWeight:700, lineHeight:1}}>
      {p_text}
    </span>
  );
}

function ContactCompanyTeammateRatingItem(props) { //props: p_label, p_rating, p_isOverallTF
  const label = props.p_label;
  const rating = props.p_rating;
  const isOverallTF = JSFUNC.prop_value(props.p_isOverallTF, false);

  return(
    <div className="displayFlexRowVc tbMicroPad hoverLighterBlueGradient">
      {(!isOverallTF) &&
        <div className="flex00a" style={{flexBasis:"1em"}} />
      }
      <div className="flex11a lrPad" title={label}>
        <font className={((isOverallTF) ? ("font13") : ("fontItalic"))}>
          {label}
        </font>
      </div>
      <div className="flex00a lrMedPad">
        <font className={((isOverallTF) ? ("font13 fontBold fontBlue") : ("fontItalic"))}>
          <CEGeneralReact.RatingNA1To5OutOf5Display p_rating1to5NAm1={rating} />
        </font>
      </div>
    </div>
  );
}

const ContactAnalysisTimeGraph = inject("ContactsMobx", "DatabaseMobx")(observer(
class ContactAnalysisTimeGraph extends Component { //props: p_isTeammateAnalysisTF, p_timeGraphObj
  onswitch_y_log_scale = () => {
    const o_contactAnalysisYLogScaleTF = this.props.ContactsMobx.o_contactAnalysisYLogScaleTF;
    this.props.ContactsMobx.a_set_contact_analysis_y_log_scale_tf(!o_contactAnalysisYLogScaleTF);
  }

  onselect_time_graph_type = (i_graphType) => {
    this.props.ContactsMobx.a_set_contact_analysis_graph_type(i_graphType);
  }

  onselect_time_bins = (i_timeBins) => {
    this.props.ContactsMobx.a_set_contact_analysis_time_bins(i_timeBins);
  }

  onselect_teammate_graph_value_type = (i_valueType) => {
    this.props.ContactsMobx.a_set_contact_analysis_teammate_graph_value_type(i_valueType);
  }

  render() {
    const o_contactAnalysisYLogScaleTF = this.props.ContactsMobx.o_contactAnalysisYLogScaleTF;
    const o_contactAnalysisGraphType = this.props.ContactsMobx.o_contactAnalysisGraphType;
    const o_contactAnalysisTimeBins = this.props.ContactsMobx.o_contactAnalysisTimeBins;
    const o_contactAnalysisTeammateGraphValueType = this.props.ContactsMobx.o_contactAnalysisTeammateGraphValueType;
    const showTeammateGraphValueSelectTF = (this.props.p_isTeammateAnalysisTF === true);
    const p_timeGraphObj = this.props.p_timeGraphObj;
    const c_graphTypeSelectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Graph Type", ["line", "bar"], true, ["Line", "Bar"]);
    const c_graphTypeFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", c_graphTypeSelectWithSearchDataObj);
    const c_teammateGraphValueSelectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Value", ["allocatedRevenueValue", "contractOverallValue"], true, ["Allocated Revenue Value", "Contract Overall Value"]);
    const c_teammateGraphValueFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", c_teammateGraphValueSelectWithSearchDataObj);
    const c_timeSelectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Time", ["yearly", "quarterly", "monthly"], true, ["Yearly", "Quarterly", "Monthly"]);
    const c_timeFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", c_timeSelectWithSearchDataObj);

    return(
      <>
        <div className="displayFlexRowVc flexWrap" style={{marginBottom:"0.45em", gap:"0.8em"}}>
          <div className="flex00a smallRightMargin">
            <CEGeneralReact.SwitchWithTextAndConfirmBox
              p_isOnTF={o_contactAnalysisYLogScaleTF}
              p_onText="Logarithmic"
              p_offText="Linear"
              p_labelText="Y-Axis"
              p_labelWidthEm={5}
              f_onSwitch={this.onswitch_y_log_scale}
            />
          </div>
          <ContactAnalysisGraphSelect
            p_label="Graph Type"
            p_fieldTypeObj={c_graphTypeFieldTypeObj}
            p_valueRaw={o_contactAnalysisGraphType}
            f_onChangeOrOnSelect={this.onselect_time_graph_type}
          />
          {(showTeammateGraphValueSelectTF) &&
            <ContactAnalysisGraphSelect
              p_label="Value"
              p_fieldTypeObj={c_teammateGraphValueFieldTypeObj}
              p_valueRaw={o_contactAnalysisTeammateGraphValueType}
              f_onChangeOrOnSelect={this.onselect_teammate_graph_value_type}
            />
          }
          <ContactAnalysisGraphSelect
            p_label="Time"
            p_fieldTypeObj={c_timeFieldTypeObj}
            p_valueRaw={o_contactAnalysisTimeBins}
            f_onChangeOrOnSelect={this.onselect_time_bins}
          />
        </div>
        <LibraryReact.TimeGraph
          p_categoriesArrayOfObjs={p_timeGraphObj.categoriesArrayOfObjs}
          p_timeGraphType={o_contactAnalysisGraphType}
          p_startDate={p_timeGraphObj.startDate}
          p_endDate={p_timeGraphObj.endDate}
          p_timeBins={o_contactAnalysisTimeBins}
          p_yLogScaleTF={o_contactAnalysisYLogScaleTF}
          p_valueFormat="moneyShort"
          p_heightPx={260}
          p_estimatedWidthPx={600}
          p_yAxisWidthEm={5}
          p_legendTF={true}
          p_legendWidthEm={7}
          p_legendHideZeroCategoriesTF={false}
          f_onClickSegment={undefined}
        />
      </>
    );
  }
}));

const ContactCompanyTeammateAnalysisCapture = inject("ContactsMobx", "OpenCaptureMobx", "UserMobx", "DatabaseMobx")(observer(
class ContactCompanyTeammateAnalysisCapture extends Component { //props: p_teammatesRatingsCaptureObj
  constructor(props) {
    super(props);
    this.state = {
      s_editingRatingsTF: false
    };
  }

  onclick_edit_ratings = () => {
    this.setState({s_editingRatingsTF:true});
  }

  onclick_close_ratings = () => {
    this.setState({s_editingRatingsTF:false});
  }

  onsave_ratings = () => {
    this.props.ContactsMobx.a_load_open_contact_teammate_ratings(true);
  }

  onclick_open_capture = () => {
    const p_teammatesRatingsCaptureObj = this.props.p_teammatesRatingsCaptureObj;
    const k_cardIDTeammates = this.props.DatabaseMobx.k_cardIDTeammates;

    const functionOnSuccess = () => {
      this.props.OpenCaptureMobx.a_launch_card_full(k_cardIDTeammates);
    }
    this.props.OpenCaptureMobx.a_open_single_capture(p_teammatesRatingsCaptureObj.captureID, functionOnSuccess);
  }

  render() {
    const s_editingRatingsTF = this.state.s_editingRatingsTF;

    const p_teammatesRatingsCaptureObj = this.props.p_teammatesRatingsCaptureObj;

    const c_teammatesRatingsQuestionsArrayOfObjs = this.props.DatabaseMobx.c_teammatesRatingsQuestionsArrayOfObjs;
    const c_userCanEditCaptureCardContentTF = this.props.UserMobx.c_userCanEditCaptureCardContentTF;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfOurPrimeSubTeammateAllocation = this.props.DatabaseMobx.c_fieldMapOfOurPrimeSubTeammateAllocation;
    const showEditRatingsTF = c_userCanEditCaptureCardContentTF && (c_teammatesRatingsQuestionsArrayOfObjs.length > 0);

    const teammatesRatingsQuestionnaireSubmissionRowObjOrUndefined = p_teammatesRatingsCaptureObj.teammatesRatingsQuestionnaireSubmissionRowObjOrUndefined;
    const teammateContactName = p_teammatesRatingsCaptureObj.teammateObj.teammateNamePlainText;
    const captureName = p_teammatesRatingsCaptureObj.captureNamePlainText;
    const captureStageColor = p_teammatesRatingsCaptureObj.captureStageColor;
    const captureStageColorCss = ((captureStageColor.charAt(0) === "#") ? (captureStageColor) : ("#" + captureStageColor));
    const ratingStatusText = ((p_teammatesRatingsCaptureObj.reviewedTF) ? ("Ratings filled out") : ("Ratings not filled out"));
    const ratingStatusClass = ((p_teammatesRatingsCaptureObj.reviewedTF) ? ("fontDarkGreen") : ("fontRed"));
    const showAllocatedRevenueValueTF = (this.props.ContactsMobx.o_contactAnalysisTeammateGraphValueType === "allocatedRevenueValue");
    const teammateGraphValueDisplayName = ((showAllocatedRevenueValueTF) ? ("Allocated Revenue Value") : ("Contract Overall Value"));
    const teammateGraphValueMask = ((showAllocatedRevenueValueTF) ? (p_teammatesRatingsCaptureObj.allocatedRevenueValueMask) : (p_teammatesRatingsCaptureObj.contractOverallValueMask));
    const teammateGraphValueHoverText = contact_analysis_field_hover_text(teammateContactName, captureName, teammateGraphValueDisplayName, teammateGraphValueMask);
    const allocationPercentMask = p_teammatesRatingsCaptureObj.teammateObj.allocationPercentMask;
    const captureNameHoverText = contact_analysis_field_hover_text(teammateContactName, captureName, "Capture Name", captureName);
    const allocationHoverText = contact_analysis_field_hover_text(teammateContactName, captureName, c_fieldMapOfOurPrimeSubTeammateAllocation.get("display_name"), allocationPercentMask);
    const stageHoverText = contact_analysis_field_hover_text(teammateContactName, captureName, c_fieldMapOfStage.get("display_name"), p_teammatesRatingsCaptureObj.captureStageName);
    const ratingStatusHoverText = contact_analysis_field_hover_text(teammateContactName, captureName, "Teammate Rating Status", ratingStatusText);
    const ratingStatusClickHoverText = ratingStatusHoverText + "\nClick to " + ((p_teammatesRatingsCaptureObj.reviewedTF) ? ("edit") : ("add")) + " teammate ratings.";
    const ratingStatusCellContent = (
      <>
        {ratingStatusText}
        {(p_teammatesRatingsCaptureObj.reviewedTF && (teammatesRatingsQuestionnaireSubmissionRowObjOrUndefined !== undefined)) &&
          <div className="font09 fontItalic fontTextLighter">
            {teammatesRatingsQuestionnaireSubmissionRowObjOrUndefined.reviewDate + " by " + teammatesRatingsQuestionnaireSubmissionRowObjOrUndefined.reviewedByUserNameMask}
          </div>
        }
      </>
    );

    return(
      <div className="smallBottomMargin overflowHidden bgWhite border1ddd borderRadius05">
        <div className="displayFlexRowVc smallFullPad" style={{minHeight:"3.2em", gap:"0.7em"}}>
          <div className="flex11a displayFlexRowVc" style={{minWidth:0}}>
            <LibraryReact.InteractiveDiv
              p_class="flex00a displayFlexColumnHcVc smallRightMargin cursorPointer"
              p_title={"Open Teammates card for Capture '" + captureName + "'"}
              f_onClick={this.onclick_open_capture}>
              <CEIconsReact.SvgOpenCapture p_sizeEm={1.4} p_color="885055" />
            </LibraryReact.InteractiveDiv>
            <div className="flex11a" title={captureNameHoverText}>
              <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold">
                {captureName}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
          <div className="flex00a displayFlexColumn smallFullPad" style={{flexBasis:"5em", minWidth:0, overflow:"hidden"}} title={allocationHoverText}>
            <div className="font09 fontItalic fontTextLighter">
              {"Allocation"}
            </div>
            <font className="fontBold" style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
              {allocationPercentMask}
            </font>
          </div>
          <div className="flex00a smallFullPad" style={{flexBasis:"5em", textAlign:"center"}}>
            {p_teammatesRatingsCaptureObj.teammateObj.isPrimeTF ? ("Prime") : ("Sub")}
          </div>
          <div className="flex00a displayFlexRowVc smallFullPad" style={{flexBasis:"9em", minWidth:0, overflow:"hidden", whiteSpace:"nowrap"}} title={stageHoverText}>
            <div className="flex00a" style={{width:"0.55em", height:"1.1em", marginRight:"0.4em", backgroundColor:captureStageColorCss, border:"1px solid rgba(0, 0, 0, 0.16)", borderRadius:"0.15em"}} />
            <div className="flex11a" style={{minWidth:0}}>
              <LibraryReact.NowrapEllipsis>
                {p_teammatesRatingsCaptureObj.captureStageName}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
          <div className="flex00a displayFlexColumn smallFullPad" style={{flexBasis:"11em", minWidth:0, overflow:"hidden"}} title={teammateGraphValueHoverText}>
            <div className="font09 fontItalic fontTextLighter">
              {teammateGraphValueDisplayName}
            </div>
            <font className="fontBold" style={{overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
              {teammateGraphValueMask}
            </font>
          </div>
          <ContactAnalysisCaptureGraphDate
            p_contactName={teammateContactName}
            p_captureName={captureName}
            p_fieldDisplayName={p_teammatesRatingsCaptureObj.captureGraphDateFieldDisplayName}
            p_date={p_teammatesRatingsCaptureObj.captureGraphDate}
          />
          {(showEditRatingsTF) ? (
            <LibraryReact.InteractiveDiv
              p_class={"flex00a smallFullPad cursorPointer " + ratingStatusClass}
              p_styleObj={{flexBasis:"12em", minWidth:0, overflow:"hidden"}}
              p_title={ratingStatusClickHoverText}
              f_onClick={this.onclick_edit_ratings}>
              {ratingStatusCellContent}
            </LibraryReact.InteractiveDiv>
          ) : (
            <div className={"flex00a smallFullPad " + ratingStatusClass} style={{flexBasis:"12em", minWidth:0, overflow:"hidden"}} title={ratingStatusHoverText}>
              {ratingStatusCellContent}
            </div>
          )}
        </div>
        {(s_editingRatingsTF) &&
          <TeammateRatingsReact.TeammateRatingsQuestionnaireEditor
            p_captureID={p_teammatesRatingsCaptureObj.captureID}
            p_teammateObj={p_teammatesRatingsCaptureObj.teammateObj}
            p_teammatesRatingsQuestionnaireSubmissionRowObj={teammatesRatingsQuestionnaireSubmissionRowObjOrUndefined}
            p_inlineTF={true}
            f_onClose={this.onclick_close_ratings}
            f_onSave={this.onsave_ratings}
          />
        }
      </div>
    );
  }
}));

const ContactCompanyCompetitorAnalysisCapture = inject("ContactsMobx", "OpenCaptureMobx", "DatabaseMobx")(observer(
class ContactCompanyCompetitorAnalysisCapture extends Component { //props: p_competitorAnalysisCaptureObj
  onclick_open_capture = () => {
    const p_competitorAnalysisCaptureObj = this.props.p_competitorAnalysisCaptureObj;
    const k_cardIDCompetitors = this.props.DatabaseMobx.k_cardIDCompetitors;

    const functionOnSuccess = () => {
      this.props.OpenCaptureMobx.a_launch_card_full(k_cardIDCompetitors);
    }
    this.props.OpenCaptureMobx.a_open_single_capture(p_competitorAnalysisCaptureObj.captureID, functionOnSuccess);
  }

  render() {
    const p_competitorAnalysisCaptureObj = this.props.p_competitorAnalysisCaptureObj;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const competitorObj = p_competitorAnalysisCaptureObj.competitorObj;
    const c_fieldMapOfStage = this.props.DatabaseMobx.c_fieldMapOfStage;
    const c_fieldMapOfContractOverallValue = this.props.DatabaseMobx.c_fieldMapOfContractOverallValue;
    const c_fieldMapOfIncumbentCompanies = this.props.DatabaseMobx.c_fieldMapOfIncumbentCompanies;
    const captureStageColor = p_competitorAnalysisCaptureObj.captureStageColor;
    const captureStageColorCss = ((captureStageColor.charAt(0) === "#") ? (captureStageColor) : ("#" + captureStageColor));
    const incumbentIconColor = ((p_competitorAnalysisCaptureObj.incumbentTF) ? ("#287a42") : ("#858585"));
    const incumbentIconText = ((p_competitorAnalysisCaptureObj.incumbentTF) ? ("\u2713") : ("\u2717"));
    const contactName = ((c_openContactObj === undefined) ? ("Contact") : (c_openContactObj.abbrOrLegalName));
    const captureName = p_competitorAnalysisCaptureObj.captureNamePlainText;
    const captureNameHoverText = contact_analysis_field_hover_text(contactName, captureName, "Capture Name", captureName);
    const stageHoverText = contact_analysis_field_hover_text(contactName, captureName, c_fieldMapOfStage.get("display_name"), p_competitorAnalysisCaptureObj.captureStageName);
    const contractOverallValueHoverText = contact_analysis_field_hover_text(contactName, captureName, c_fieldMapOfContractOverallValue.get("display_name"), p_competitorAnalysisCaptureObj.contractOverallValueMask);
    const incumbentHoverText = contact_analysis_field_hover_text(contactName, captureName, c_fieldMapOfIncumbentCompanies.get("display_name"), ((p_competitorAnalysisCaptureObj.incumbentTF) ? ("Yes") : ("No")));
    const swotItemsArrayOfObjs = [
      {label:"Strengths", value:competitorObj.strengths},
      {label:"Weaknesses", value:competitorObj.weaknesses},
      {label:"Opportunities", value:competitorObj.opportunities},
      {label:"Threats", value:competitorObj.threats}
    ];

    return(
      <div className="smallBottomMargin overflowHidden bgWhite border1ddd borderRadius05">
        <div className="smallFullPad" style={{display:"grid", gridTemplateColumns:"minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.4fr) minmax(0, 1fr)", alignItems:"center", minHeight:"3.2em", gap:"0.7em"}}>
          <div className="displayFlexRowVc" style={{minWidth:0}}>
            <LibraryReact.InteractiveDiv
              p_class="flex00a displayFlexColumnHcVc smallRightMargin cursorPointer"
              p_title={"Open Competitors card for Capture '" + captureName + "'"}
              f_onClick={this.onclick_open_capture}>
              <CEIconsReact.SvgOpenCapture p_sizeEm={1.4} p_color="885055" />
            </LibraryReact.InteractiveDiv>
            <div className="flex11a" style={{minWidth:0}} title={captureNameHoverText}>
              <LibraryReact.NowrapEllipsis p_fontClass="font12 fontBold">
                {captureName}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
          <div className="smallFullPad" style={{display:"flex", alignItems:"center", minWidth:0, whiteSpace:"nowrap"}} title={stageHoverText}>
            <div className="flex00a" style={{width:"0.55em", height:"1.1em", marginRight:"0.4em", backgroundColor:captureStageColorCss, border:"1px solid rgba(0, 0, 0, 0.16)", borderRadius:"0.15em"}} />
            <div className="flex11a" style={{minWidth:0, overflow:"hidden", textOverflow:"ellipsis"}}>
              <LibraryReact.NowrapEllipsis>
                {p_competitorAnalysisCaptureObj.captureStageName}
              </LibraryReact.NowrapEllipsis>
            </div>
          </div>
          <div className="displayFlexColumn smallFullPad" style={{minWidth:0}} title={contractOverallValueHoverText}>
            <div className="font09 fontItalic fontTextLighter">
              {"Contract Overall Value"}
            </div>
            <font className="fontBold">
              {p_competitorAnalysisCaptureObj.contractOverallValueMask}
            </font>
          </div>
          <ContactAnalysisCaptureGraphDate
            p_contactName={contactName}
            p_captureName={captureName}
            p_fieldDisplayName={p_competitorAnalysisCaptureObj.captureGraphDateFieldDisplayName}
            p_date={p_competitorAnalysisCaptureObj.captureGraphDate}
          />
          <div className="smallFullPad" style={{display:"flex", alignItems:"center", minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}} title={incumbentHoverText}>
            <span className="displayFlexColumnHcVc" style={{width:"1.5em", height:"1.5em", marginRight:"0.35em", color:"#fff", backgroundColor:incumbentIconColor, borderRadius:"50%", fontWeight:700}}>
              {incumbentIconText}
            </span>
            {p_competitorAnalysisCaptureObj.incumbentTF ? ("Incumbent") : ("Not incumbent")}
          </div>
        </div>
        <div className="smallFullPad" style={{display:"grid", gridTemplateColumns:"repeat(4, minmax(0, 1fr))", gap:"0.5em"}}>
          {swotItemsArrayOfObjs.map((m_swotItemObj) =>
            <div key={m_swotItemObj.label} className="medFullPad border1ddd borderRadius05" style={{minWidth:0, background:"#fbfaf7"}} title={contact_analysis_field_hover_text(contactName, captureName, m_swotItemObj.label, JSFUNC.text_or_number_is_filled_out_tf(m_swotItemObj.value) ? (m_swotItemObj.value) : ("—"))}>
              <div className="smallBottomMargin">
                <font className="fontBold fontTextLight">
                  {m_swotItemObj.label}
                </font>
              </div>
              <font className="fontTextLight" style={{whiteSpace:"pre-wrap", overflowWrap:"anywhere"}}>
                {JSFUNC.text_or_number_is_filled_out_tf(m_swotItemObj.value) ? (m_swotItemObj.value) : ("—")}
              </font>
            </div>
          )}
        </div>
      </div>
    );
  }
}));

const ContactPersonConversations = inject("ContactsMobx")(observer(
class ContactPersonConversations extends Component { //props:
  onchange_filter_by_capture_name = (i_newValueString) => {
    this.props.ContactsMobx.a_set_open_contact_person_conversations_filter_by_capture_name_text(i_newValueString);
  }

  onchange_filter_by_date_min = (i_newValueDateYmd) => {
    this.props.ContactsMobx.a_set_open_contact_person_conversations_filter_by_date_min(i_newValueDateYmd);
  }

  onchange_filter_by_date_max = (i_newValueDateYmd) => {
    this.props.ContactsMobx.a_set_open_contact_person_conversations_filter_by_date_max(i_newValueDateYmd);
  }

  onchange_filter_by_notes = (i_newValueString) => {
    this.props.ContactsMobx.a_set_open_contact_person_conversations_filter_by_notes_text(i_newValueString);
  }

  render() {
    const o_openContactPersonConversationsFilterByCaptureNameText = this.props.ContactsMobx.o_openContactPersonConversationsFilterByCaptureNameText;
    const o_openContactPersonConversationsFilterByDateMin = this.props.ContactsMobx.o_openContactPersonConversationsFilterByDateMin;
    const o_openContactPersonConversationsFilterByDateMax = this.props.ContactsMobx.c_openCo_openContactPersonConversationsFilterByDateMaxontactObj;
    const o_openContactPersonConversationsFilterByNotesText = this.props.ContactsMobx.o_openContactPersonConversationsFilterByNotesText;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const c_openContactPersonFilteredExpandedConversationsPerCaptureArrayOfObjs = this.props.ContactsMobx.c_openContactPersonFilteredExpandedConversationsPerCaptureArrayOfObjs;
    const c_openContactPersonNumFilteredConversations = this.props.ContactsMobx.c_openContactPersonNumFilteredConversations;

    if(!c_openContactObj.isPersonTF) {
      return(null);
    }

    const numContactPersonCapturesWithFilteredConversations = c_openContactPersonFilteredExpandedConversationsPerCaptureArrayOfObjs.length;

    return(
      <>
        <div className="smallBottomMargin">
          <font className="font12 fontBold fontTextLight">
            {"Conversations across all Captures"}
          </font>
        </div>
        <div className="displayFlexColumn bgLightesterGray borderT1bbb borderB1bbb">
          <div className="flex00a displayFlexRow flexWrap lrPad">
            <div className="flex00a displayFlexColumn tbMargin lrMargin" style={{width:"17em"}}>
              <div className="flex00a displayFlexColumnHcVc microBottomMargin textCenter">
                <font className="fontBold fontTextLighter">
                  {"Search Capture Names"}
                </font>
              </div>
              <div className="flex00a">
                <LibraryReact.Text
                  p_value={o_openContactPersonConversationsFilterByCaptureNameText}
                  p_styleObj={{width:"100%"}}
                  f_onChange={this.onchange_filter_by_capture_name}
                />
              </div>
            </div>
            <div className="flex00a displayFlexColumn tbMargin lrMargin" style={{width:"25em"}}>
              <div className="flex00a displayFlexColumnHcVc microBottomMargin textCenter">
                <font className="fontBold fontTextLighter">
                  {"Filter by Date"}
                </font>
              </div>
              <div className="flex00a displayFlexRow">
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.7em"}}>
                  <font className="font09 fontItalic fontTextLight">
                    {"min:"}
                  </font>
                </div>
                <div className="flex00a displayFlexColumnHcVc">
                  <LibraryReact.Date
                    p_value={o_openContactPersonConversationsFilterByDateMin}
                    f_onChange={this.onchange_filter_by_date_min}
                  />
                </div>
                <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.7em"}}>
                  <font className="font09 fontItalic fontTextLight">
                    {"max:"}
                  </font>
                </div>
                <div className="flex00a displayFlexColumnHcVc">
                  <LibraryReact.Date
                    p_value={o_openContactPersonConversationsFilterByDateMax}
                    f_onChange={this.onchange_filter_by_date_max}
                  />
                </div>
              </div>
            </div>
            <div className="flex00a displayFlexColumn tbMargin lrMargin" style={{width:"17em"}}>
              <div className="flex00a displayFlexColumnHcVc microBottomMargin textCenter">
                <font className="fontBold fontTextLighter">
                  {"Search Conversations"}
                </font>
              </div>
              <div className="flex00a">
                <LibraryReact.Text
                  p_value={o_openContactPersonConversationsFilterByNotesText}
                  p_styleObj={{width:"100%"}}
                  f_onChange={this.onchange_filter_by_notes}
                />
              </div>
            </div>
          </div>
          <div className="flex00a displayFlexColumnHcVc smallBottomMargin lrMedPad textCenter">
            <font className="fontBold fontTextLighter">
              {c_openContactPersonNumFilteredConversations + " " + JSFUNC.plural(c_openContactPersonNumFilteredConversations, "Converstaion", "Conversations") + " across " + numContactPersonCapturesWithFilteredConversations + " " + JSFUNC.plural(numContactPersonCapturesWithFilteredConversations, "Capture", "Captures")}
            </font>
          </div>
        </div>
        <div className="medTopMargin">
          {c_openContactPersonFilteredExpandedConversationsPerCaptureArrayOfObjs.map((m_openContactPersonExpandedConversationsPerCaptureObj) =>
            <>
              <ContactPersonConversationsPerCaptureItem
                key={m_openContactPersonExpandedConversationsPerCaptureObj.id}
                p_openContactPersonExpandedConversationsPerCaptureObj={m_openContactPersonExpandedConversationsPerCaptureObj}
              />
              <div className="bigBottomMargin" />
            </>
          )}
        </div>
      </>
    );
  }
}));

const ContactPersonConversationsPerCaptureItem = inject("OpenCaptureMobx", "DatabaseMobx")(observer(
class ContactPersonConversationsPerCaptureItem extends Component { //props: p_openContactPersonExpandedConversationsPerCaptureObj
  onclick_contact_conversations_capture_name_open_capture = () => {
    const p_openContactPersonExpandedConversationsPerCaptureObj = this.props.p_openContactPersonExpandedConversationsPerCaptureObj;
    const k_cardIDConversations = this.props.DatabaseMobx.k_cardIDConversations;

    const functionOnSuccess = (i_parseResponse) => {
      this.props.OpenCaptureMobx.a_launch_card_full(k_cardIDConversations);
    }
    this.props.OpenCaptureMobx.a_open_single_capture(p_openContactPersonExpandedConversationsPerCaptureObj.captureID, functionOnSuccess);
  }

  render() {
    const p_openContactPersonExpandedConversationsPerCaptureObj = this.props.p_openContactPersonExpandedConversationsPerCaptureObj;

    const c_cardNameConversations = this.props.DatabaseMobx.c_cardNameConversations;

    const captureNamePlainText = p_openContactPersonExpandedConversationsPerCaptureObj.captureNamePlainText;
    const captureExpandedConversationsArrayOfObjs = p_openContactPersonExpandedConversationsPerCaptureObj.captureExpandedConversationsArrayOfObjs;
    
    return(
      <div className="displayFlexColumn bgRedCapture border bevelBorderColors borderRadius05">
        <div
          className="flex00a displayFlexRowVc lrMedPad cursorPointer"
          style={{flexBasis:"2.2em"}}
          title={"Open the " + c_cardNameConversations + " card for Capture '" + captureNamePlainText + "'"}
          onClick={this.onclick_contact_conversations_capture_name_open_capture}>
          <LibraryReact.NowrapEllipsis p_fontClass="font11 fontAlmostWhite hoverFontUnderline">
            {captureNamePlainText}
          </LibraryReact.NowrapEllipsis>
        </div>
        <div className="flex11a displayFlexRow">
          <div className="flex00a" style={{flexBasis:"2em"}} />
          <div className="flex11a displayFlexColumn bgLightestestGray">
            {captureExpandedConversationsArrayOfObjs.map((m_expandedConversationsObj) =>
              <ContactPersonSingleConversationItem
                key={m_expandedConversationsObj.id}
                p_expandedConversationObj={m_expandedConversationsObj}
              />
            )}
          </div>
          <div className="flex00a" style={{flexBasis:"0.5em"}} />
        </div>
        <div className="flex00a" style={{flexBasis:"0.5em"}} />
      </div>
    );
  }
}));

class ContactPersonSingleConversationItem extends Component { //props: p_expandedConversationObj
  render() {
    const p_expandedConversationObj = this.props.p_expandedConversationObj;

    return(
      <div className="displayFlexRow borderB1ddd" style={{height:"1.8em"}}>
        <div className="flex00a displayFlexRowVc lrMedPad" style={{flexBasis:"7em"}} title={p_expandedConversationObj.dateTimeLocalValueMaskSortIfoObj.valueMaskPlainText}>
          <font className="">
            {p_expandedConversationObj.dateYmdLocalValueMaskSortIfoObj.valueMask}
          </font>
        </div>
        <div className="flex11a displayFlexRowVc lrMedPad" title={p_expandedConversationObj.notes}>
          <LibraryReact.NowrapEllipsis p_fontClass="">
            {p_expandedConversationObj.notes}
          </LibraryReact.NowrapEllipsis>
        </div>
      </div>
    );
  }
}







const NewContactForm = inject("ContactsMobx")(observer(
class NewContactForm extends Component { //props:
  constructor(props) {
    super(props);
    this.state = {
      s_triedFirstSaveTF: false //don't show any errors unless you tried to save and fields that cannot be blank were blank
    };
  }

  onclick_save_new_contact = () => {
    const o_newContactObj = this.props.ContactsMobx.o_newContactObj;

    var newContactFieldsAreValidTF = false;
    if(o_newContactObj.isPersonTF) { //person
      newContactFieldsAreValidTF = (this.new_person_first_name_valid_tf() && this.new_person_last_name_valid_tf() && this.new_person_email_valid_tf());
    }
    else { //company
      newContactFieldsAreValidTF = (this.new_company_legal_name_valid_tf() && this.new_company_business_type_valid_tf());
    }

    if(!newContactFieldsAreValidTF) {
      this.setState({s_triedFirstSaveTF:true});
    }
    else { //successful save with minimum number of required fields filled out
      this.props.ContactsMobx.a_insert_new_contact_from_contacts_system_creation_and_open_on_success();
    }
  }

  onclick_cancel_new_contact = () => {
    this.props.ContactsMobx.a_close_contact();
  }

  new_person_first_name_valid_tf = () => { return(JSFUNC.text_or_number_is_filled_out_tf(this.props.ContactsMobx.o_newContactObj.first_name)); }
  new_person_last_name_valid_tf = () => { return(JSFUNC.text_or_number_is_filled_out_tf(this.props.ContactsMobx.o_newContactObj.last_name)); }
  new_person_email_valid_tf = () => { return((this.props.ContactsMobx.o_newContactObj.email === "") || (JSFUNC.valid_email_address_undefined_or_invalid_email_error_message_string(this.props.ContactsMobx.o_newContactObj.email) === undefined)); }

  new_company_legal_name_valid_tf = () => { return(JSFUNC.text_or_number_is_filled_out_tf(this.props.ContactsMobx.o_newContactObj.legal_name)); }
  new_company_business_type_valid_tf = () => { return(JSFUNC.select_int_is_filled_out_tf(this.props.ContactsMobx.o_newContactObj.business_type_id)); }

  render() {
    const s_triedFirstSaveTF = this.state.s_triedFirstSaveTF;

    const o_newContactObj = this.props.ContactsMobx.o_newContactObj;

    const isPersonTF = o_newContactObj.isPersonTF;
    const personCompanyString = this.props.ContactsMobx.person_or_company_string_from_is_person_and_is_multi_tf(isPersonTF, false);
    const contactFieldsArrayOfObjs = this.props.ContactsMobx.contact_fields_arrayOfObjs(isPersonTF);

    var errorMessageObj = {
      first_name: undefined,
      last_name: undefined,
      email: undefined,
      legal_name: undefined,
      business_type_id: undefined
    };

    if(s_triedFirstSaveTF) {
      if(isPersonTF) { //person field errors
        if(!this.new_person_first_name_valid_tf()) {
          errorMessageObj.first_name = "The First Name must be filled out";
        }

        if(!this.new_person_last_name_valid_tf()) {
          errorMessageObj.last_name = "The Last Name must be filled out";
        }

        if(!this.new_person_email_valid_tf()) {
          errorMessageObj.email = JSFUNC.valid_email_address_undefined_or_invalid_email_error_message_string(o_newContactObj.email);
        }
      }
      else { //company field errors
        if(!this.new_company_legal_name_valid_tf()) {
          errorMessageObj.legal_name = "The new company Legal Name must be filled out";
        }

        if(!this.new_company_business_type_valid_tf()) {
          errorMessageObj.business_type_id = "A Business Type must be selected";
        }
      }
    }

    return(
      <div className="flex11a displayFlexColumn" style={{minHeight:0, overflow:"hidden", background:"#fbfaf7"}}>
        <div className="flex00a" style={{padding:"0.9em 1.1em", background:"linear-gradient(135deg, #fbfaf7, #efede6)", borderBottom:"1px solid #ddd8cd", boxShadow:"0 0.12em 0.4em rgba(35, 45, 55, 0.06)"}}>
          <div className="displayFlexRow flexWrap" style={{gap:"0.75em"}}>
            <div className="flex11a displayFlexRowVc">
              <div className="flex00a smallRightMargin displayFlexRowHcVc" style={{width:"4.2em", height:"4.2em", background:"#e7e3d8", border:"1px solid #d5d0c3", borderRadius:"50%"}}>
                <CompanyOrPersonIcon p_isPersonTF={isPersonTF} p_sizeEm={3} />
              </div>
              <div className="flex11a smallRightMargin">
                <font className="font15 fontItalic" style={{color:"#202b33", fontStyle:"normal", fontWeight:700}}>
                  {"Creating a New Contact " + personCompanyString}
                </font>
              </div>
            </div>
            <div className="flex00a displayFlexRowVc" style={{gap:"0.45em"}}>
              <div className="flex00a smallRightMargin">
                <CEGeneralReact.CEButton
                  p_type="blue"
                  p_text="Save"
                  p_tabIndex={contactFieldsArrayOfObjs.length + 2}
                  f_onClick={this.onclick_save_new_contact}
                />
              </div>
              <div className="flex00a">
                <CEGeneralReact.ButtonWithConfirmBox
                  p_buttonType="gray"
                  p_buttonText="Cancel"
                  p_confirmType="confirm"
                  p_confirmMessage={"Are you sure you want to cancel creating this new Contact " + personCompanyString + "?"}
                  p_tabIndex={contactFieldsArrayOfObjs.length + 3}
                  f_onClickConfirm={this.onclick_cancel_new_contact}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="flex11a yScroll yScrollBottomPad" style={{minHeight:0, padding:"1.1em 1.2em", background:"#fbfaf7"}}>
          <div style={{marginBottom:"0.55em", paddingBottom:"0.45em", color:"#34434d", borderBottom:"1px solid #e2e6e4"}}>
            <font className="font12 fontBold fontTextLight">
              {"Details"}
            </font>
          </div>
          {contactFieldsArrayOfObjs.map((m_contactFieldObj, m_index) =>
            (!JSFUNC.in_array(m_contactFieldObj.db_name, ["contact_company_id", "org_topdiv_id", "tree_id"])) &&
            <NewContactInputField
              p_contactFieldObj={m_contactFieldObj}
              p_tabIndex={m_index + 1}
              p_errorMessageObj={errorMessageObj}
            />
          )}
          <div style={{marginTop:"1.2em", padding:"0.9em 1em", background:"#f3f5f1", border:"1px solid #e0e2d9", borderRadius:"0.6em"}}>
            <EditParentCompanyDivision p_contactObj={o_newContactObj} />
          </div>
        </div>
      </div>
    );
  }
}));


const NewContactInputField = inject("ContactsMobx", "DatabaseMobx")(observer(
class NewContactInputField extends Component { //props: p_isPersonTF, p_contactFieldObj, p_tabIndex, p_errorMessageObj
  onchange_field_value = (i_newValue) => {
    this.props.ContactsMobx.a_update_new_contact_field_local(this.props.p_contactFieldObj.db_name, i_newValue);
  }

  render() {
    const p_contactFieldObj = this.props.p_contactFieldObj; //each p_contactFieldObj (hardcoded and custom fields together) is an expanded field map converted to an obj
    const p_errorMessageObj = this.props.p_errorMessageObj;

    const o_newContactObj = this.props.ContactsMobx.o_newContactObj;

    const fieldDbName = p_contactFieldObj.db_name;
    const fieldDisplayName = p_contactFieldObj.display_name;
    const fieldTypeObj = p_contactFieldObj.fieldTypeObj;

    const value = o_newContactObj[fieldDbName];

    const fieldErrorMessage = p_errorMessageObj[fieldDbName];
    const errorTF = (fieldErrorMessage !== undefined);

    var fieldIsSbCertsAndTypeIsLargeTF = false;
    if(fieldDbName === "sb_certifications_bm_set_aside_ids_comma") {
      const businessTypeMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_business_types", o_newContactObj.business_type_id);
      if(businessTypeMap !== undefined) {
        if(businessTypeMap.get("is_sb_type_01") !== 1) {
          fieldIsSbCertsAndTypeIsLargeTF = true;
        }
      }
    }



    return(
      <div className="displayFlexRowVc lrMargin" style={{gap:"0.75em", margin:0, padding:"0.65em 0.2em", borderBottom:"1px solid #e9ecea"}}>
        <div className="flex00a smallRightMargin" style={{flexBasis:"10em"}}>
          <font className="fontBlue">
            {fieldDisplayName}
          </font>
        </div>
        <div className="flex11a smallTopMargin smallBottomMargin contactsModernNewContactFieldControl">
          {(fieldIsSbCertsAndTypeIsLargeTF) ? (
            <font className="fontItalic fontTextLighter">
              {"N/A for Large Business size"}
            </font>
          ) : (
            <>
              <CEGeneralReact.GenericInputOrSelectFromInputType
                p_fieldTypeObj={fieldTypeObj}
                p_valueRaw={value}
                p_tabIndex={this.props.p_tabIndex}
                p_errorTF={errorTF}
                f_onChangeOrOnSelect={this.onchange_field_value}
              />
              {(errorTF) &&
                <CEGeneralReact.ErrorText
                  p_class="microTopMargin"
                  p_text={fieldErrorMessage}
                />
              }
            </>
          )}
        </div>
      </div>
    );
  }
}));





const SelectContactCheckBox = inject("ContactsMobx")(observer(
class SelectContactCheckBox extends Component { //props: p_selectMode, p_contactIDsAlreadyAddedArray, p_contactObj, p_sizeEm, p_styleObj
  onclick_select_contact = () => {
    this.props.ContactsMobx.a_select_contact(this.props.p_contactObj.id, this.props.p_selectMode);
  }

  render() {
    const p_selectMode = this.props.p_selectMode;
    const p_contactIDsAlreadyAddedArray = this.props.p_contactIDsAlreadyAddedArray;
    const p_contactObj = this.props.p_contactObj;
    const sizeEm = JSFUNC.prop_value(this.props.p_sizeEm, 1.2);
    const styleObj = JSFUNC.prop_value(this.props.p_styleObj, {});

    const [isSelectingPersonsTFU, isMultiSelectTFU] = this.props.ContactsMobx.is_person_and_is_multiselect_tfu_from_select_mode(p_selectMode);
    const isPersonTF = p_contactObj.isPersonTF;
    const contactID = p_contactObj.id;

    if(isPersonTF !== isSelectingPersonsTFU || (p_contactObj.id <= 0)) { //if this contact is not the type being selected, do not draw a checkbox or a blank space for a checkbox
      return(null);
    }

    //determine if the checkbox is checked
    const isAlreadyAddedTF = JSFUNC.in_array(contactID, p_contactIDsAlreadyAddedArray);
    const isSelectedTF = this.props.ContactsMobx.contact_is_selected_tf(contactID);
    var checkedFlag = 0; //unchecked
    if(isAlreadyAddedTF) {
      checkedFlag = 4; //disabled and checked
    }
    else if(isSelectedTF) {
      checkedFlag = 1; //checked
    }

    const personCompanyString = this.props.ContactsMobx.person_or_company_string_from_is_person_and_is_multi_tf(isPersonTF, false);
    var title = undefined;
    if(isAlreadyAddedTF) {
      title = "This Contact " + personCompanyString + " has already been added and is not available for selection";
    }
    else {
      title = "Select this Contact " + personCompanyString;
    }

    return(
      <div className="flex00a" style={styleObj}>
        <LibraryReact.CheckBox
          p_u0_s1_p2_du3_ds4={checkedFlag}
          p_sizeEm={sizeEm}
          p_tabIndex={-1}
          p_title={title}
          f_onClick={this.onclick_select_contact}
        />
      </div>
    );
  }
}));






const AdvancedSearchCapturesAnalysis = inject("ContactsMobx", "DatabaseMobx")(observer(
class AdvancedSearchCapturesAnalysis extends Component { //props: p_selectMode
  constructor(props) {
    super(props);
    this.state = {
      s_clickedDotCaptureIDToHighlight: undefined
    };
  }

  onclick_scatter_dot = (i_captureID) => {
    this.setState((i_state, i_props) => ({
      s_clickedDotCaptureIDToHighlight: ((i_state.s_clickedDotCaptureIDToHighlight === i_captureID) ? (undefined) : (i_captureID)) //clicking the same dot turns off all highlight
    }));
  }

  render() {
    const clickedDotCaptureIDToHighlight = this.state.s_clickedDotCaptureIDToHighlight;

    const p_selectMode = this.props.p_selectMode;

    const advSearchTeamingCategory = this.props.ContactsMobx.o_advSearchTeamingCategory;
    const advSearchCaptureIDsArray = this.props.ContactsMobx.o_advSearchCaptureIDsArray;
    const c_openContactObj = this.props.ContactsMobx.c_openContactObj;
    const c_openContactName = this.props.ContactsMobx.c_openContactName;
    const advSearchAnalysisCapturesArrayOfObjs = this.props.ContactsMobx.c_advSearchAnalysisCapturesArrayOfObjs;
    const advSearchAnalysisScatterDataObj = this.props.ContactsMobx.c_advSearchAnalysisScatterDataObj;

    const fieldMapOfContractOverallValue = this.props.DatabaseMobx.c_fieldMapOfContractOverallValue;
    const fieldMapOfAwardDate = this.props.DatabaseMobx.c_fieldMapOfAwardDate;

    var graphTitle = "'" + c_openContactName + "' ";
    if(advSearchTeamingCategory === "theirAsOurWins") { graphTitle += "where we are the Prime (Won Captures)"; }
    else if(advSearchTeamingCategory === "theirAsOurActive") { graphTitle += "where we are the Prime (Active Captures)"; }
    else if(advSearchTeamingCategory === "theirAsOurLosses") { graphTitle += "where we are the Prime (Lost Captures)"; }
    else if(advSearchTeamingCategory === "usAsTheirWins") { graphTitle += "where we are a Sub (Won Captures)"; }
    else if(advSearchTeamingCategory === "usAsTheirActive") { graphTitle += "where we are a Sub (Active Captures)"; }
    else if(advSearchTeamingCategory === "usAsTheirLosses") { graphTitle += "where we are a Sub (Lost Captures)"; }

    const canOpenCaptureTF = (p_selectMode === "no_select");
    const numCaptures = advSearchAnalysisCapturesArrayOfObjs.length;

    var capturesListTitle = numCaptures + " " + JSFUNC.plural(numCaptures, "Capture", "Captures");

    return(
      <>
        <div className="flex00a tbPad">
          <font className="font14">
            {"Advanced Search Analysis"}
          </font>
        </div>
        <div className="medFullPad bgWhite border1ddd">
          <LibraryReact.ScatterPlot
            p_dataObjOrDataArrayOfObjs={advSearchAnalysisScatterDataObj}
            p_xMin={undefined}
            p_xMax={advSearchAnalysisScatterDataObj.maxXValue * 1.09}
            p_xValueFormat={undefined}
            p_xLabel={"# Months Until " + fieldMapOfAwardDate.get("display_name")}
            p_yMin={undefined}
            p_yMax={undefined}
            p_yValueFormat="moneyShort"
            p_yLabel={fieldMapOfContractOverallValue.get("display_name")}
            p_yLogScaleTF={true}
            p_zSizePercentOfHeight={3}
            p_zMin={undefined}
            p_zMax={undefined}
            p_dataAverageVerticalLinesTF={false}
            p_title={graphTitle}
            p_heightPx={300}
            p_fontSizePx={undefined}
            p_legendTF={false}
            f_onClickDot={this.onclick_scatter_dot}
          />
        </div>
        <div className="flex00a tbPad">
          <font className="font12 fontBold fontItalic fontTextLighter">
            {capturesListTitle}
          </font>
        </div>
        <div className="flex11a yScroll lrPad hugeBottomPad">
          {advSearchAnalysisCapturesArrayOfObjs.map((m_advSearchAnalysisCaptureObj) =>
            <AdvancedSearchAnalysisSingleCaptureRow
              key={"c" + m_advSearchAnalysisCaptureObj.captureID + "cc" + c_openContactObj.id}
              p_advSearchAnalysisCaptureObj={m_advSearchAnalysisCaptureObj}
              p_clickedDotCaptureIDToHighlight={clickedDotCaptureIDToHighlight}
              p_canOpenCaptureTF={canOpenCaptureTF}
            />
          )}
        </div>
      </>
    );
  }
}));

const AdvancedSearchAnalysisSingleCaptureRow = inject("ContactsMobx", "OpenCaptureMobx", "TeammateContractsMobx", "DatabaseMobx")(observer(
class AdvancedSearchAnalysisSingleCaptureRow extends Component { //props: p_advSearchAnalysisCaptureObj, p_clickedDotCaptureIDToHighlight, p_canOpenCaptureTF
  constructor(props) {
    super(props);
    this.state = {
      s_expandedTF: false
    };
  }

  onclick_expand_collapse_adv_search_capture_row = () => {
    this.setState((i_state, i_props) => ({
      s_expandedTF: (!i_state.s_expandedTF)
    }));
  }

  onclick_capture = () => {
    this.props.OpenCaptureMobx.a_open_single_capture(this.props.p_advSearchAnalysisCaptureObj.captureID);
  }

  render() {
    const expandedTF = this.state.s_expandedTF;

    const advSearchAnalysisCaptureObj = this.props.p_advSearchAnalysisCaptureObj;
    const clickedDotCaptureIDToHighlight = this.props.p_clickedDotCaptureIDToHighlight;
    const canOpenCaptureTF = this.props.p_canOpenCaptureTF;

    const c_openContactName = this.props.ContactsMobx.c_openContactName;
    const advSearchExpandedSelectedTeammatesArrayOfObjs = this.props.ContactsMobx.c_advSearchExpandedSelectedTeammatesArrayOfObjs;
    const c_teammatesAllocOfCovFieldDisplayName = this.props.DatabaseMobx.c_teammatesAllocOfCovFieldDisplayName;
    const c_teammatesWorkshareTypeFieldDisplayName = this.props.DatabaseMobx.c_teammatesWorkshareTypeFieldDisplayName;
    const c_teammatesWorkshareNumFtesFieldDisplayName = this.props.DatabaseMobx.c_teammatesWorkshareNumFtesFieldDisplayName;
    const c_teammatesWorkshareNotesFieldDisplayName = this.props.DatabaseMobx.c_teammatesWorkshareNotesFieldDisplayName;

    const isHighlightedTF = (advSearchAnalysisCaptureObj.captureID === clickedDotCaptureIDToHighlight);

    return(
      <div className="displayFlexRow bgWhite border bevelBorderColors">
        <div className={"flex00a " + ((isHighlightedTF) ? ("bgGoldGradient") : ("bgLighterGray"))} style={{flexBasis:"1.5em"}} />
        <div className="flex11a">
          <div className="displayFlexRow">
            <div
              className={"flex11a displayFlexRow tbPad " + ((canOpenCaptureTF) ? ("hoverLighterBlueGradient cursorPointer") : (""))}
              title={((canOpenCaptureTF) ? ("Click to open Capture '" + advSearchAnalysisCaptureObj.captureName + "'") : (undefined))}
              onClick={((canOpenCaptureTF) ? (this.onclick_capture) : (undefined))}>
              <div className="flex11a">
                <div className="displayFlexRow" style={{height:"2.8em"}}>
                  <div className="flex11a displayFlexRowVc lrMedPad" style={{flexBasis:"300em"}}>
                    <LibraryReact.MaxHeightWrap p_maxHeight="2.5em" p_fontClass="font11 fontBold fontBlue">
                      {advSearchAnalysisCaptureObj.captureName}
                    </LibraryReact.MaxHeightWrap>
                  </div>
                  <div className="flex11a displayFlexRowVc lrMedPad" style={{flexBasis:"100em"}}>
                    <LibraryReact.NowrapEllipsis p_fontClass="">
                      {advSearchAnalysisCaptureObj.stageValueMask}
                    </LibraryReact.NowrapEllipsis>
                  </div>
                  <div className="flex00a displayFlexRowVc textRight" style={{flexBasis:"10em"}}>
                    <font className="">
                      {advSearchAnalysisCaptureObj.covValueMask}
                    </font>
                  </div>
                  <div className="flex00a displayFlexRowVc" style={{flexBasis:"8em"}}>
                    <font className="">
                      {advSearchAnalysisCaptureObj.awardDateValueMask}
                    </font>
                  </div>
                </div>
                <div className="displayFlexRowVc" style={{height:"1.3em"}}>
                  <div className="flex11a lrMedPad" style={{flexBasis:"200em"}}>
                    <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontTextLighter">
                      <font className="fontItalic fontTextLight">
                        {((advSearchAnalysisCaptureObj.captureTypeIsPrimeTF) ? (c_openContactName) : (advSearchAnalysisCaptureObj.ourPrimeSubTeammateDivisionValueMaskSortIfoCanEditObj.valueMask))}
                      </font>
                    </LibraryReact.NowrapEllipsis>
                  </div>
                  <div className="flex11a lrMedPad" style={{flexBasis:"100em"}}>
                    <LibraryReact.NowrapEllipsis p_fontClass="">
                      <font className="fontItalic fontTextLighter">
                        {c_teammatesAllocOfCovFieldDisplayName + ": "}
                      </font>
                      {((advSearchAnalysisCaptureObj.captureTypeIsPrimeTF) ? (
                        advSearchAnalysisCaptureObj.expandedTeammateObj.allocationPercentMask + " (" + advSearchAnalysisCaptureObj.expandedTeammateObj.allocationOfCOVMask + ")"
                      ) : (
                        advSearchAnalysisCaptureObj.ourPrimeSubTeammateAllocationValueMaskSortIfoCanEditObj.valueMask + " (" + advSearchAnalysisCaptureObj.ourAllocationMoneyShort + ")"
                      ))}
                    </LibraryReact.NowrapEllipsis>
                  </div>
                </div>
                <div className="displayFlexRowVc" style={{height:"1.3em"}}>
                  <div className="flex11a lrMedPad" style={{flexBasis:"200em"}}>
                    <LibraryReact.NowrapEllipsis p_fontClass="">
                      <font className="fontItalic fontTextLighter">
                        {c_teammatesWorkshareTypeFieldDisplayName + ": "}
                      </font>
                      {((advSearchAnalysisCaptureObj.captureTypeIsPrimeTF) ? (
                        advSearchAnalysisCaptureObj.expandedTeammateObj.workshareTypeMask
                      ) : (
                        advSearchAnalysisCaptureObj.ourDivisionMinus2TeammateObj.workshareTypeMask
                      ))}
                    </LibraryReact.NowrapEllipsis>
                  </div>
                  <div className="flex11a lrMedPad" style={{flexBasis:"100em"}}>
                    <font className="fontItalic fontTextLighter">
                      {c_teammatesWorkshareNumFtesFieldDisplayName + ": "}
                    </font>
                    {((advSearchAnalysisCaptureObj.captureTypeIsPrimeTF) ? (
                      advSearchAnalysisCaptureObj.expandedTeammateObj.workshare_number_of_ftes
                    ) : (
                      advSearchAnalysisCaptureObj.ourDivisionMinus2TeammateObj.workshare_number_of_ftes
                    ))}
                  </div>
                </div>
                <div className="displayFlexRowVc" style={{height:"1.3em"}}>
                  <div className="flex00a lrMedPad" style={{flexBasis:"10em"}}>
                    <font className="fontItalic fontTextLighter">
                      {c_teammatesWorkshareNotesFieldDisplayName + ": "}
                    </font>
                  </div>
                  <div className="flex11a lrMedPad" title={((advSearchAnalysisCaptureObj.captureTypeIsPrimeTF) ? (advSearchAnalysisCaptureObj.expandedTeammateObj.workshare_notes) : (advSearchAnalysisCaptureObj.ourDivisionMinus2TeammateObj.workshare_notes))}>
                    <LibraryReact.NowrapEllipsis p_fontClass="">
                      {((advSearchAnalysisCaptureObj.captureTypeIsPrimeTF) ? (
                        advSearchAnalysisCaptureObj.expandedTeammateObj.workshare_notes
                      ) : (
                        advSearchAnalysisCaptureObj.ourDivisionMinus2TeammateObj.workshare_notes
                      ))}
                    </LibraryReact.NowrapEllipsis>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex00a displayFlexColumnHcVc lrMedPad">
              <CEGeneralReact.ButtonExpandCollapse
                p_isExpandedTF={expandedTF}
                p_sizeEm={2}
                p_title="Expand to view Capture/Teammate details"
                f_onClick={this.onclick_expand_collapse_adv_search_capture_row}
              />
            </div>
          </div>
          {(expandedTF) &&
            <div className="bgLightestGray smallFullMargin smallFullPad border1ddd">
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfCaptureID} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfCaptureType} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfCaptureManagers} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfDivisionOwners} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfContractType} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfPeriodOfPerformance} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfAddedDate} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfAwardDate} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfContractStartDate} />
              <AdvSearchCaptureField p_captureMap={advSearchAnalysisCaptureObj.captureMap} p_expandedCaptureFieldMap={this.props.DatabaseMobx.c_fieldMapOfContractEndDate} />
              <div className="medTopMargin tbPad">
                <font className="font11 fontBold fontItalic fontTextLighter">
                  {"Teammates on this Capture"}
                </font>
              </div>
              <div className="displayFlexRow">
                <div className="flex00a" style={{flexBasis:"1em"}} />
                <div className="flex11a">
                  {advSearchExpandedSelectedTeammatesArrayOfObjs.map((m_expandedTeammateObj) =>
                    ((m_expandedTeammateObj.capture_id === advSearchAnalysisCaptureObj.captureID) && (m_expandedTeammateObj.contact_company_id > 0)) &&
                    <div className="displayFlexRow tbMicroPad hoverLightestBlueGradient">
                      <div className="flex11a lrPad" style={{flexBasis:"200em"}} title={m_expandedTeammateObj.teammateNamePlainText}>
                        <LibraryReact.NowrapEllipsis p_fontClass="">
                          {m_expandedTeammateObj.teammateNamePlainText}
                        </LibraryReact.NowrapEllipsis>
                      </div>
                      <div className="flex00a lrPad" style={{flexBasis:"3em"}}>
                        {m_expandedTeammateObj.businessSizeLabelShort}
                      </div>
                      <div className="flex00a lrPad" style={{flexBasis:"6em"}}>
                        {m_expandedTeammateObj.allocationPercentMask}
                      </div>
                      <div className="flex11a lrPad" style={{flexBasis:"100em"}}>
                        {m_expandedTeammateObj.allocationOfCOVMask}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}));


const AdvSearchCaptureField = inject("DatabaseMobx")(observer(
class AdvSearchCaptureField extends Component { //props: p_captureMap, p_expandedCaptureFieldMap
  render() {
    const captureMap = this.props.p_captureMap;
    const p_expandedCaptureFieldMap = this.props.p_expandedCaptureFieldMap;

    const valueMask = this.props.DatabaseMobx.value_mask_from_capture_map_and_expanded_capture_field_map(captureMap, p_expandedCaptureFieldMap);

    return(
      <div className="displayFlexRowVc tbMicroPad hoverLightestBlueGradient">
        <div className="flex11a lrMedPad" style={{flexBasis:"100em"}}>
          <font className="fontBlue">
            {p_expandedCaptureFieldMap.get("display_name")}
          </font>
        </div>
        <div className="flex11a lrMedPad" style={{flexBasis:"300em"}}>
          <font className="">
            {valueMask}
          </font>
        </div>
      </div>
    );
  }
}));
